export const translation = {
  "Footer_Copyright": "Neufast Limited에 의해 제공",
  "Table_RowsPerPage": "페이지당 행:",
  "MainMenu_Language": "언어",
  "MainMenu_CandidateLogin": "지원자 로그인",
  "MainMenu_RecruiterLogin": "고용주 로그인",
  "Recruiter_Menu_Dashboard": "지원자",
  "Recruiter_Menu_Statistics": "통계",
  "Recruiter_Menu_Settings": "직업 및 평가",
  "Recruiter_Menu_Settings_old": "채용 및 화상 면접",
  "Recruiter_Menu_Review": "면접 리뷰",
  "Recruiter_Menu_Greeting": "안녕하세요, {name}",
  "Recruiter_Menu_Logout": "계정 로그아웃",
  "Recruiter_Menu_AccountSetting": "계정 설정",
  "Recruiter_Menu_LogoutInProgress": "로그아웃 중...",
  "Recruiter_Menu_Greeting_Acting": "안녕하세요, {name} (Acting)",
  "Recruiter_Menu_Interview_Monitor": "면접 모니터",
  "Login_HiEmployer": "고용주님, 안녕하세요",
  "Login_HiCandidate": "지원자님, 안녕하세요",
  "Login_WelcomeBack": "화상 면접 및 평가에 오신 것을 환영합니다",
  "Login_EnterYourDetailsBelow": "아래에 세부 정보를 입력하세요",
  "Login_Email": "이메일",
  "Login_Password": "비밀번호",
  "Login_AccessCode": "비밀번호",
  "Login_ForgotPassword": "비밀번호를 잊으셨나요?",
  "Login_RememberMe": "로그인 정보 저장",
  "Login_Login": "로그인",
  "Login_Terms_Prefix": "'로그인'을 클릭하면 다음 내용에 동의하는 것으로 간주됩니다.",
  "Login_Terms_Suffix": ".",
  "Login_Terms_Conditions": "개인 정보 보호 정책 및 이용 약관",
  "Login_Terms_Conditions_Close": "닫기",
  "Login_Terms_Conditions_Content": ["<h2>Neufast 서비스 약관</h2>",
    "<h3>1. 이용 약관</h3>",
    "<p> <a href='http://www.neufast.com'>http://www.neufast.com</a>웹사이트에 접속함으로써, 귀하는 본 서비스 약관, 모든 관련 법률 및 규정을 준수하는 데 동의하며 관련 현지 법률을 준수할 책임이 있음에 동의합니다. 이 약관에 동의하지 않는 경우 이 사이트의 사용 또는 접속이 금지됩니다. 본 웹사이트에 포함된 자료는 관련 저작권 및 상표법에 의해 보호됩니다.</p>",
    "<h3>2. 사용 라이센스</h3>",
    "<ol type='a'>",
    "<li>개인적이고 비상업적인 목적으로만 Neufast의 웹사이트에서 자료(정보 또는 소프트웨어)의 사본을 일시적으로 다운로드할 수 있는 권한이 부여됩니다. 이것은 소유권 이전이 아닌 라이센스의 부여이며 이 라이센스에 따라 다음을 할 수 없습니다:",
    "<ol type='i'>",
    "<li>자료를 수정하거나 복사하는 행위;</li>",
    "<li>자료를 상업적 목적 또는 공개(상업적 또는 비상업적) 목적으로 사용하는 행위;</li>",
    "<li>Neufast 웹사이트에 포함된 소프트웨어를 역편집 또는 역설계하는 행위;</li>",
    "<li>자료에서 저작권 또는 기타 소유권 표기 삭제; 또는</li>",
    "<li>타인에게 자료 전송 또는 다른 서버의 자료 '미러링'.</li>",
    "</ol>",
    "</li>",
    "<li>본 라이센스는 귀하가 이러한 제한 사항을 위반하는 경우 자동으로 종료되며 언제든지 Neufast에 의해 종료될 수 있습니다. 이러한 자료의 열람을 종료하거나 본 라이센스를 종료할 경우 전자 또는 인쇄 형식으로 다운로드한 모든 자료를 파기해야 합니다.</li>",
    "</ol>",
    "<h3>3. 면책 조항</h3>",
    "<ol type='a'>",
    "<li>Neufast 웹사이트에 게재된 자료는 '있는 그대로' 제공됩니다. Neufast는 명시적 또는 묵시적 보증을 하지 않으며 상품성, 특정 목적에 대한 적합성 또는 지적 재산권의 비침해 또는 기타 권리 위반에 대한 묵시적 보증 또는 조건을 포함하되 이에 국한되지 않는 다른 모든 보증을 부인합니다.</li>",
    "<li>또한, Neufast는 웹사이트의 자료 사용의 정확성, 가능성 있는 결과 또는 신뢰성에 대해서나 그러한 자료 또는 본 사이트에 링크된 모든 사이트에 대해 보증하거나 진술하지 않습니다.</li>",
    "</ol>",
    "<h3>4. 제한 사항</h3>",
    "<p>어떠한 ​경우에도 Neufast 또는 그 공급자는 Neufast 또는 Neufast 공인 대리인이 구두 또는 서면으로 손해의 가능성에 대해 통지를 받은 경우에도 Neufast 웹사이트에 있는 자료를 사용 또는 사용 불능으로 인해 발생하는 모든 손해(데이터 손실, 이익 손실 또는 업무 중단으로 인한 손해를 포함하되 이에 국한되지 않음)에 대해 책임을 지지 않습니다. 일부 관할권에서는 묵시적 보증 또는 결과적 또는 부수적 손해에 대한 책임 제한을 허용하지 않으므로 이러한 제한은 귀하에게 적용되지 않을 수 있습니다.</p>",
    "<h3>5. 자료의 정확성</h3>",
    "<p>Neufast 웹사이트에 게재된 자료에는 기술적 오류, 오타 또는 사진 오류가 포함될 수 있습니다. Neufast는 웹사이트의 자료가 정확하거나 완벽하거나 최신이라고 보증하지 않습니다. Neufast는 언제든지 예고 없이 웹사이트에 포함된 자료를 변경할 수 있습니다. 그러나 Neufast는 자료 업데이트에 대한 어떠한 약속도 하지 않습니다.</p>",
    "<h3>6. 링크</h3>",
    "<p>Neufast는 웹사이트에 링크된 모든 사이트를 검토하지 않았으며 링크된 사이트의 내용에 대해 책임을 지지 않습니다. 링크가 포함되었다고 해서 Neufast가 본 사이트를 보증한다는 의미는 아닙니다.  링크된 웹사이트의 사용은 사용자의 책임입니다.</p>",
    "<h3>7. 변경사항</h3>",
    "<p>Neufast는 언제든지 예고 없이 웹사이트의 본 서비스 약관을 변경할 수 있습니다. 이 웹사이트를 이용함으로써 귀하는 본 서비스 약관의 최신 버전을 준수하는 데 동의하게 됩니다.</p>",
    "<h3>8. 준거법</h3>",
    "<p>본 이용약관은 홍콩 법률에 따라 규율되고 해석되며 귀하는 해당 주 또는 지역의 법원의 배타적 관할권에 따라 변경할 수 없습니다.</p>",
    "<h3>9. 일반</h3>",
    "<p>엄격한 개인 정보 보호 정책과 통제를 시행하기 위해 노력했지만 아직 유럽연합의 일반 정보 보호 규정(GDPR)을 완전히 준수하는것으로 감사 및 확인되지 않았습니다. 유럽 시민권자 및 거주자인 사용자는 당사의 서비스를 이용하기 전에 이 사실을 인지하고 이에 동의해야 합니다.</p>",
    "<h3>10. 개인 정보 삭제</h3>",
    "<p><p>​귀하의 이름, 이메일 주소 및 로그인 정보는 귀하의 사용자 계정이 해지된 후 3개월 후에 시스템에서 삭제됩니다. 인터넷 사용 정보, 채용 정보, 면접 질문, 영상, 점수 및 의견과 같은 비개인 정보는 평가 및 서비스 품질을 개선하기 위한 목적으로 시스템에 집계되어 저장됩니다.</p>",
    "<h3>11. 권리 제한 없음</h3>",
    "<p>이 약관의 어떠한 내용도 개인 정보(개인 데이터) 조례(PDPO)에 따라 정보 주체의 권리를 제한하지 않습니다.</p>",

  ],
  "Login_Privacy_Policy": "프리바리 정책 성명서",
  "Login_Privacy_Policy_Close": "닫기",
  "Login_Privacy_Policy_Content": [
    "<h2>개인 정보 보호 정책 선언문</h2>",
    "<p>Neufast Limited (이하 '회사')는 사용자의 개인 데이터를 존중하고 보호하기 위해 최선을 다하고 있으며 개인 데이터 보호 원칙 및 개인 데이터 개인 정보 보호 위원회(PCPD)가 발행한 개인 데이터(개인 정보 보호) 조례('조례')의 모든 관련 조항을 준수하기 위해 최선을 다하고 있습니다. 데이터는 회사의 웹 사이트 서비스 Neufast.com ( '사이트')에 의해 수집됩니다. 회사의 PPS는 취급하는 개인 데이터와 관련된 개인 정보 보호 정책 및 관행에 대한 일반적인 진술입니다.</p>",
    "<h3>1. 관행 선언문</h3>",
    "<ol 유형 = 'a'>",
    "<li>다음 개인 데이터가 수집됩니다.",
    "<ol 유형 = 'i'>",
    "<li>사용자의 이름, 이메일, 전화번호 및 이력서를 포함하는 인사 기록.</li>",
    "<li>텍스트, 오디오 및 비디오 형식의 비디오 및 답변을 포함하여 사용자의 성과를 포함하는 평가 기록</li>",
    "<li>IP 주소, 장치 유형, 브라우저, OS, 국가, 운영 기록 및 로그를 포함한 작동 매개변수.</li>",
    "</ol>",
    "</li>",
    "<li>사이트를 사용하는 과정에서 사용자는 개인 정보 및/또는 데이터를 공개하거나 제공하도록 요청할 수 있습니다. 사이트에서 제공하는 다양한 서비스의 혜택을 누리고 즐기기 위해 사용자는 회사에 개인 정보 및 / 또는 데이터를 제공해야 할 수 있습니다. 사용자는 사이트에서 요청한 정보 및/또는 데이터를 제공할 의무가 없지만 사용자가 제공하지 않을 경우 회사는 사이트에서 특정 서비스를 제공할 수 없습니다.</li>",
    "<li>사용자는 사용자가 회사에 제공 한 모든 정보가 자발적이며 정확하고 사실이며 최신이며 완전하다는 데 동의합니다. 그렇지 않거나 회사가 의심할 만한 합리적인 근거가 있는 경우, 회사는 사용자에 대한 서비스를 취소 및/또는 거부할 권리가 있습니다.</li>",
    "</ol>",
    "<h3>2. 수집목적<h3>",
    "<ol>",
    "<li>",
    "사이트의 정보 및 데이터를 수집하고 사용하는 회사의 목적에는 다음이 포함되지만 이에 국한되지는 않습니다.",
    "<ul>",
    "<li>사용자에게 제공되는 서비스의 일상적인 운영을 위해;</li>",
    "<li>고용주가 광범위한 직업 및 산업에 대한 구인 공석에 대한 후보자의 적합성을 평가할 수 있도록 지원;</li>",
    "<li>사용자가 인터뷰 기술을 향상시킬 수 있도록 돕기 위해</li>",
    "<li>사용자의 문의, 요청 및 불만 사항을 처리하고 후속 조치를 취하기 위해;</li>",
    "<li>사이트 사용과 관련된 관리 통지 및 통신과 관련하여 사용자에게 연락하고 사용자의 문의 또는 요청에 응답하기 위해;</li>",
    "<li>향후 마케팅 및 홍보 목적 또는 기타 내부 목적을 위한 개발을 지원하기 위해;</li>",
    "<li>회사 및/또는 계열사가 회사가 제공하는 서비스 제공과 관련된 목적으로 사용자의 개인 데이터를 사용하도록 용이하게 하기 위해;</li>",
    "<li>내부 사용을 위한 추가 개발을 돕기 위해 사이트 사용을 분석하기 위해 사용자에 대한 통계를 얻습니다. 그리고</li>",
    "<li>명시된 관련 목적을 위해 사이트에서 제공하는 서비스를 개선하는 데 도움이 됩니다.</li>",
    "</ul>",
    "</li>",
    "<li>사용자가 18세 미만인 경우, 회사는 사용자를 사이트 회원으로 등록하기 위한 \"문의\" 섹션에 연락처 세부 정보가 명시된 책임 있는 고객 지원 담당자에게 연락할 수 있는 부모 또는 보호자와 같이 부모에 대한 책임이 있는 사람(예: 부모 또는 보호자)의 사전 동의를 구할 것을 강력히 권장합니다.</li>", 
    "<li>회사는 위에 명시된 목적과 관련하여 필요하고 적절하지만 과도하지 않은 개인 데이터만 수집하기 위해 노력합니다.</li>",
    "<li>회사가 위에 명시된 목적 이외의 목적으로 귀하의 개인 데이터를 사용하도록 요구하는 경우, 당사는 귀하의 규정 된 동의를 요청할 것입니다. 귀하가 미성년자인 경우, 부모 또는 보호자가 규정된 동의를 해야 합니다.</li>",
    "</ol>",
    "<h3>3. 데이터 보호 원칙</h3>",
    "모든 개인 데이터 처리는 다음과 같은 데이터 보호 원칙에 따라 수행됩니다.",
    "<ul>",
    "<li>개인 데이터는 합법적이고 공정하며 투명하게 처리되어야 합니다.</li>",
    "<li>개인 데이터는 구체적이고 명시적이며 합법적인 목적으로만 수집할 수 있습니다.</li>",
    "<li>개인 데이터는 관련성이 있어야 하며 처리에 필요한 것으로 제한되어야 합니다.</li>",
    "<li>개인 데이터는 정확해야 하며 삭제하거나 수정하기 위한 모든 노력과 함께 최신 상태로 유지되어야 합니다.</li>",
    "<li>개인 데이터는 처리에 필요한 경우에만 데이터 주체를 식별할 수 있는 형식으로 보관해야 합니다.</li>",
    "<li>개인 데이터는 적절한 보안을 보장하는 방식으로 처리되어야 합니다.</li>",
    "</ul>",
    "<h3>4. 데이터 인벤토리</h3>",
    "<ol>",
    "<li>",
    "우리는 또한 다음을 포함한 데이터 처리의 다양한 측면을 결정하기 위해 데이터 인벤토리 및 데이터 흐름 프로세스를 유지했습니다.",
    "<ul>",
    "<li>개인 데이터를 사용하는 비즈니스 프로세스.</li>",
    "<li>개인 데이터의 수집 및/또는 사용 목적.</li>",
    "<li>개인 데이터의 출처.</li>",
    "<li>Processing activities.</li>",
    "<li>모든 데이터 전송 및 누구에게.</li>",
    "<li>모든 데이터 액세스, 수정 또는 옵트아웃 요청. 이러한 데이터 인벤토리는 용이하게 할 것입니다.</li>",
    "</ul>",
    "</li>",
    "<li>Neufast Limited는 데이터 및 관련 처리 활동을 추적하고 관련 개인 정보 보호 및 기타 법률 및 규정을 준수할 수 있는 더 나은 위치에 있습니다.</li>",
    "</ol>",
    "<h3>5. 보안</h3>",
    "<p>사용자의 개인 정보 및 데이터 보안은 Neufast Limited에게 중요합니다. 당사는 항상 사용자의 개인 정보 및 데이터가 무단 액세스로부터 보호되도록 노력할 것입니다. 당사는 사용자의 개인 정보 및 데이터를 보호, 보호 및 보안을 위해 적절한 전자 및 관리 조치를 구현했습니다  .</p>",
    "<p>사용자가 제공하는 모든 개인 정보 및 데이터는 회사 또는 승인 된 제 3 자의 승인 된 직원 만 액세스 할 수 있으며, 해당 직원은 이러한 개인 정보 및 데이터에 액세스 할 때 본 개인 정보 보호 정책의 조건을 준수하도록 지시받습니다. 사용자는 자신의 개인 정보와 데이터가 수집 목적을 달성하는 데 필요한 기간 동안 만 보관된다는 것을 확신 할 수 있습니다. 등록 된 사용자는 자신의 고유 한 사용자 이름과 비밀번호를 비밀 및 기밀로 유지하여 보호해야하며 이러한 세부 정보를 누구와도 공유하지 않아야합니다.</p>",
    "<p>회사는 사이트에서 전자 결제 거래를 용이하게 하기 위해 제3자 서비스 제공업체를 사용합니다.</p>",
    "<p>회사는 사용자가 사이트에 제출 한 개인 정보 및 데이터를 전송 중과 수신 한 후에 보호하기 위해 일반적으로 인정되는 업계 표준을 따릅니다. 그러나 인터넷을 통한 전송 방법이나 전자 저장 방법은 100 % 안전하지 않습니다. 따라서 당사는이용자의 개인 정보 및 데이터를 무단 액세스로부터 보호하기 위해 노력하고 있지만 절대적인 보안을 보장 할 수는 없습니다.</p>",
    "<h3>6. 데이터 처리의 법적 근거</h3>",
    "<p>우리는 개인 데이터 처리에 대한 법적 근거가 있는지 확인합니다. 이러한 법적 근거에는 다음이 포함됩니다 : (i) 개인 데이터 처리에있어 Neufast Limited의 합법적 인 비즈니스 이익; (ii) 관련 법률 또는 규정에서 요구하는 경우, 그러한 개인 데이터를 처리하기 위해 귀하의 구체적인 동의를 구합니다. 및/또는 (iii) 관련 법률 및 규정에 따른 기타 관련 근거.</p>",
    "<h4>정당한 이익</h4>",
    "<p>Neufast Limited는 개인 데이터 보호가  필요한 데이터  주체의 이익 또는 기본권 및 자유에 의해 그러한 이익이 기각되는 경우를 제외하고 Neufast Limited가 추구하는 정당한 이익을 위해 개인 데이터 처리가 필요하다는 것을 의미하는 \"합법적 이익\"법적 근거에 따라 개인 데이터를 처리합니다.</p>", 
    "<h4>정당한 이익 평가</h4>",
    "<p>각 관련 상황에서 우리는 다음을 평가합니다 : (i) 이러한 합법적 인 이익이 무엇인지; (ii) 목적을 달성하기 위해 그러한 데이터를 처리해야하는지 여부; (iii) 데이터 주체의 관련 권리; 그러한 목적을 달성하기 위한 당사의 이익과 그러한 권리의 균형을 맞추고, Neufast Limited가 정당한 이익을 기반으로 개인 데이터를 처리할 수 있다고 결론을 내리기 전에 그러한 권리가 Neufast Limited의 정당한 이익보다 우선하지 않도록 합니다.</p>",
    "<h4>데이터 주체와 통신</h4>",
    "<p>모든 데이터 주체는 당사가 자신의 개인 데이터, 관련 개인 데이터의 범주 및 처리 목적을 수집하고 있음을 통보받습니다. 이는 데이터 주체가 당사의 개인 데이터 수집 및 처리에 대해 명확히 하고 그러한 수집 및 처리가 데이터 주체의 합리적인 기대 범위 내에 있는지 확인하기 위한 것입니다  . 모든 데이터 주체는 당사가 소유한 자신의 개인 데이터에 대한 액세스 및/또는 수정을 요청할 수 있는 권리 외에도 언제든지 당사의 개인 데이터 수집 및 처리에 이의를 제기할 수 있습니다.</p>",
    "<h4>데이터 보안 메커니즘</h4>",
    "<p>우리는 또한 데이터 최소화를 포함하되 이에 국한되지 않는 처리의 위험 또는 잠재적 부정적인 영향을 줄임으로써 그러한 개인 데이터와 관련된 데이터 주체의 개인 정보 보호 및 관련 권리를 존중하기 때문에 수집 및 처리하는 개인 데이터의 기밀성과 보안을 보호하기 위해 적절한 메커니즘, 정책 및 절차를 구현했습니다.  식별 해제, 암호화, 제한된 액세스 및 기타 모든 기술적 보안 방법 및 개인 데이터 보호를위한 노력. 데이터 주체의 개인 정보 보호 및 관련 권리에 대한 이러한 보호는 Neufast Limited가 합법적 인 이익 법적 근거에 따라 개인 데이터를 처리 할 수있게합니다. 위의 평가를 철저히 수행 한 Neufast Limited는 다음과 같이 합법적 인 이익하에 개인 데이터를 수집하고 처리하고 있다고 결론지었습니다 : </p>",
    "<ol type='a'>",
    "<li>",
    "<p>고객 및 운영 요구 사항 충족 개인 데이터 범주를 처리하는 주요 목적은 위에 명시되어 있습니다.</p>",
    "<p>Neufast Limited는 이러한 모든 목적이 Neufast Limited가 고객과 기업 및 기술 조직으로서의 운영 요구 사항을 충족하는 데 필수적이기 때문에 Neufast Limited가 동일한 프로세스를 처리하는 데 합법적인 이익이 있습니다.</p>",
    "<p>Neufast Limited와 같은 회사는 직원이 비즈니스 (따라서 인사 기록)를 위해 일하고 서비스 제공 업체가 계속 운영하도록해야합니다 (따라서 기타 운영 기록).</p>",
    "<p>Neufast와 같은 기술 조직은 HR 및 교육 영역의 고객에게 서비스를 제공하기 위해 서비스를 향상시키는 데 필요한 기술을 더욱 향상시키는 기술을 개발해야합니다.</p>",
    "</li>",
    "<li>",
    "<p>Pubic에게 알리십시오</p>",
    "<p>채용 조직으로서  Neufast Limited는 우리 지역 사회와 세계에서 일어나는 일에 대해 대중의 권리를 존중합니다. Neufast Limited는 법률 및 저널리즘 윤리에 따라 그러한 사건을 대중에게 알릴 의무가 있습니다 ( \"알릴 의무\").</p>",
    "<p>이러한 권장 사항은 언제든지 액세스할 수 있는 해당 웹사이트의 다른 모든 기사나 콘텐츠를 보는 것을 금지하거나 제한하지 않습니다.</p>",
    "</li>",
    "<li>",
    "<p>동의</p>",
    "<p>직접 마케팅 수행을 포함하여 개인 데이터를 처리하기 전에 특정 동의를 얻어야 하는 해당 법적 요구 사항이 있는 경우, 당사는 다음과 같이 그러한 특정 동의를 얻을 수 있도록 할 것입니다.</p>",
    "<ol type='a'>",
    "<li>동의는 명확하고 명시적이며 구체적이어야 합니다.</li>",
    "<li>데이터 주체는 당사가 사용하려는 개인 데이터의 유형을 완전히 알고 있습니다. 및 그러한 사용의 목적(예: 데이터 주체에 대한 서비스 개선 또는 직접 마케팅) 그리고</li>",
    "<li>양수인의 이름/신원(당사가 귀하의 데이터를 전송하려는 경우) 및 양수인이 귀하의 개인 데이터를 사용하는 방법.</li>",
    "</ol>",
    "</li>",
    "</ol>",
    "<h3>7. 정보주체의 권리</h3>",
    "<p>Neufast Limited는 데이터 주체가 데이터 처리 및 그에 대해 기록된 데이터에 대해 다음과 같은 권리를 갖는다는 것을 존중합니다:</p>",
    "<ol>",
    "<li>보유 정보의 성격과 공개 대상에 대한 액세스 요청.</li>",
    "<li>손상이나 고통을 초래할 수 있는 가공을 방지하기 위해.</li>",
    "<li>직접 마케팅 목적의 처리를 방지하기 위해.</li>",
    "<li>그들에게 중대한 영향을 미칠 자동화된 의사 결정 프로세스(있는 경우)의 메커니즘에 대한 정보를 얻기 위해.</li>",
    "<li>자동화된 프로세스에 의해서만 취해진 중요한 결정을 내리지 않습니다.</li>",
    "<li>부정확한 데이터를 잊어버리거나 파기할 권리를 포함하여 수정, 차단 및 삭제를 위한 조치를 취합니다.</li>",
    "<li>감독 기관에 요청하려면 (예 : 개인 정보 보호 위원회 또는 데이터 보호 책임자)가 관련 개인 정보 보호 및 기타 법률의 조항을 위반했는지 여부를 평가합니다.</li>",
    "<li>구조화되고 일반적으로 사용되며 기계가 읽을 수 있는 형식으로 개인 데이터를 제공하고 그러한 데이터를 다른 데이터 컨트롤러에게 전송할 수 있는 권리.</li>",
    "<li>발생하는 자동화된 프로파일링에 반대합니다.</li>",
    "</ol>",
    "<h3>8. 개인 데이터 전송</h3>",
    "<p>당사는 당사가 보유한 개인 데이터를 기밀로 유지하며, 이는 위에 명시된 목적을 위해 다음 당사자에게 전송될 수 있습니다.</p>",
    "<ol>",
    "<li>운영을 위해 Neufast Limited에 관리, 기술 또는 기타 서비스를 제공하는 클라우드 서비스 제공 업체, 계약자 또는 제 3 자;</li>",
    "<li>(†관할 법 집행 기관, 규제 기관, 정부 기관, 법원 또는 기타 제3자†공개가 필요하다고 판단되는 경우, (i) 관련 법률 또는 규정의 문제로, (ii) 당사의 법적 권리를 행사, 확립 또는 방어하기 위해, 또는 (iii) 귀하 또는 다른 사람의 중요한 이익을 보호하기 위해;</li>",
    "<li>당사 사업의 일부에 대한 제안된 구매, 재구성, 합병 또는 인수와 관련하여, 구매자에게 본 개인정보 보호정책에 공개된 목적으로만 귀하의 개인 정보를 사용해야 한다고 알리는 경우;</li>",
    "<li>Neufast Limited.</li>의 모든 계열사",
    "</ol>",
    "<p>그러한 전송의 경우 Neufast Limited는 데이터 전송자가 전송된 개인 데이터를 기밀로 유지하고 모든 관련 개인 데이터 개인 정보 보호 법률 및 규정을 준수하도록 계약상 또는 기타 수단을 사용해야 합니다.</p>",
    "<p>위에서 언급한 바와 같이, 귀하가 후보자, 직원 또는 연수생이고 당사가 서비스를 통해 귀하의 개인 정보를 수집하는 경우, 당사는 고객과 체결한 계약에 따라 고객을 대신하여 개인 정보를 수집합니다. 귀하의 개인 정보가 제3자와 공유되는 방법에 대한 자세한 내용은 관련 잠재적 고용주에게 문의하거나 해당 잠재적 고용주의 개인 정보 보호 정책/개인 정보 보호 고지를 참조해야 합니다.</p>",
    "<p>위의 하위 조항 (iv)에 설명 된 상황과 관련하여 - Neufast Limited  계열사 간의 그룹 내 전송이 국경 간 데이터 전송을 포함하는 경우 Neufast Limited는 그러한 개인 데이터의 보안을 보호하기위한 구속력있는 기업 규칙을 채택 할 수 있습니다. 관련된 모든 계열사가 관련 개인 정보 보호 및 기타 법률을 준수하도록 보장합니다.</p>",
    "<h3>9. 개인 데이터의 보유</h3>",
    "<p>Neufast Limited가 사용자의 개인 정보 및/또는 데이터를 획득하면 \"관행 진술\" 섹션에 명시된 대로 데이터 수집 목적을 달성하는 데 필요한 기간 동안 회사 시스템에  안전하게 유지됩니다. . 일단 등록되면 사용자는 데이터 컨트롤러, 즉 사용자가 당사 사이트를 사용하는 고용주/트레이너에게 연락하여 사이트에서 개인 정보를 제거하거나 사이트 회원 자격을 종료할 수 있습니다. 회사는 당사의 법적 의무를 준수하거나, 규제 요건을 충족하거나, 사용자 간의 분쟁을 해결하거나, 사기 및 남용을 방지하거나, 본 개인 정보 보호 정책 및 이용 약관을 시행하기 위해 합리적으로 필요한 경우 사용자가 계정을 폐쇄 한 후에도 사용자의 개인 정보를 보유 할 수 있습니다.</p>",
    "<h3>10. 본 개인정보 보호정책의 변경 사항</h3>",
    "<p>회사는 필요하다고 판단되는 경우 언제든지 본 개인 정보 보호 정책을 업데이트, 개정, 수정 또는 수정할 권리가 있으므로 사용자는 이 개인 정보 보호 정책을 자주 검토할 것을 강력히 권장합니다. 회사가 본 개인 정보 보호 정책을 업데이트, 개정, 수정 또는 수정하기로 결정한 경우, 회사는 해당 변경 사항을 사이트 및 / 또는 회사가 적절하다고 판단하는 기타 장소에 게시하여 회사가 수집하는 정보, 사용 방법 및 회사가 공개하는 상황 (있는 경우)을 사용자가 알 수 있도록합니다.</p>",
    "<p>회사가 본 개인 정보 보호 정책에 중대한 변경 사항을 적용하는 경우 당사는 이 웹페이지, 이메일 또는 사이트 홈페이지의 공지를 통해 사용자에게 통지합니다. 이 개인 정보 보호 정책에 대한 이러한 변경 사항은 회사가 사이트에 동일한 내용을 게시 한 시점부터 적용됩니다. 사용자가 사이트에서 사이트 및 서비스를 계속 사용하는 것은 본 개인 정보 보호 정책의 변경 사항을 수락하는 것으로 간주됩니다.</p>",
    "<h3>11. Cookies 사용</h3>",
    "<p>Cookies는 웹 사이트가 사이트에 있는 동안 기록 보관 목적으로 개인의 하드 드라이브로 전송하는 정보 항목입니다. Cookies는 무엇보다도 귀하의 비밀번호, 구매 및 기본 설정을 저장하여 웹 서핑을 더 쉽게 만듭니다. Cookies 사용은 업계 표준이며 대부분의 주요 웹 사이트에서 Cookies를 찾을 수 있습니다.</p>",
    "<p>Cookies 자체에는 개인 식별 정보가 포함되어 있지 않지만 회사는 사용자의 서비스 사용을 사용자가 이전에 제출한 개인 식별 정보(있는 경우)와 연관시킬 수 있습니다.</p>",
    "<p>대부분의 브라우저는 초기에 Cookies를 허용하도록 설정되어 있습니다. 위의 정보가 공개되는 것을 원하지 않는 경우 Cookies를 거부하도록 설정해야 합니다. 그러나 그렇게 하면 사이트의 대부분의 영역이 제대로 작동하지 않을 수 있습니다.</p>",
    "<h3>12. 아웃소싱 계약</h3>",
    "<p>회사는 IT 시스템을 개발하고 유지 관리하기 위해 사내 자원을 사용하고 있습니다. 회사가 IT 시스템과 관련된 특정 서비스를 제공하기 위해 제 3 자 공급 업체를 고용하는 경우 공급 업체는 일반적인 상황에서 IT 시스템에 저장된 개인 데이터에 액세스 할 수 없습니다.</p>",
    "<p>해당 벤더가 그러한 액세스 권한을 갖는 예외적인 경우, 회사는 합리적인 조치를 취하여 다음을 보장합니다: (i) 해당 벤더는 계약상 그러한 개인 데이터를 기밀로 유지하고 무단 액세스, 사용, 손실, 보유, 수정, 전송 또는 기타를 방지하기 위한 적절한 수단을 채택할 의무가 있습니다.</p>",
    "<h3>13. 문의, 동의 철회, 데이터 액세스 요청 및 데이터 수정</h3>",
    "<p>모든 개인은 당사가 보유한 자신의 개인 데이터에 대한 데이터 처리, 문의, 액세스 및 수정을 요청하는 것에 대한 동의를 철회 할 권리가 있습니다. 고용주 또는 트레이너에게 연락하여 데이터에 액세스하고 수정하십시오. </p>",
    "당사가 보유한 귀하의 페르소나 데이터를 문의, 액세스 또는 수정하려면 다음 주소로 요청을 보내주십시오.",
    "<p>데이터 개인 정보 보호 책임자</p>",
    "<p>Dr. Dennis Lee</p>",
    "<p>Neufast Limited</p>",
    "<p>주소: Unit 2, 3/F, Building 2W, No.2 Science Park Avenue West, Shatin, N.T., Hong Kong</p>",
    "<p>전화: (+852)59876904</p>",
    "<p>이메일: customer-service@neufast.com</p>",
    "<h3>14. 국제 데이터 전송</h3>",
    "<p> 사용자의 개인 정보는 사용자가 거주하는 국가 이외의 국가로 전송되어 처리 될 수 있습니다. 이러한 국가에는 사용자 국가의 법률과 다른 데이터 보호법이 있을 수 있습니다. 특히, 현지 법률에서 달리 요구하지 않는 한, 제공되는 당사 웹사이트, 시스템 및 제3자 서비스는 EEA, 싱가포르 및 홍콩 SAR.</p>",
    "<p>그러나 당사는 사용자의 개인 정보가 본 개인 정보 보호 고지 및 관련 법률에 따라 보호되도록 적절한 보호 조치를 취했습니다. 사용자가 EEA 또는 영국 출신인 경우 여기에는 당사 그룹 회사 간 및 제3자 서비스 제공업체 및 파트너와의 개인 정보 전송에 대한 유럽 위원회의 표준 계약 조항 구현이 포함됩니다. 표준 계약 조항은 비 EEA 회사가 유럽 경제 지역 데이터 보호법에 따라 처리하는 EEA 및 영국 개인 정보를 보호하도록 요구합니다.</p>",
    "<h3>15. 개인 데이터 제거</h3>",
    "<p>고용주 또는 트레이너는 시스템의 개인 데이터를 제어하는 데이터 컨트롤러 역할을 합니다. 이름, 이메일, 전화 번호, 이력서, 이미지, 원본 비디오, 오디오와 같은 개인 데이터는 고용주 또는 트레이너가 플랫폼에서 제거 할 수 있습니다. 귀하가 귀하의 데이터를 제공 한 사용자 인 경우, 귀하가 당사 플랫폼을 사용하는 회사에 연락하여 귀하의 개인 정보를 제거하십시오. 또한 사용자의 개인 정보는 사용자 계정이 폐쇄 된 후 3 개월 후에 당사 시스템에서 삭제됩니다. 직무 정보, 면접 질문, 편집된 비디오, 점수 및 답변과 같은 비개인 정보는 평가 및 서비스 품질 개선을 위한 목적으로만 집계 및 저장됩니다. 편집된 비디오 및 기타 정보는 고용주/트레이너가 customer-service@neufast.com.</p로 이메일을 보내 통지할 때 당사의 계약에 따라 제거할 수도 있습니다>"
  ],
  "And" : "그리고",
  "Forget_Password_Title": "비밀번호 찾기",
  "Forget_Password_Subtitle": "이메일 주소를 입력하시면 비밀번호 초기화를 위한 이메일을 보내드립니다.",
  "Forget_Password_Success_Message": '비밀번호 초기화 이메일이 {email}로 전송되었습니다. 계정의 비밀번호를 초기화하려면 이메일에 있는 링크를 확인하고 클릭하세요.',
  "Forget_Password_Email_Not_Found_Message": '이메일을 찾을 수 없습니다. 이메일을 정확히 입력하세요.',
  "Reset_Password_Title": "비밀번호 초기화",
  "Reset_Password_Sutitle": "계정을 보호하기 위해 비밀번호를 확인하세요: ",
  "Reset_Password_Sutitle_List": [
    '7자보다 깁니다.',
    '사용자 이름이 일치하지 않거나 사용자 이름을 크게 포함하지 않습니다. 예를 들어, "username123"을 사용하지 마십시오',
  ],
  "Reset_Password_Success_Message": "비밀번호 초기화가 성공적으로 완료되었습니다.",
  "Reset_Password_Failed_Message_Token_expired": "비밀번호 초기화에 실패했습니다.",
  "Reset_Password_Failed_Message": "비밀번호 초기화에 실패했습니다.",
  "Reset_Password_Back_Button": "홈으로 돌아가기",
  "InterviewLanguage_en": "영어",
  "InterviewLanguage_tc": "광둥어",
  "InterviewLanguage_sc": "중국어",
  "InterviewLanguage_th": "태국어",
  "InterviewLanguage_ja": "일본어",
  "InterviewLanguage_id": "인도네시아어",
  "InterviewLanguage_ms": "말레이시아어",
  "InterviewLanguage_vi": "베트남어",
  "InterviewLanguage_km": "크메르어",
  "InterviewLanguage_kr": "한국어",
  "InterviewLanguage_bu": "버마어",
  "InterviewLanguage_ta": "필리핀어",
  "InterviewLanguage_hi": "힌디어",
  "InterviewLanguage_de": "독일 사람",
  "InterviewLanguage_fr": "프랑스 국민",

  "LayoutSettings_QuestionSubType_TaskPerformance": "업무 성과",
  "LayoutSettings_QuestionSubType_InterpersonalRelationshipCommunication": "대인 관계 및 커뮤니케이션",
  "LayoutSettings_QuestionSubType_Adaptability": "적응성",

  "Recruiter_Layout_Title": "평가 레이아웃 설정",
  "Recruiter_Layout_Title_old": "화상 면접 레이아웃 설정",
  "Recruiter_Layout_Instruction": "아래 평가에 대한 레이아웃을 설정하고 '{action}'을(를) 누르십시오.",
  "Recruiter_Layout_Instruction_old": "아래 화상 면접에 대한 레이아웃을 설정하고 '{action}'을(를) 누르십시오.",
  "Recruiter_Layout_CompanyName": "회사명",
  "Recruiter_Layout_CompanyMessage": "면접 완료 메시지",
  "Recruiter_Layout_Timezone": "시간대",
  "Recruiter_Layout_CV_Upload_Enable" : "Enable Candidate to upload CV",
  "Recruiter_Layout_CV_Upload_Enable_Message" : "If you enable this function, candidate can upload their cv from their side.",
  "Recruiter_Layout_InterviewLanguage": "평가 레이아웃 언어",
  "Recruiter_Layout_InterviewLanguage_old": "화상 면접 레이아웃 언어",
  "Recruiter_Layout_InterviewStart": "시작",
  "Recruiter_Layout_InterviewStartDate": "날짜",
  "Recruiter_Layout_InterviewStartTime": "시간",
  "Recruiter_Layout_InterviewEnd": "마감일",
  "Recruiter_Layout_InterviewEndDate": "날짜",
  "Recruiter_Layout_InterviewEndTime": "시간",
  "Recruiter_Layout_ShowAvatar": "가상 면접관 표시",
  "Recruiter_Layout_CompanyVideo": "회사 소개 영상",
  "Recruiter_Layout_CompanyVideo_Instruction": "동영상을 여기에 놓거나 클릭하여 파일을 선택하십시오.",
  "Recruiter_Layout_CompanyVideo_Format": "동영상 파일 크기 < 200MB, 파일 형식: AVI, MP4, MOV",
  "Recruiter_Layout_CompanyLogo": "회사 로고",
  "Recruiter_Layout_CompanyWebsite": "회사 웹사이트",
  "Recruiter_Layout_CompanyLogo_Instruction": "사진을 여기에 놓거나 클릭하여 파일을 선택하십시오.",
  "Recruiter_Layout_CompanyLogo_Format": "권장 크기 300px x 300px",
  "Recruiter_Layout_ColorScheme": "색상 구성표",
  "Recruiter_Layout_Question": "질문 설정",
  "Recruiter_Layout_QuestionSet": "질문 세트 {no}",
  "Recruiter_Layout_QuestionType": "질문 유형",
  "Recruiter_Layout_QuestionSubType": "질문 유형",
  "Recruiter_Layout_PleaseSelect": "선택하십시오",
  "Recruiter_Layout_PleaseSelectQuestion": "질문",
  "Recruiter_Layout_Answer": "답변",
  "Recruiter_Layout_QuestionRemove": "삭제",
  "Recruiter_Layout_AddQuestion": "질문 추가",
  "Recruiter_Layout_UploadVideo": "동영상 업로드",
  "Recruiter_Layout_uploading": "업로드 중...",
  "Recruiter_Layout_AddQuestionSet": "질문 세트 추가",
  "Recruiter_Layout_Action_Save": "저장",
  "Recruiter_Layout_Action_Confirm": "확인",
  "Recruiter_Layout_Action_Save_MsgSuccess": "저장 성공",
  "Recruiter_Layout_Action_Save_MsgFailed": "저장 실패",
  "Recruiter_Layout_Goback": "뒤로 가기",
  "Recruiter_Layout_Next": "다음",
  "Recruiter_Layout_Submit": "제출",
  "Recruiter_Layout_QuestionLength": "각 답변에 제공된 시간",
  "Recruiter_Layout_Minutes": "분",
  'Recruiter_Layout_Action_Finish': '완료',
  'Recruiter_Layout_Action_Finish_MsgSuccess': '면접이 생성되었습니다.',
  'Recruiter_Layout_Step': '단계 {step} - ',
  'Recruiter_Layout_No_Preparation_Time': '준비시간 없음',
  'Recruiter_Layout_CompanyName_Tooltip': '면접 및 이메일 전체에 사용되는 회사 이름입니다.',
  'Recruiter_Layout_CompanyWebsite_Tooltip': '면접 인터페이스에 표시되는 회사 웹사이트 주소입니다.',
  "Recruiter_Layout_InterviewLanguage_Tooltip": "지원자 평가 인터페이스에서 사용되는 주요 언어입니다.",
  "Recruiter_Layout_InterviewLanguage_Tooltip_old": "지원자 화상 면접 인터페이스에서 사용되는 기본 언어입니다.",
  "Recruiter_Layout_Timezone_Tooltip": "모집자가 시작 시간 및 마감일에 사용하는 시간대입니다.",
  'Recruiter_Layout_ShowAvatarIdentity': '가상 면접관의 신원 표시',
  'Recruiter_Layout_AvatarIdentity': '가상 면접관의 신원',
  "Recruiter_Layout_FirstName": "이름",
  "Recruiter_Layout_LastName": "성",
  "Recruiter_Layout_JobTitle": "직책",
  'Recruiter_Layout_AvatarIdentity_Tooltip': '지원자에게 보이는 가상 면접관의 ID입니다.',
  "Recruiter_Layout_ShowAvatar_Tooltip": "이 스위치는 질문 중 읽기를 시뮬레이션하는 가상 면접관의 이미지를 켭니다.",
  "Recruiter_Layout_ShowAvatarIdentity_Tooltip": "이 스위치는 지원자가 이 가상 면접관을 소개받을 수 있도록 가상 면접관의 신원을 켭니다.",
  "Recruiter_Layout_CompanyVideo_Tooltip": "이 영상은 지원자의 참여를 위해 면접 시작 부분에 표시됩니다.",
  "Recruiter_Layout_VideoReduction": "회사 영상의 파일 크기를 줄이기 위해 처리되고 있습니다. 설정을 계속하십시오.",
  "Recruiter_Layout_CompanyLogo_Tooltip": "면접 인터페이스에 표시되는 회사 로고입니다.",
  "Recruiter_Layout_ColorScheme_Tooltip": "면접 인터페이스에 사용되는 주 색상입니다.",
  "Recruiter_Layout_PreparationTime": "각 질문에 대한 준비 시간",
  "Recruiter_Layout_Totaltime": "이 테스트의 총 응답 시간입니다.",
  'Recruiter_Layout_PreparationLength_Tooltip': "답변하기 전에 답변을 생각할 수 있는 시간입니다.",
  "Recruiter_Layout_QuestionLength_Tooltip": "각 질문에 답변하기 위해 제공된 시간입니다.",
  "Recruiter_Layout_CompanyMessage_Tooltip": "면접이 끝나면 지원자에게 보내지는 메시지입니다.",
  "Recruiter_Layout_AdvancedSetting": "고급 설정",
  "Recruiter_Layout_ScreenLayout": "면접관/면접자 화면 레이아웃",
  'Recruiter_Layout_Arrangement_Tooltip': "면접관과 면접자 화면의 레이아웃 스타일을 설정합니다.",
  "Recruiter_Layout_TwoScreens": "두 개의 동일한 화면을 나란히 표시",
  "Recruiter_Layout_BigSmallScreen": "하나의 큰 화면과 하나의 작은 화면",
  "Recruiter_Layout_AddQuestionSet_Tooltip": "면접 질문에 임의성을 추가하기 위해 지원자에게 질문 세트 중 하나가 제시됩니다.",
  "Recruiter_Layout_Pronunciation": "발음",
  "Recruiter_Layout_Pronunciation_None": "없음",
  "Recruiter_Layout_Pronunciation_Philipplines": "필리핀",
  "Recruiter_Question_Title": "평가 질문 설정",
  "Recruiter_Test_Setting_Title": "평가 설정",
  "Recruiter_Question_Title_old": "화상 면접 질문 설정",
  "Recruiter_Settings_Test_Settings_Video_Interview": "화상 면접",
  "Recruiter_Settings_Test_Settings_Multiple_Choices": "객관식 질문",
  "Recruiter_Settings_Test_Settings_Short_Questions": "짧은 질문",
  "Recruiter_Settings_Test_Settings_Test_Name": "테스트 이름 (선택 사항)",
  "Recruiter_Settings_Test_Settings_Add_Choice": "선택 항목 추가",
  "Recruiter_Settings_Test_Settings_Choice": "선택 {number}",
  "Recruiter_Settings_Test_Settings_Single_Answer": "단일 답변",
  "Recruiter_Settings_Test_Settings_Multiple_Answers": "객관식 질문 답변",
  "Recruiter_Settings_Test_Settings_Required_Field": "필수 분야",
  "Recruiter_Settings_Test_Settings_Test_Duaration": "테스트 시간",
  "Recruiter_Settings_Test_Settings_Copy": "복사",
  "Recruiter_Settings_Test_Settings_Delete": "삭제",
  "Recruiter_Layout_QuestionLanguage": "언어",
  "Recruiter_Question_Instruction": "평가에 질문을 추가하고 '{action}'을(를) 누르십시오. '질문 세트 추가'를 눌러 추가 질문 세트를 추가하여 질문 세트 중 하나가 무작위로 선택되어 지원자에게 제시될 수 있습니다.",
  "Recruiter_Question_Instruction_old": "화상 면접에 질문을 추가하고 '{action}'을(를) 누르십시오. '질문 세트 추가'를 눌러 추가 질문 세트를 추가하여 질문 세트 중 하나가 무작위로 선택되어 지원자에게 제시될 수 있습니다.",
  "Recruiter_Multiple_Choices_Question_Instruction": "객관식 테스트에 질문을 추가하십시오. 선택 항목 옆의 원을 클릭하여 모범 답안으로 표시할 수 있습니다. 객관식 질문에 대한 모법 답변으로 둘 이상의 답변을 선택할 수 있습니다.",
  "Recruiter_Short_Question_Instruction": "짧은 질문 테스트에 질문을 추가하십시오.",
  "Recruiter_Question_CustomizeVirtualInterviewer": "맞춤형 가상 면접관 (선택 사항, 동영상/사진):",
  "Recruiter_Question_VirtualInterviewer_Tips": "사진/동영상이 업로드되지 않은 경우 기본 가상 면접관이 제공됩니다.",
  "Recruiter_Question_File_Format": "파일 크기 < 20MB, 형식: AVI, MP4, MOV, JPG, PNG",
  "Recruiter_Question_Voice_Tooltip": "면접 중 면접 질문 목소리 켜기/끄기",
  "Recruiter_Question_Contain": "이 질문에는 다음이 포함됩니다:",
  "Recruiter_Email_Title": "지원자에게 이메일 및 SMS",
  "Recruiter_Email_CompanyLogo": "회사 로고",
  "Recruiter_Email_DropFile_Title": "사진을 여기에 놓거나 클릭하여 파일을 선택하십시오.",
  "Recruiter_Email_DropFile_Message": "권장 크기 300px x 300px",
  "Recruiter_Email_EmailDomain": "이메일 도메인",
  "Recruiter_Email_Invitation": "초대",
  "Recruiter_Email_Invitation_Title": "평가 초대",
  "Recruiter_Email_HighScoreContent_Title": "평가 초대",
  "Recruiter_Email_MediumScoreContent_Title": "평가 초대",
  "Recruiter_Email_LowScoreContent_Title": "평가 초대",
  "Recruiter_Email_Invitation_Title_old": "화상 면접 초대",
  "Recruiter_Email_Reminder": "알림",
  "Recruiter_Email_Reminder_Title": "평가 알림",
  "Recruiter_Email_Reminder_Title_old": "화상 면접 알림",
  "Recruiter_Email_Extension": "마감일 변경",
  "Recruiter_Email_Extension_Title": "평가 마감일 변경",
  "Recruiter_Email_Extension_Title_old": "화상 면접 마감일 변경",
  "Recruiter_Email_Confirmation": "확인",
  "Recruiter_Email_Confirmation_Title": "평가 완료",
  "Recruiter_Email_Confirmation_Title_old": "화상 면접 완료",
  "Recruiter_Email_AdvancedSettings": "고급 설정",
  "Recruiter_Email_Section_Title": "제목",
  "Recruiter_Email_Section_Message": "메시지",
  "Recruiter_Email_Section_Add_Attachment_Title": "첨부 파일 추가",
  "Recruiter_Email_Section_Add_Attachment_Message": "첨부할 파일을 여기로 누르거나 드래그하십시오(파일 1개 <20MB만 해당).",
  "Recruiter_Email_Section_AddCompanyLogo": "회사 로고 추가",
  'Recruiter_Email_High_Score_Heading': "높은 총점(7-10점) 지원자 보고서",
  "Recruiter_Email_Medium_Score_Heading": "중간 총점(4-6점) 지원자 보고서",
  "Recruiter_Email_Low_Score_Heading": "낮은 총점(0-3점) 지원자 보고서",
  "Recruiter_Email_Section_AddSMS": "SMS 추가",
  "Recruiter_Email_Section_AddComment": "의견 추가",
  "Recruiter_Email_Save": "저장",
  "Recruiter_Email_Intoduction": "아래 버튼을 클릭하여 필수 이메일 및 SMS 메시지를 열고 '{action}'을(를) 누르십시오.",
  "Recruiter_Email_Invitation_Tips": "초대 이메일은 지원자에게 평가를 수행하도록 요청합니다.",
  "Recruiter_Email_Invitation_Tips_old": "초대 이메일은 지원자에게 평가를 수행하도록 요청합니다.",
  "Recruiter_Email_Reminder_Tips": "알림 이메일은 마감일 24시간 전에 전송됩니다.",
  "Recruiter_Email_Extension_Tips": "평가 마감일이 변경되면 이 이메일이 지원자에게 전송됩니다.",
  "Recruiter_Email_Extension_Tips_old": "화상 면접 마감일이 변경되면 이 이메일이 지원자에게 전송됩니다.",
  "Recruiter_Email_Confirmation_Tips": "지원자가 평가를 완료하면 확인 이메일이 자동으로 전송됩니다.",
  "Recruiter_Email_Redo": "면접 재응시",
  "Recruiter_Email_Redo_Tips": "이 이메일은 지원자에게 화상 면접을 다시 수행하도록 요청합니다.",
  "Recruiter_Email_Report_Tips": "이 이메일은 지원자에게 보고서를 보냅니다.",
  "Recruiter_Email_Redo_Title": "화상 면접 부분 재응시",
  "Recruiter_Email_Report_Title": "화상 면접 개발 보고서",
  "Recruiter_Email_Report_Section_Title": "지원자에게 보고서 보내기",
  "Recruiter_Scoring_Title": "자동 채점 역량 설정",
  "Recruiter_Scoring_ImpressionScore": "노출 기준",
  "Recruiter_Scoring_PerformanceScore": "성과 기준",
  "Recruiter_Scoring_Weighting": "가중치 (%)",
  "Recruiter_Scoring_Total": "총계:",
  "Recruiter_Scoring_Save": "저장",
  "Recruiter_Scoring_MsgNotSumTo100": "저장하기 전에 최대 100%를 추가하십시오.",
  "Recruiter_Scoring_MsgNotSumTo0": "중요, 필수 또는 보너스로 하나 이상의 영역을 선택하십시오.",
  "Recruiter_Scoring_Save_MsgSuccess": "저장 성공",
  "Recruiter_Scoring_Save_MsgFailed": "저장 실패",
  "Recruiter_Scoring_Critical": "중요",
  "Recruiter_Scoring_Required": "필수",
  "Recruiter_Scoring_Bonus": "보너스",
  "Recruiter_Scoring_Irrelevant": "관련 없음",
  "Recruiter_Scoring_Introduction": "이 직무에 중요한 역량의 가중치를 선택하십시오. 면접 점수는 이러한 역량의 가중치에 따라 답변으로 채점됩니다.",
  'Recruiter_Scoring_Impression': '노출 점수',
  'Recruiter_Scoring_TaskPerformance': '업무 성과 점수',

  "Recruiter_Scoring_PotentialWorkPerformance": "잠재적 업무 성과 점수",
  "Recruiter_AIRating_PotentialWorkPerformance": "잠재적 업무 성과 점수",

  'Recruiter_Scoring_ContextualPerformance': '상황별 성과 점수',
  'Recruiter_Scoring_AdaptivePerformance': '적응형 성과 점수',
  "Recruiter_Scoring_Leadership_Definition": "다른 사람들을 이끌고 영향을 주며 자기 자신과 다른 사람들을 성공으로 이끄는 데 있어서 역동적이고 활기찹니다. 다른 사람들이 업무를 수행하도록 동기를 부여하는 데 독단성을 보여줍니다.",
  "Recruiter_Scoring_DevelopingPeople_Definition": "강점 기반 사고 방식을 수용하고 개인이 개인으로서 그리고 직업적으로 성장할 수 있는 잠재력을 가지고 있다고 믿고 피드백과 코칭, 개발 과제 및 경험을 제공하여 그에 따라 지원합니다.",
  "Recruiter_Scoring_GoalAndAchievementStriving_Definition": "목표 달성을 위해 부지런하고 효과적인 실행과 목표 달성을 보장하기 위해 자원과 업무 또는 프로젝트의 진행 상황을 계획하고 관리하는 데 조직적입니다.",
  "Recruiter_Scoring_Responsibility_Definition": "개인적 책임을 지고 책임감을 갖고 일을 실현하는 데 집중하며 직무 요구 사항을 독립적으로 이행할 수 있는 자신의 능력을 활용합니다.",
  "Recruiter_Scoring_ManagingExecution_Definition": "일정 및 목표에 따라 업무 또는 프로젝트의 원활한 실행을 보장하기 위해 지시 및 절차에 따라 자원 업업무 및 활동에 대한 조직적이고 조정된 계획을 만듭니다.",
  "Recruiter_Scoring_AnalyticalAndLogicalThinking_Definition": "문제를 탐색하고 연구하며 정보와 아이디어를 수집 및 종합하고 일반적인 관찰과 특정 사실로부터 결론을 도출하기 위해 비판적으로 분석하고 평가하는 데 호기심이 많습니다.",
  "Recruiter_Scoring_ComplexProblemSolving_Definition": "많은 양의 정보를 조사하고 문제의 본질을 명확히 하는 능력, 행동을 식별하고 대안을 평가하며 목표에 도달하기 위한 다양한 옵션의 결과를 결정하는 유연한 사고 능력을 보여줍니다.",
  "Recruiter_Scoring_Communication_Definition": "자신감있게 의사소통하고 유창하고 명확하며 간결하고 정리되어 설득력 있는 방식으로 아이디어와 정보를 제시합니다.",
  "Recruiter_Scoring_CaringAndEmpathy_Definition": "타인에 대한 배려와 관심을 보이고 다른 사람들의 요구에 이해하하고 적극적인 경청과 공감 표현을 통해 개인적 방식으로 타인과 소통할 수 있습니다.",
  "Recruiter_Scoring_EnglishOralCommunication_Definition": "영어로 유창하고 명확하게 말하고 표현하는 능력을 보여줍니다.",
  "Recruiter_Scoring_CantoneseOralCommunication_Definition": "광둥어로 유창하고 명확하게 말하고 표현하는 능력을 보여줍니다.",
  "Recruiter_Scoring_MandarinOralCommunication_Definition": "북경어로 유창하고 명확하게 말하고 표현하는 능력을 보여줍니다.",
  "Recruiter_Scoring_InterpersonalRelationship_Definition": "팀워크와 협업에서 효율적으로 사람들과 상호 작용하고, 부서 및/또는 조직 내에서 긍정적인 관계를 구축합니다.",
  "Recruiter_Scoring_TeamCollaborationAndInclusion_Definition": "서로 다른 배경, 문화 및 조직에서 다른 사람들과 함께 일할 때 존경심을 보이고 문화적으로 이해심이 있는 태도를 보여 다른 사람들과 쉽게 신뢰를 쌓으며 협동적으로 일합니다.",
  "Recruiter_Scoring_BuildingRelationshipsAndNetwork_Definition": "대인 관계 기술 및 다양한 사람들과 상호 작용하여 긍정적인 관계를 구축하고 부서, 직능 및/또는 조직 내에서 네트워크를 구축하는 능력을 보여줍니다.",
  "Recruiter_Scoring_FlexibilityAndAdaptability_Definition": "새로운 상황에 따라 행동을 조정하고, 모호한 상황 속에서 효율적으로 일할 수 있으며 목표를 달성하기 위해 다른 사람들과의 상호 작용에서 자신의 접근 방식을 유연하게 조정할 수 있습니다.",
  "Recruiter_Scoring_LearningAgility_Definition": "호기심이 많고 성찰적이며 새로운 학습과 경험을 습득하고 지속적인 개선을 위해 문제 해결에 대한 새로운 접근 방식을 시도할 수 있는 성장형 사고 방식과 민첩성을 가지고 있습니다.",
  "Recruiter_Scoring_CreativityAndInnovation_Definition": "창의적이고 새로운 아이디어를 창출하며 문제를 해결하거나 서비스 또는 제품 품질을 향상시키기 위해 새로운 고안/관행을 발전시킵니다.",
  "Recruiter_Scoring_EmotionalIntelligence_Definition": "문제나 어려운 고객/사람에 직면했을 때 침착성과 낙관성을 유지하고 끈질기게 행동하며 인내심과 회복력을 발휘합니다.",
  "Recruiter_Scoring_Enthusiasm_Definition": "일반적으로 사물과 삶에 대한 열정, 낙관주의 및 활기찬 관심을 보여줍니다.",
  "Recruiter_Scoring_Composure_Definition": "압박을 받았을 때 걱정 또는 좌절감을 거의 느끼지 않고 긴장감 없이 차분함을 유지합니다.",
  "Recruiter_Scoring_SelfConfidence_Definition": "상황과 무관하게 문제를 다루고 목표를 달성할 수 있는 자기 확신과 역량을 보여줍니다.",
  "Recruiter_Scoring_VisionAndEntrepreneurialMindset_Definition": "문제를 찾고 비전을 만들어 기업가적 사고방식으로 실행에 옮길 수 있습니다. 비즈니스 기회를 감지하고 미래에 대한 그림을 그린 다음 문제를 해결하기 위한 혁신과 고안을 가져오기 위해 고려된 위험과 함께 체계적이고 지속적으로 추진합니다.",
  "Recruiter_Scoring_TechnologyExpertiseAndBusinessSense_Definition": "인내심이 있고 실패에서 회복할 수 있으며 열정과 훈련으로 집중할 수 있습니다. 성공을 위한 용기와 결단력, 그리고 그 과정에서 직면하는 도전이나 역경에도 불구하고 장기적인 목표를 달성하기 위한 진심어린 관심과 열정과 결합된 절제된 노력이 있습니다.",
  "Recruiter_Scoring_EffectiveCommunicationAndTeambuilding_Definition": "홍콩에서 중국 본토 및 전 세계에 이르기까지 시장 요구를 충족시키기 위해 기술 전문성을 적용할 수 있습니다. 기술에 대한 능력과 지식을 보유하고 최신 기술을 파악하며 주요 비즈니스 문제를 이해하여 시장 요구를 해결하는 데 해당 지식을 적용할 수 있습니다.",
  "Recruiter_Scoring_GritAndPassion_Definition": "아이디어를 제시하고 설명하며 성공적인 팀을 구축하고 참여시킬 수 있습니다. 유창하고 간결하며 설득력 있는 방식으로 의사소통합니다. 개인의 차이를 존중할 뿐만 아니라 공통의 목표를 개발하고 지식, 경험 및 성공을 공유함으로써 더 나은 팀워크를 육성하기 위해 다른 사람들에게 영향력을 행사할 수 있습니다.",

  "Recruiter_Scoring_TaskPerformance_Definition": "일상 업무를 계획, 준비, 관리하고 직무 책임을 이행하는 능력",
  "Recruiter_Scoring_InterpersonalRelationshipCommunication_Definition": "팀워크와 협업에서 효율적으로 사람들과 상호 작용하고, 부서 및/또는 조직 내에서 긍정적인 관계를 구축하는 능력",
  "Recruiter_Scoring_Adaptability_Definition": "새로운 상황에 따라 행동을 조정하고, 모호한 상황 속에서 효율적으로 일할 수 있으며 목표를 달성하기 위해 다른 사람들과의 상호 작용에서 자신의 접근 방식을 유연하게 조정할 수 있습니다.",

  "Recruiter_Evaluation_Title": "검토자 채점 역량 설정",
  "Recruiter_Evaluation_Instruction": "채점에 대한 역량은 아래에서 수정될 수 있습니다. 변경 사항은 이 직무의 모든 지원자에게 적용됩니다. 삭제된 역량의 모든 정보는 손실됩니다.",
  "Recruiter_Evaluation_AddCategory": "+ 여기에 입력하여 카테고리 추가",
  "Recruiter_Evaluation_AddCriterion": "+ 여기에 입력하여 기준 추가",
  "Recruiter_Evaluation_AddCategoryButton": "+ 카테고리 추가",
  "LayoutSettings_QuestionType_General": "일반 HR 및 고용",
  "LayoutSettings_QuestionType_SoftSkills": "역량 소프트 스킬",
  "LayoutSettings_QuestionSubType_Intro": "소개",
  "LayoutSettings_QuestionSubType_Motivation": "동기 부여 및 경력 계획",
  "LayoutSettings_QuestionSubType_Strenth": "강점, 성취 및 약점",
  "LayoutSettings_QuestionSubType_Attitude": "태도, 관심사 및 가치",
  "LayoutSettings_QuestionSubType_Understanding": "역할/회사에 대한 이해",
  "LayoutSettings_QuestionSubType_WorkPlan": "업무 계획",
  "LayoutSettings_QuestionSubType_Salary": "급여",
  "LayoutSettings_QuestionSubType_Others": "기타",
  "LayoutSettings_QuestionSubType_Leadership": "리더십 및 관리",
  "LayoutSettings_QuestionSubType_Teamwork": "팀워크 및 서비스 지향",
  "LayoutSettings_QuestionSubType_Communication": "커뮤니케이션 및 관계 구축",
  "LayoutSettings_QuestionSubType_ProblemAnalysis": "이해 및 문제 분석",
  "LayoutSettings_QuestionSubType_Strategy": "전략 및 혁신",
  "LayoutSettings_QuestionSubType_Process": "프로세스 및 실행 관리",
  "LayoutSettings_QuestionSubType_Change": "변경 및 복원력",
  "LayoutSettings_QuestionSubType_Venturing": "벤처 및 업적 지향",
  "Recruiter_Settings_Title": "직업 및 평가 설정",
  "Recruiter_Settings_Title)old": "채용 및 화상 면접 설정",
  "Recruiter_Settings_BulkAction": "대량 작업",
  "Recruiter_Settings_AddJob": "채용 정보 추가",
  "Recruiter_Settings_Edit": "수정",
  "Recruiter_Settings_Action_Import": "가져오기",
  "Recruiter_Settings_Action_Export": "내보내기",
  "Recruiter_Settings_Action_Remove": "삭제",
  "Recruiter_Settings_JobCount": "{count}개의 채용 정보",
  "Recruiter_Settings_TableColumn_Department": "부서",
  "Recruiter_Settings_TableColumn_JobTitle": "채용 정보",
  "Recruiter_Settings_TableColumn_Created_At": "생성일",
  "Recruiter_Settings_TableColumn_NoOfQuestion": "질문 수",
  "Recruiter_Settings_TableColumn_NoOfCandidates": "지원자 수",
  "Recruiter_Settings_TableColumn_Deadline": "마감일",
  "Recruiter_Settings_TableColumn_CompletionRate": "완료율",
  "Recruiter_Settings_Import_Title": "지원자 정보를 업로드하려면 파일을 선택하십시오.",
  "Recruiter_Settings_Import_FileDropTitle": "파일을 여기에 놓거나 클릭하여 파일을 선택하십시오.",
  "Recruiter_Settings_Import_FileDropFormat": "지원되는 파일 형식: .csv 및 .xls 및 .xlsx",
  "Recruiter_Settings_Import_UploadNote": "* 업로드된 파일에는 지원자의 이름, 이메일(필수 항목), 국가 코드, 전화번호, 대학 및 학위(필수 항목 아님)가 포함되어야 합니다. 정보는 열에 나열됩니다. 예시를 다운로드하십시오:  ",
  "Recruiter_Settings_Import_UploadTemplate": "다운로드",
  "Recruiter_Settings_Export_TopPercentile": "상위 백분위수",
  "Recruiter_Settings_Export_Title": "정보 내보내기",
  "Recruiter_Settings_Export_Description": "다음에서 내보낼 정보를 선택하십시오.",
  "Recruiter_Settings_Export_ItemCount": "{count}개 항목",
  "Recruiter_Settings_Export_TickBox": "체크상자 선택",
  "Recruiter_Settings_Export_Select_All": "모두 선택",
  "Recruiter_Settings_Export_Column_CandidateName": "지원자 이름",
  "Recruiter_Settings_Export_Column_University": "대학",
  "Recruiter_Settings_Export_Column_DegreeTitle": "학위",
  "Recruiter_Settings_Export_Column_TelephoneNumber": "전화번호",
  "Recruiter_Settings_Export_Column_EmailAddress": "이메일",
  "Recruiter_Settings_Export_Column_RecruiterProgram": "채용 담당자 프로그램",
  "Recruiter_Settings_Export_Column_OverallScore": "전체 점수",
  "Recruiter_Settings_Export_Column_ImpressionScore": "노출 점수",
  "Recruiter_Settings_Export_Column_PotentialWorkPerformanceScore": "잠재적 업무 성과 점수",
  "Recruiter_Settings_Export_Column_Personal_Information": "개인 정보",
  "Recruiter_Settings_Export_Column_Interview_Information": "면접 정보",
  "Recruiter_Settings_Export_Column_Interview_Result": "면접 결과",
  "Recruiter_Settings_Export_Column_Programme_Statistics": "프로그램 통계",
  "Recruiter_Settings_Export_Column_Programme_Setting": "프로그램 설정",
  "Recruiter_Settings_Export_Column_Candidate_Answer": "후보자 답변",
  "Recruiter_Settings_Export_help_0": "지원자의 이름, 이메일, 대학, 학위 및 전화번호를 내보냅니다.",
  "Recruiter_Settings_Export_help_1": "각 지원자에 대한 채용 담당자 이메일, 직업 ID, 면접 시작 및 종료 날짜, 평가 상태 및 각 지원자의 암호를 내보냅니다.",
  "Recruiter_Settings_Export_help_2": "선택한 평가에서 지원자의 개별 점수를 내보냅니다.",
  "Recruiter_Settings_Export_help_3": "선택한 평가에서 지원자의 통계를 내보냅니다.",
  "Recruiter_Settings_Export_help_4": "선택된 평가의 설정을 내보냅니다.",
  "Recruiter_Settings_Export_help_5": "선택한 평가에서 응시자의 답변을 내보냅니다.",
  "Recruiter_Settings_Action_Edit_ErrorInterviewInProgress": "면접이 진행 중이며 설정을 변경해서는 안 됩니다.",
  "Recruiter_Settings_Action_Export_ErrorNoCompletedCandidate": "내보내기 실패 !  지원자 결과는 적어도 한 명의 지원자가 면접을 완료한 후에만 내보낼 수 있습니다.",
  "Recruiter_Settings_Action_Export_MsgSuccess": "파일을 성공적으로 내보냈습니다.",
  "Recruiter_Settings_Action_Import_MsgSuccess": "지원자를 성공적으로 가져왔습니다. 그들을 평가에 초대할 수 있습니다.",
  "Recruiter_Settings_Action_Import_MsgSuccess_old": "지원자를 성공적으로 가져왔습니다. 그들을 화상 면접에 초대할 수 있습니다.",
  "Recruiter_Settings_Action_Import_Error": "업로드된 파일은 지원되지 않습니다.",
  "Recruiter_Settings_Action_Import_Error_Column_Not_Match": "Excel/csv 파일의 열 제목이 필요한 형식과 일치하지 않습니다. 예시를 따르십시오.",
  "Recruiter_Settings_Action_Import_Error_Column_duplicate": "여러 지원자의 이메일 주소가 동일합니다. 삭제하고 다시 업로드하십시오.",
  "Recruiter_Settings_Action_Import_Error_Miss_Information": "일부 지원자에 대한 필수 정보가 누락되었습니다.",
  "Recruiter_Settings_Action_Delete_MsgSuccess": "채용 정보가 성공적으로 삭제되었습니다!",
  "Recruiter_Settings_Action_Delete_Error": "채용 정보를 삭제하는 데 실패했습니다.",
  "Recruiter_Setting_Msg_Delete_title": "채용 정보 삭제",
  "Recruiter_Setting_Msg_Delete_content": "이 작업은 선택한 채용 정보를 삭제하며 되돌릴 수 없습니다. 정말 계속하시겠습니까?",
  "Recruiter_Setting_Msg_VideoWithAudio_title": "질문 저장",
  "Recruiter_Setting_Msg_VideoWithAudio_content": "경고! 일부 면접 질문에서는 자동 생성 음성이 켜져 있는 상태에서 가상 면접 영상이 사용됩니다. 이로 인해 면접에서 두 개의 다른 목소리가 나올 수 있습니다. 이 설정을 사용하시겠습니까? ",
  "Recruiter_Settings_Instruction_1": "환영합니다! {user},",
  "Recruiter_Settings_Instruction_2": "이 페이지는 평가 목록을 표시합니다,",
  "Recruiter_Settings_Instruction_3": "시작하려면 오른쪽 상단의 [+ 채용 정보 추가] 버튼을 누르십시오.",
  "Recruiter_Settings_Add_Title": "새로운 채용 정보 추가",
  "Recruiter_Settings_Add_RecentDepartment": "최근 부서에서 선택",
  "Recruiter_Settings_Add_CreateNewDepartment": "새 부서 생성",
  "Recruiter_Settings_Add_JobName": "새 직업 이름",
  "Recruiter_Settings_Add_Copy_title": "다른 직업에서 설정 복사",
  "Recruiter_Settings_Add_Confirm": "확인",
  "Recruiter_Settings_Test": "테스트 {number}",
  "Recruiter_Settings_Test_Video_Interview": "화상 면접",
  "Recruiter_Settings_Test_Multiple_Choices": "객관식 질문",
  "Recruiter_Settings_Test_Short_Question": "짧은 질문",
  "Recruiter_Settings_Test_Test_Name": "테스트 이름",
  "Recruiter_Settings_Test_Add_Test": "테스트 추가",
  "Recruiter_Settings_Special_Character_Error": '특수 문자 ";/?:@=&"는 금지되어 있습니다.',
  "Recruiter_Settings_Duplicate_Department": "부서 이름 중복.",
  "Recruiter_Settings_SideMenu_InterviewLayout": "평가 레이아웃",
  "Recruiter_Settings_SideMenu_InterviewQuestion": "면접 질문",
  "Recruiter_Settings_SideMenu_InterviewEmail": "이메일 및 SMS",
  "Recruiter_Settings_SideMenu_Scoring": "자동 채점 역량",
  "Recruiter_Settings_SideMenu_Evaluation": "검토자 채점 역량",
  "Recruiter_Settings_SideMenu_TestSetting": "평가 설정",
  'Recruiter_Settings_Addjob_disable': '할당량을 초과하여 새 직업을 추가할 수 없습니다. 더 많은 면접 할당량을 얻으려면 관리자에게 문의하십시오.',
  "Recruiter_Stat_Title": "통계",
  "Recruiter_Stat_Filter": "필터",
  "Recruiter_Stat_Filter_OverallScore": "전체 점수",
  "Recruiter_Stat_Filter_ImpressionScore": "노출 점수",
  "Recruiter_Stat_Filter_Potential_Work_Performance": "잠재적 업무 성과",
  "Recruiter_Stat_Filter_Pace": "능변",
  "Recruiter_Stat_Filter_Enthusiasm": "열정",
  "Recruiter_Stat_Filter_SelfConfidence": "자신감",
  "Recruiter_Stat_Filter_Composure": "침착성",
  "Recruiter_Stat_Filter_Leadership": "리더십",
  "Recruiter_Stat_Filter_Learning_Agility": "학습 민첩성",
  "Recruiter_Stat_Filter_Creativity_And_Innovation": "창의성 및 혁신성",
  "Recruiter_Stat_Filter_Emotional_Intelligence": "감정 지능",
  "Recruiter_Stat_Filter_Communication": "커뮤니케이션",
  "Recruiter_Stat_Filter_Interpersonal_Relationship": "대인 관계",
  "Recruiter_Stat_Filter_Goal_And_Achievement_Striving": "목표 및 성취에 대한 노력",
  'Recruiter_Stat_Filter_Impression': '노출 점수',
  'Recruiter_Stat_Filter_TaskPerformance': '업무 성과 점수',
  'Recruiter_Stat_Filter_ContextualPerformance': '상황별 성과 점수',
  'Recruiter_Stat_Filter_AdaptivePerformance': '적응형 성과 점수',

  "Recruiter_Stat_Action_Export": "내보내기",
  "Recruiter_Stat_Section_CompletedCandidates": "완료된 지원자",
  "Recruiter_Stat_Section_NoOfDaysLeft": "남은 일수",
  "Recruiter_Stat_Section_NoOfQuestion": "질문 수",
  "Recruiter_Stat_Section_NoOfCandidate": "지원자 수",
  "Recruiter_Stat_Section_Deadline": "마감일",
  "Recruiter_Stat_Section_Trackers": "추적",
  "Recruiter_Stat_Section_Trackers_Invitation": "초대",
  "Recruiter_Stat_Section_Trackers_Reminder": "알림",
  "Recruiter_Stat_Section_Trackers_Confirmation": "확인",
  "Recruiter_Stat_Section_OverallScore": "전체 점수",
  "Recruiter_Stat_Section_OverallScore_Average": "평균",
  "Recruiter_Stat_Section_OverallScore_StandardDeviation": "표준 편차",
  "Recruiter_Stat_Section_OverallScore_Skewness": "비대칭도",
  "Recruiter_Stat_Section_CandidateVideoScoreDist": "지원자 영상 점수 분포",
  "Recruiter_Stat_Section_NormalizedScore": "정규화된 점수",
  "Recruiter_Stat_Deadline_Expired": "만료됨",
  "Recruiter_JobSelection_Title": "직무를 선택하십시오: ",
  "Recruiter_ProgrammeSelection_Title": "부서를 선택하십시오: ",
  "Recruiter_ProgrammeSelection_Cancel": "취소",
  "Recruiter_ProgrammeSelection_Go_Back": "뒤로 가기",
  "Recruiter_Dashboard_Title": "지원자",
  "Recruiter_Dashboard_CandidateCount": "후보자 {count}명",
  "Recruiter_Dashboard_InterviewDeadline": "면접 마감일:",
  "Recruiter_Dashboard_Search": "검색",
  "Recruiter_Dashboard_FilterByTop": "상단으로 필터",
  "Recruiter_Dashboard_Add_Candiadte": "지원자 추가",
  "Recruiter_Dashboard_BulkInvite": "초대",
  "Recruiter_Dashboard_BulkReport": "지원자에게 보고서 보내기",
  "Recruiter_Dashboard_BulkExport": "내보내기",
  "Recruiter_Dashboard_BulkModify": "마감일 변경",
  "Recruiter_Dashboard_BulkAction": "대량 작업",
  "Recruiter_Dashboard_BulkDelete": "삭제",
  "Recruiter_Dashboard_BulkRedo": "초기화",
  "Recruiter_Dashboard_BulkDownloadPDF":"PDF 보고서 다운로드",
  "Recruiter_Dashboard_Filter_Auto_Score": "자동 채점",
  "Recruiter_Dashboard_Filter_Recruiter_Score": "내 점수",
  "Recruiter_Dashboard_Action_View": "보기",
  "Recruiter_Dashboard_Action_Invite": "초대",
  'Recruiter_Dashboard_Action_Redo': "초기화",
  "Recruiter_Dashboard_TableColumn_Name": "이름",
  "Recruiter_Dashboard_TableColumn_University": "대학",
  "Recruiter_Dashboard_TableColumn_Status": "상태",
  "Recruiter_Dashboard_TableColumn_Status_Pending": "초대 대기 중...",
  "Recruiter_Dashboard_TableColumn_Status_Wait_Invite": "초대 전송됨, 평가 보류 중",
  "Recruiter_Dashboard_TableColumn_Status_Processing": "동영상 처리 중...",
  "Recruiter_Dashboard_TableColumn_Status_Complete": "완료",
  'Recruiter_Dashboard_TableColumn_Status_Partial_Complete': "부분 완료",
  "Recruiter_Dashboard_TableColumn_AutoScoring": "자동 채점",
  "Recruiter_Dashboard_TableColumn_RecruiterScoring": "내 점수",
  "Recruiter_Dashboard_TableColumn_TestScores": "테스트 점수",
  "Recruiter_Dashboard_TableColumn_TotalScore": "총 점수",
  "Recruiter_Dashboard_TableColumn_Video": "동영상",
  "Recruiter_Dashboard_TableColumn_AIReport": "AI 보고서",
  "Recruiter_Dashboard_TableColumn_RecruiterEvaluation": "채용 담당자 평가",
  "Recruiter_Dashboard_TableColumn_Start_Date": "평가 시작",
  "Recruiter_Dashboard_TableColumn_End_Date": "평가 마감일",
  "Recruiter_Dashboard_TableColumn_Action": "행동",
  "Recruiter_Dashboard_TableColumn_Delete": "삭제",
  "Recruiter_Dashboard_TableColumn_Tooltip_Invite": "평가에 초대하기",
  "Recruiter_Dashboard_TableColumn_Tooltip_Report": "보고서 보내기",
  "Recruiter_Dashboard_TableColumn_Tooltip_Report_Sent": "지원자 보고서 전송됨",
  "Recruiter_Dashboard_TableColumn_Tooltip_Redo": "지원자 계정 초기화",
  "Recruiter_Dashboard_TableColumn_Tooltip_Delete": "지원자 삭제",
  "Recruiter_Dashboard_TableColumn_Pending": "보류 중",
  "Recruiter_Dashboard_TableColumn_Tooltip_Shortlist": "명단",
  "Recruiter_Dashboard_TableColumn_Tooltip_Reject": "거부",
  "Recruiter_Dashboard_TableColumn_Tooltip_WaitingList": "대기자 명단에 추가",
  "Recruiter_Dashboard_TableColumn_Tooltip_Edit": "지원자 정보 수정",
  "Recruiter_Dashboard_TableColumn_Tooltip_change_deadline": "마감일 변경",
  "Recruiter_Dashboard_TableColumn_Tooltip_Share": "검토자와 공유",
  "Recruiter_Dashboard_TableColumn_Tooltip_CV_Uploaded": "이력서 업로드됨",
  "Recruiter_Dashboard_TableColumn_Tooltip_Download": "후보자 비디오 다운로드",
  "Recruiter_Dashboard_Dialog_Invitation_Title": "초대",
  "Recruiter_Dashboard_Dialog_Report_Title": "보고서",
  "Recruiter_Dashboard_Dialog_Invitation": "평가를 위해 선택한 지원자에게 초대를 보내시겠습니까?",
  "Recruiter_Dashboard_Dialog_Report": "선택한 지원자에게 지원자 보고서를 보내시겠습니까?",
  "Recruiter_Dashboard_Dialog_Wrong_CV_Filetype": "이력서 업로드에 실패했습니다. 파일 형식을 확인하십시오.",
  "Recruiter_ShareDialog_Title": "이메일로 검토자와 공유",
  "Recruiter_ShareDialog_Subtitle_1": "선택된 지원자",
  "Recruiter_ShareDialog_Caption_1": "공유하기로 선택한 지원자입니다. 이메일 옆에 있는 십자가를 눌러 삭제할 수 있습니다.",
  "Recruiter_ShareDialog_ReviewerInfo": "검토자 정보",
  "Recruiter_ShareDialog_Caption_2": "'추가' 버튼을 눌러 여러 명의 검토자에게 초대 이메일을 보낼 수 있습니다.",
  "Recruiter_ShareDialog_Add": '추가',
  "Recruiter_ShareDialog_Name": "이름",
  "Recruiter_ShareDialog_Email": "이메일",
  "Recruiter_ShareDialog_Message": "메시지",
  "Recruiter_ShareDialog_Caption_3": "이 메시지는 평가 초대 이메일에 첨부됩니다.",
  "Recruiter_ShareDialog_Confirm": "확인",
  "Recruiter_ShareDialog_Cancel": "취소",
  "Recruiter_ShareDialog_Success": "초대 이메일이 성공적으로 전송되었습니다.",
  "Recruiter_ShareDialog_Fail": "초대 이메일 전송애 실패했습니다.",
  "Recruiter_Dashboard_Msg_Invite_Duplicate_title": "이메일 재전송",
  "Recruiter_Dashboard_Msg_Report_Duplicate_title": "보고서 재전송",
  "Recruiter_Dashboard_Msg_Invite_Duplicate_content": "이 지원자에게 이미 초대를 보냈습니다. 다시 보내시겠습니까?",
  "Recruiter_Dashboard_Msg_Report_Duplicate_content": "이 지원자에게 이미 보고서를 보냈습니다. 다시 보내시겠습니까?",
  "Recruiter_Dashboard_InviteDuplicate_No": "아니오",
  "Recruiter_Dashboard_InviteDuplicate_Yes": "예",
  "Recruiter_Dashboard_InviteSuccess": "초대가 성공적으로 전송되었습니다.",
  "Recruiter_Dashboard_InviteFail": "초대를 보낼 수 없습니다. 이 채용 정보의 이메일 설정을 확인하십시오.",
  "Recruiter_Dashboard_ReportSuccess": "보고서가 성공적으로 전송되었습니다.",
  "Recruiter_Dashboard_ReportFail": "보고서를 보낼 수 없습니다. 이 채용 정보의 이메일 설정을 확인하십시오.",
  "Recruiter_Dashboard_DeleteFail": "오류가 있습니다. (삭제)",
  "Recruiter_Dashboard_ExportSuccess": "지원자 정보를 성공적으로 내보냈습니다!",
  "Recruiter_Dashboard_ExportFail": "내보내기 실패 !  선택된 지원자가 평가를 완료하지 않았습니다.",
  "Recruiter_Dashboard_BulkDuplicateInvite": "다음 선택된 지원자가 초대되었습니다. 다시 초대하시겠습니까?",
  "Recruiter_Dashboard_Sending_Invitation": "초대 보내는 중 ...",
  "Recruiter_Dashboard_Sending_Report": "보고서 보내는 중 ...",
  "Recruiter_Dashboard_Msg_Redo_title": "지원자 정보 초기화",
  "Recruiter_Dashboard_Msg_Redo_content": "이 작업은 선택한 지원자의 정보(동영상 및 AI 점수 포함)를 초기화하고 해당 지원자가 온라인 평가를 다시 수행할 수 있도록 합니다. 정말 계속하시겠습니까?",
  "Recruiter_Dashboard_Msg_Delete_title": "지원자 삭제",
  "Recruiter_Dashboard_Msg_Delete_content": "이 작업은 선택한 지원자를 삭제하며 되돌릴 수 없습니다. 정말 계속하시겠습니까?",
  "Recruiter_Dashboard_Import_Dialog_Title": "지원자 추가",
  "Recruiter_Dashboard_Import_Dialog_Form_Label": "양식 순",
  "Recruiter_Dashboard_Import_Dialog_Excel_Label": "엑셀 순",
  "Recruiter_Dashboard_Import_Dialog_Field_Name": "성명",
  "Recruiter_Dashboard_Import_Dialog_Field_Email": "이메일",
  "Recruiter_Dashboard_Import_Dialog_Field_Country_Code": "국가 코드",
  "Recruiter_Dashboard_Import_Dialog_Field_Phone_Number": "전화번호",
  "Recruiter_Dashboard_Import_Dialog_Field_Degree": "학위",
  "Recruiter_Dashboard_Import_Dialog_Field_University": "기관",
  "Recruiter_Dashboard_Import_Dialog_Instruction": "이 지원자에 대한 평가 시작 및 마감일을 선택하십시오",
  "Recruiter_Dashboard_Import_Dialog_Column_Name": "이름",
  "Recruiter_Dashboard_Import_Dialog_Column_Email": "이메일",
  "Recruiter_Dashboard_Import_Dialog_Column_Status": "상태",
  "Recruiter_Dashboard_Import_Duplicate_Dialog_Title": "이메일 중복",
  "Recruiter_Dashboard_Import_Duplicate_Dialog_Content": "이 채용에 이미 포함된 이메일이 있습니다. 새로운 정보로 덮어쓰시겠습니까?",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Title": "가져오기 성공!",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Content": "이메일이 Excel/csv 파일 내에서 반복됩니다. 처음 나타난 행만 가져오고 다른 행은 가져오기가 중단됩니다.",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Repeat_Tag": "반복",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Title": "마감일 변경",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Subtitle": '선택된 지원자에 대한 새로운 마감일을 선택하십시오',
  "Recruiter_Dashboard_Change_Deadline_Dialog_SendEmail": "지원자에게 알림 이메일/SMS 보내기",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Msg": '마감일을 성공적으로 업데이트했습니다.',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_title': '지금 초대를 보내시겠습니까?',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_content': '지원자 중 일부를 아직 초대하지 않으셨습니다. 지금 업데이트된 마감일로 초대를 보내시겠습니까?',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_Button_Yes': '지금 보내기',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_Button_No': "보내지 않음",
  'Recruiter_Dashboard_Modify_Deadline_Msg': '마감일을 성공적으로 업데이트했습니다.',
  "Recruiter_Dashboard_Add_New_Candiadte": "새 지원자 추가",
  "Recruiter_Dashboard_Status_Results": "결과를 보려면 클릭하십시오",
  "Recruiter_Dashboard_Status_Pending": "결과 대기 중",
  'Recruiter_Dashboard_TableColumn_Status_Shortlisted': "최종 후보자로 선정되었습니다.",
  "Recruiter_Dashboard_TableColumn_Status_WaitingListed": "대기자 명단에 있습니다.",
  'Recruiter_Dashboard_TableColumn_Status_Rejected': "탈락",
  "Recruiter_Dashboard_Instruction_1": "이 페이지는 선택한 직무의 지원자를 나열합니다",
  "Recruiter_Dashboard_Instruction_2": "평가에 지원자를 추가하고 평가 날짜를 설정하려면 오른쪽 상단의 [+ 지원자 추가] 버튼을 누르십시오.",
  "Recruiter_Dashboard_Edit_Dialog_Failed": "지원자 정보 업데이트에 실패했습니다. ",
  "Recruiter_Dashboard_Edit_Dialog_Email_Change_Reminder": "지원자의 이메일을 업데이트했습니다. 이전에 지원자를 평가에 초대했다면 지원자를 다시 초대해야 합니다.",
  'Recruiter_Dashboard_Status_Filter_Caption': "필터 기준:",
  'Recruiter_Dashboard_Status_Filter_Title': "상태별 필터",
  'Recruiter_Dashboard_Status_Filter_All': "모두",
  'Recruiter_Dashboard_Addcandidate_disable': '면접 할당량이 0으로 떨어졌으며 지원자 추가 기능이 일시 중지되었습니다. 더 많은 면접 할당량을 얻으려면 관리자에게 문의하십시오.',
  "Recruiter_Dashboard_Redo_Questions_Dialog_Title": "질문 재실행",
  "Recruiter_Dashboard_Redo_Questions_Dialog_Instruction": "재실행해야 하는 질문 번호를 선택하십시오",
  "Recruiter_Dashboard_Redo_Questions_Dialog_SendEmail": "지원자에게 이메일 보내기",
  "Recruiter_Dashboard_TableColumn_Tooltip_RedoQuestions": "질문 재실행",
  "Recruiter_Dashboard_BulkSharing_Tooltip": "지원자가 선택되지 않았거나 일부 선택된 지원자가 평가를 완료하지 않아 검토할 수 없습니다",
  "Recruiter_Evaluation_Norating": "검토자 평가 등급 없음",
  "Recruiter_ReportSideBar_VideoInterview": "화상 면접",
  "Recruiter_ReportSideBar_FullInterview": "전체 면접",
  "Recruiter_ReportSideBar_GeneralHR": "일반 HR",
  "Recruiter_ReportSideBar_Competency": "역량",
  "Recruiter_ReportSideBar_Technical": "기술",
  "Recruiter_ReportSideBar_AutoScoring": "자동 채점",
  "Recruiter_ReportSideBar_OverallScore": "전체 점수",
  "Recruiter_ReportSideBar_AIReport": "AI 보고서",
  "Recruiter_ReportSideBar_RecruiterEvaluation": "채용 담당자 평가",
  "Recruiter_VideoInterview_BackToDashboard": "지원자 목록으로 돌아가기",
  "Recruiter_VideoInterview_Title": "화상 면접",
  "Recruiter_VideoInterview_QuestionSet": "질문 세트 {no}",
  "Recruiter_VideoInterview_Question": "질문 {no}: {question}",
  "Recruiter_VideoInterview_Back": "뒤로",
  "Recruiter_VideoInterview_Next": "다음",
  "Recruiter_VideoInterview_NoQuestion": "이 카테고리에 질문이 없습니다",
  "Recruiter_VideoInterview_NoVideoSubmitted": "지원자가 이 질문을 완료하지 않았습니다.",
  "Recruiter_Multiple_Choices_QuestionSet": "질문 세트 {no}",
  "Recruiter_Short_Question_QuestionSet": "질문 세트 (no}",
  'Recruiter_CandidateResult_Title': "면접 분석",
  'Recruiter_CandidateResult_Multiple_Choices_Title': "객관식 질문 분석",
  'Recruiter_CandidateResult_Short_Questions_Title': '짧은 질문 분석',
  'Recruiter_CandidateResult_AnswerList': "지원자 답변 목록",
  'Recruiter_CandidateResult_Name': "이름:",
  'Recruiter_CandidateResult_Email': "이메일:",
  "Recruiter_Dashboard_Import_Dialog_Field_1st_Preference": "첫 번째 선호도",
  "Recruiter_Dashboard_Import_Dialog_Field_2nd_Preference": "두 번째 선호도",
  'Recruiter_CandidateResult_University': "대학:",
  'Recruiter_CandidateResult_Degree': "학위:",
  'Recruiter_CandidateResult_1st_Preference': "첫 번째 선호도:",
  'Recruiter_CandidateResult_2nd_Preference': "두 번째 선호도:",
  'Recruiter_CandidateResult_NextCandidate': "다음 지원자",
  'Recruiter_CandidateResult_LastCandidate': "마지막 지원자",
  'Recruiter_CandidateResult_FacialExpression': '얼굴 표정 어노테이션',
  'Recruiter_CandidateResult_MyComment': "내 의견:",
  'Recruiter_CandidateResult_MyScoring': "내 점수",
  'Recruiter_CandidateResult_Transcribe': '기록',
  'Recruiter_CandidateResult_AutoScoring': "자동 채점",
  'Recruiter_CandidateResult_ReviewerScoring': "검토자 점수",
  'Recruiter_CandidateResult_Resume': "이력서",
  'Recruiter_CandidateResult_Report': "PDF 보고서 다운로드",
  "Recruiter_CandidateResult_Save": "저장",
  'Recruiter_CandidateResult_Indicator': '감정 지표',
  'Recruiter_CandidateResult_Emotion': '감정 비율',
  'Recruiter_CandidateResult_Time': '시간',
  'Recruiter_CandidateResult_PositiveEmotions': '긍정적 감정',
  'Recruiter_CandidateResult_NeutralEmotions': '중립적 감정',
  'Recruiter_CandidateResult_NegativeEmotions': '부정적 감정',
  'Recruiter_CandidateResult_Translation_title': '이 지원자의 답변은 아래에 기록됩니다:',
  'Recruiter_CandidateResult_Tooltip_City': '도시',
  'Recruiter_CandidateResult_Tooltip_Country': '위치',
  'Recruiter_CandidateResult_Tooltip_IP': 'IP 주소',
  'Recruiter_CandidateResult_Tooltip_Complete': '완료 날짜 및 시간',
  'Recruiter_CandidateResult_Tooltip_Download_Resume': '이력서 다운로드',



  'Recruiter_CandidateResult_Total_Score': '총 점수: {score}',
  'Recruiter_CandidateResult_Correct': '{logo} 정답',
  'Recruiter_CandidateResult_Wrong': '{logo} 오답',
  'Recruiter_CandidateResult_Model_Answer': '모델 답변:',
  'Recruiter_CandidateResult_Candidate_Answer': '지원자 답변:',
  'Recruiter_CandidateResult_Action': '행동',
  'Recruiter_CandidateResult_ErrorViewingShortQuestions': '이 지원자는 아직 짧은 질문 평가를 완료하지 않았습니다.',
  'Recruiter_CandidateResult_ErrorViewingMultipleChoicesQuestions': '이 지원자는 아직 객관식 질문 평가를 완료하지 않았습니다.',
  "Recruiter_AIReport_BackToDashboard": "지원자 목록으로 돌아가기",
  "Recruiter_AIReport_Title": "AI 보고서",
  "Recruiter_AIReport_OverallScore": "전체 점수",
  "Recruiter_AIReport_Percentile": "백분위수",
  "Recruiter_AIReport_Passed": "합격",
  "Recruiter_AIReport_Failed": "탈락",
  "Recruiter_AIReport_Impression": "노출",
  "Recruiter_AIReport_PotentialWorkPerformance": "잠재적 업무 성과",
  'Recruiter_AIReport_TaskPerformance': '업무 성과',
  'Recruiter_AIReport_ContextualPerformance': '상황별 성과',
  'Recruiter_AIReport_AdaptivePerformance': '적응형 성과',
  "Recruiter_AIReport_Rating": "등급",
  "Recruiter_AIReport_Weighting": "가중치",
  "Recruiter_AIReport_QualitativeAnalysis": "정성 분석",
  'Recruiter_AIReport_NoReportAnnounce': "이 지원자는 화상 면접의 가이드라인을 따르지 않았으며 AI 보고서를 생성할 수 없습니다.",
  "Recruiter_AIReport_ReportInProgress": "면접 분석이 진행 중입니다. 잠시만 기다려 주십시오.",



  'Recruiter_AIReport_task_performance_high': ' 일상적인 업무를 계획, 조직, 관리하는 높은 수준의 능력을 보여주며 대부분의 책임을 수행할 수 있습니다.',
  'Recruiter_AIReport_interpersonal_relationship_communication_high': ' 타인과 효율적으로 소통하고 부서/조직과 긍정적인 관계를 구축하는 높은 능력을 보입니다.',
  'Recruiter_AIReport_adaptability_high': ' 새로운 상황에 유연하고 적응하며 즉시 루틴을 조정할 수 있고 다른 사람들과의 상호 작용에서 매우 유연하게 자신의 접근 방식을 조정할 수 있습니다.',

  'Recruiter_AIReport_task_performance_medium': ' 일상적인 업무를 계획, 조직, 관리하는 능력이 낮으며 직무 책임의 일부를 수행할 수 있습니다.',
  'Recruiter_AIReport_interpersonal_relationship_communication_medium': ' 타인과 효율적으로 소통하고 부서/조직과 긍정적인 관계를 구축하는 중간 수준의 능력을 보입니다.',
  'Recruiter_AIReport_adaptability_medium': ' 적당히 유연하고 변화에 적응하며 일반적으로 루틴을 조정하거나 다른 사람들과의 상호작용에서 자신의 접근 방식을 조정할 의지가 있습니다.',

  'Recruiter_AIReport_task_performance_low': ' 일상적인 업무를 계획, 조직, 관리하는 능력이 낮으며 직무 책임을 수행할 수 없습니다.',
  'Recruiter_AIReport_interpersonal_relationship_communication_low': ' 타인과 효율적으로 소통하고 부서/조직과 긍정적인 관계를 구축하는 낮은 능력을 보입니다.',
  'Recruiter_AIReport_adaptability_low': ' 다소 유연하지 않고 변화에 적응하지 못하며 루틴을 조정하거나 다른 사람들과의 상호작용에서 자신의 접근 방식을 조정하려는 시도를 거의 하지 않습니다.',

  'Recruiter_AIReport_task_performance_0': '이 역량을 판단할 수 없습니다. 보통 지원자가 해당 면접 질문에 답하지 않았거나 면접 영상을 제공하지 않았기 때문입니다.',
  'Recruiter_AIReport_interpersonal_relationship_communication_0': '이 역량을 판단할 수 없습니다. 보통 지원자가 해당 면접 질문에 답하지 않았거나 면접 영상을 제공하지 않았기 때문입니다.',
  'Recruiter_AIReport_adaptability_0': '이 역량을 판단할 수 없습니다. 보통 지원자가 해당 면접 질문에 답하지 않았거나 면접 영상을 제공하지 않았기 때문입니다.',


  'Recruiter_AIReport_pace_high': ' 이상적인 속도에 가깝게 말하고 속도와 리듬을 잘 표현하며 체계적인 사고를 보입니다.',
  'Recruiter_AIReport_leadership_high': ' 다른 사람들을 이끌고 지시하며 높은 성과에 헌신할 수 있게 단호하고 자신감 있는 리더십 자질을 보유하고 있음을 보입니다.',
  'Recruiter_AIReport_learning_agility_high': ' 지속적인 학습 태도와 새로운 기술과 새로운 학습을 습득하고 이를 변화에 적용하려는 열정을 보입니다.',
  'Recruiter_AIReport_creativity_innovation_high': ' 새로운 아이디어에 대한 선호도를 보이고 현재의 관행이나 전통을 따르기보다는 새로운 것을 만들기 위해 상상력과 모험심을 발휘합니다.',

  'Recruiter_AIReport_interpersonal_relationship_high': ' 사람을 대할 때 매우 친절하고 명랑하고 사교적이며 친밀하고 조화로운 관계를 효율적으로 구축할 수 있습니다.',
  'Recruiter_AIReport_goal_and_achievement_striving_high': ' 열심히 일하고 야심차며 더 높은 목표와 성취를 달성하기 위해 동기를 부여받습니다.',
  'Recruiter_AIReport_developing_people_high': ' 다른 사람의 개인적 및 직업적 개발을 지원하는 뚜렷한 강점 기반 사고 방식과 주도권을 보입니다.',
  'Recruiter_AIReport_responsibility_high': ' 책임감이 있고 목표 및 결과 달성을 위한 추진력을 보이며 직무 요구 사항을 충족하고 업무를 독립적으로 수행하기 위해 자신의 능력을 최대한 활용하는 방법을 알고 있습니다.',
  'Recruiter_AIReport_managing_execution_high': ' 자원, 작업 및/또는 프로젝트를 계획하고 관리하는 데 있어 잘 준비되어 있고 조직적입니다. 신중하고 양심적인 방식으로 일하고 목표와 일정에 따라 업무를 우선시하는 방법을 알고 있습니다.',
  'Recruiter_AIReport_analytical_and_logical_thinking_high': ' 아이디어를 탐색하고 정보를 연구하며 분석에 필요한 정보와 아이디어를 체계적으로 수집하고 종합하고 세대 관찰 및 특정 사실로부터 논리적 결론을 도출합니다.',
  'Recruiter_AIReport_complex_problem_solving_high': ' 문제의 본질을 명확히 하고 대안을 평가하고 실행 가능한 해결책을 제시하며 건전한 판단과 결정을 내리는 데 있어 유연하고 개방적입니다.',
  'Recruiter_AIReport_communication_high': ' 정보와 아이디어를 매우 유창하고 명확하고 간결하게 표현할 수 있고 어조와 목소리가 차분하고 확실합니다.',
  'Recruiter_AIReport_caring_and_empathy_high': ' 타인의 행복을 위해 배려하고 공감하고 관심을 보이며 적극적인 경청의 기술을 실천하고 대인 관계에서 인내심과 정직성을 보입니다.',
  'Recruiter_AIReport_english_oral_communication_high': ' 생각과 아이디어를 매우 유창하고 명확하게 표현합니다.',
  'Recruiter_AIReport_cantonese_oral_communication_high': ' 생각과 아이디어를 매우 유창하고 명확하게 표현합니다.',
  'Recruiter_AIReport_mandarin_oral_communication_high': ' 생각과 아이디어를 매우 유창하고 명확하게 표현합니다.',
  'Recruiter_AIReport_team_collaboration_and_inclusion_high': ' 다른 사람에게 친절하고 배려심이 있고 팀 플레이어로서 협조적이고 도움을 주며 호의적이고 문화적으로 민감하여 다양한 배경을 가진 동료들과 함께 일할 수 있습니다.',
  'Recruiter_AIReport_building_relationships_and_network_high': ' 따뜻하고 사교적이며 다양한 사람들과 성공적으로 상호 작용할 수 있는 우수한 대인 관계 기술을 가지고 있고 몸짓을 해석하고 사용하는 방법을 알고 있습니다. 다른 사람의 개인 개발을 지원하는 강력한 강점 기반 사고 방식을 수용합니다.',
  'Recruiter_AIReport_flexibility_and_adaptability_high': ' 새로운 상황에 유연하고 적응하며 즉시 루틴을 조정할 수 있고 다른 사람들과의 상호 작용에서 매우 유연하게 자신의 접근 방식을 조정할 수 있습니다.',
  'Recruiter_AIReport_creativity_and_innovation_high': ' 개방적이고 호기심이 많으며 창의적으로 사고하여 새롭고 심지어 파괴적인 아이디어를 창출할 수 있습니다. 문제 해결에 새로운 접근 방식을 적용하고 새로운 것 또는 디자인을 만들기 위해 새로운 발명을 발전시킬 수 있습니다.',
  'Recruiter_AIReport_emotional_intelligence_high': ' 어려움에 직면하거나 다른 배경(장애인, 노인 또는 어린이)을 가진 고객을 대할 때 침착합니다.',
  'Recruiter_AIReport_enthusiasm_high': ' 명랑하고 긍정적인 감정과 에너지를 전달하는 모습을 보입니다.',
  'Recruiter_AIReport_composure_high': ' 압박을 받을 때 스트레스에 쉽게 취약하지 않고 차분하고 침착합니다.',
  'Recruiter_AIReport_self_confidence_high': ' 자신을 소개할 때 자신감이 넘치고 사람들을 대할 때 편안함을 느낍니다.',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_high': ' 문제를 찾고 비전을 창출하는 뚜렷한 능력을 보여주며 위험을 고려한 혁신과 발명을 가져올 기회를 적극적으로 포착하고 행동하는 강력한 기업가적 마인드를 가지고 있습니다.',
  'Recruiter_AIReport_technology_expertise_and_business_sense_high': ' 기술에 대한 능력과 지식의 전문성을 보여주며 시장의 요구를 해결할 수 있는 매우 우수한 비즈니스 감각을 보입니다.',
  'Recruiter_AIReport_effective_communication_and_teambuilding_high': ' 아이디어를 명확하고 간결하게 전달할 수 있는 강력한 능력이 있고 성공적인 팀 구축을 위해 다른 사람에게 영향력을 행사하고 참여시킬 수 있습니다.',
  'Recruiter_AIReport_grit_and_passion_high': ' 어려움과 역경에 직면했을 때 장기적인 목표를 달성하기 위한 강한 끈기와 열정으로 성공하기 위한 강한 용기와 결단력을 보입니다.',


  'Recruiter_AIReport_pace_medium': ' 너무 빠르지도 너무 느리지도 않습니다.',
  'Recruiter_AIReport_leadership_medium': ' 다른 사람들을 이끌고 영향력을 주고 높은 성과와 개선할 여지를 제공하기 위해 단호한 리더십 자질을 어느 정도 보유하고 있음을 보입니다.',
  'Recruiter_AIReport_learning_agility_medium': ' 새로운 학습과 경험을 습득하기 위해 적당한 관심과 민첩성을 보이며 이를 변화에 적용할 수 있음을 인지합니다.',
  'Recruiter_AIReport_creativity_innovation_medium': ' 새로운 아이디어를 창출하는 데 적당한 수준의 선호도를 보이고 상상력을 발휘하며 새로운 아이디어로 기존 방식을 깨뜨릴 가능성이 있습니다.',

  'Recruiter_AIReport_interpersonal_relationship_medium': ' 사람을 대할 때 적당히 친절하고 따뜻하고 사교적이며 다른 사람들과 관계를 구축할 수 있습니다.',
  'Recruiter_AIReport_goal_and_achievement_striving_medium': ' 적당히 열심히 일하고 야심차며 더 높은 목표와 성취를 달성하기 위해 동기를 부여받습니다.',
  'Recruiter_AIReport_developing_people_medium': ' 다른 사람의 개인적 및 직업적 개발을 지원하는 적당한 강점 기반 사고 방식과 주도권을 보입니다.',
  'Recruiter_AIReport_responsibility_medium': ' 목표 및 결과를 달성하기 위해 적당히 신뢰할 수 있고 집중하며 직무 요구 사항을 충족하기 위해 필요한 것만 제공합니다.',
  'Recruiter_AIReport_managing_execution_medium': ' 목표 및 마감 일정에 따라 업무를 우선적으로 고려하면서 자원, 과제 및/또는 프로젝트의 계획 및 조정에 적당히 조직적이고 양심적입니다.',
  'Recruiter_AIReport_analytical_and_logical_thinking_medium': ' 아이디어를 탐색하거나 정보를 적극적으로 연구하는 데 적당히 탐구적이고 분석에 필요한 정보와 아이디어를 적당히 체계적으로 수집하고 종합하며 논리적 결론을 도출합니다. ',
  'Recruiter_AIReport_complex_problem_solving_medium': ' 의사 결정을 위해 합리적인 논리와 판단을 사용하고 정보를 활용하여 대안 및 옵션을 평가할 수 있습니다.',
  'Recruiter_AIReport_communication_medium': ' 정보와 아이디어를 적당히 유창하고 명확하고 간결하게 표현할 수 있고 어조와 목소리가 적당히 차분하고 확실합니다.  ',
  'Recruiter_AIReport_caring_and_empathy_medium': ' 타인에게 적당히 배려하고 공감하며 인내심을 갖고 다른 사람의 요구를 일반적으로 경청하며 대인 관계에서 적절한 정직성을 유지합니다.',
  'Recruiter_AIReport_english_oral_communication_medium': ' 생각과 아이디어를 적당히 유창하고 명확하게 표현합니다.',
  'Recruiter_AIReport_cantonese_oral_communication_medium': ' 생각과 아이디어를 적당히 유창하고 명확하게 표현합니다.',
  'Recruiter_AIReport_mandarin_oral_communication_medium': ' 생각과 아이디어를 적당히 유창하고 명확하게 표현합니다.',
  'Recruiter_AIReport_team_collaboration_and_inclusion_medium': ' 다른 사람을 배려하지도 외면하지도 않으며 일반적으로 협조적이고 팀워크에 도움이 되며 다른 배경을 가진 동료와 함께 일할 때 적당히 호의적이고 문화적으로 민감합니다.',
  'Recruiter_AIReport_building_relationships_and_network_medium': ' 사람들 사이에서 편안함을 느끼고 가끔 사적인 시간을 즐기며 다양한 사람들과 성공적으로 상호 작용할 수 있는 적당한 대인 관계 기술을 가지고 있거나 다른 사람의 개인 개발에 초점을 맞춘 강점 기반 사고 방식을 수용합니다.',
  'Recruiter_AIReport_flexibility_and_adaptability_medium': ' 적당히 유연하고 변화에 적응하며 일반적으로 루틴을 조정하거나 다른 사람들과의 상호작용에서 자신의 접근 방식을 조정할 의지가 있습니다.',
  'Recruiter_AIReport_creativity_and_innovation_medium': ' 새로운 아이디어를 창출하기 위해 적당히 개방적이고 호기심이 많습니다. 일반적으로 오래된 문제를 해결하기 위해 임시 해결책을 적용하고 일부 확립된 관행에 변화를 가져올 수 있지만 독창적인 디자인이나 해결책은 아닐 수 있습니다.',
  'Recruiter_AIReport_emotional_intelligence_medium': ' 어려움에 직면할 때 자신의 감정을 통제하기 위해 의도적인 노력을 기울입니다. 일반적으로 인내심을 가지고 다른 배경(장애인, 노인 또는 어린이)을 가진 고객을 용인할 수 있습니다. ',
  'Recruiter_AIReport_enthusiasm_medium': ' 적당히 명랑하고 긍정적인 감정과 에너지를 전달하는 모습을 보입니다.',
  'Recruiter_AIReport_composure_medium': ' 적당히 차분하고 침착한 경향이 있고 압박을 받았을 때 스트레스에 적당히 민감합니다.',
  'Recruiter_AIReport_self_confidence_medium': ' 자신을 소개할 때 적당히 자신감이 넘치고 사람들을 대할 때 적당히 편안함을 느낍니다.',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_medium': ' 문제를 찾고 비전을 창출하는 적당한 능력을 보여주며 위험을 고려한 혁신과 발명을 가져올 기회를 포착하고 행동하는 적당한 기업가적 마인드를 가지고 있습니다.',
  'Recruiter_AIReport_technology_expertise_and_business_sense_medium': ' 기술에 대한 능력과 지식의 적당한 수준을 보여주며 시장의 요구를 해결할 수 있는 적당한 비즈니스 감각을 보입니다.',
  'Recruiter_AIReport_effective_communication_and_teambuilding_medium': ' 아이디어를 명확하고 간결하게 전달할 수 있는 적당한 능력이 있고 성공적인 팀 구축을 위해 다른 사람에게 적당히 영향력을 행사하고 참여시킬 수 있습니다.',
  'Recruiter_AIReport_grit_and_passion_medium': ' 어려움과 역경에 직면했을 때 장기적인 목표를 달성하기 위한 적당한 수준의 끈기와 열정으로 성공하기 위한 적당한 용기와 결단력을 보입니다.',


  'Recruiter_AIReport_pace_low': ' 속도가 너무 빠르거나 느리고 청중에게 맞게 속도와 리듬을 조정할 수 없습니다.',
  'Recruiter_AIReport_leadership_low': ' 다른 사람을 이끌고 지시할 수 있을 만큼 단호하거나 자신감이 없으며 높은 성과에 헌신하는 등 아직 개발되지 않은 리더십 자질을 보입니다.',
  'Recruiter_AIReport_learning_agility_low': ' 새로운 학습이나 새로운 경험에 거의 관심이 없거나 덜 민첩한 태도를 보이며 변화의 필요성을 느끼지 못합니다.',
  'Recruiter_AIReport_creativity_innovation_low': ' 현재의 관행과 전통에서 벗어나는 선호도가 낮고 안정감을 유지하고자 합니다.',

  'Recruiter_AIReport_interpersonal_relationship_low': ' 사람을 대할 때 더 내성적이고 덜 따뜻하고 덜 사교적이며 팀보다는 독립적입니다.',
  'Recruiter_AIReport_goal_and_achievement_striving_low': ' 더 조심스럽고 야심차야 하며 성취에 쉽게 만족합니다.',
  'Recruiter_AIReport_developing_people_low': ' 다른 사람의 개인적 및 직업적 개발을 지원하는 낮은 강점 기반 사고 방식과 주도권을 보입니다.',
  'Recruiter_AIReport_responsibility_low': ' 목표 및 결과를 달성하는 데 의무감이나 책임감을 덜 느낍니다. 일을 완수하는 데 느긋하고 여유롭게 느낍니다.',
  'Recruiter_AIReport_managing_execution_low': ' 덜 체계적이고 덜 신중한 방식으로 일하며 자원, 작업 및 프로젝트의 세부 계획 및 조율에 부주의하며 목표 및 마감 일정을 따르지 않습니다. ',
  'Recruiter_AIReport_analytical_and_logical_thinking_low': ' 아이디어를 탐색하기 위해 흥미를 느끼지 못하거나 탐구적이지 않고 분석에 필요한 올바르고 충분한 정보를 조사, 수집 또는 종합하고 논리적 결론을 내리는 데 능동적이지 않습니다. ',
  'Recruiter_AIReport_complex_problem_solving_low': ' 옵션을 평가하거나 제안하기 위해 문제의 본질을 명확히 할 수 없으며 합리적인 논리나 판단에 근거하여 결정을 내릴 수 없습니다.',
  'Recruiter_AIReport_communication_low': ' 정보와 아이디어를 명확하고 간결하게 제시하는 능력이 떨어지고 말투와 목소리에서 약간의 초조함을 보이며 확신이 없습니다.',
  'Recruiter_AIReport_caring_and_empathy_low': ' 타인에 대한 동정심이나 공감력을 거의 보이지 않으며 타인의 요구에 귀를 기울이거나 대인 관계에서 정직성의 원칙을 고수하려는 인내심이나 의향이 거의 없습니다.',
  'Recruiter_AIReport_english_oral_communication_low': ' 생각과 아이디어를 덜 유창하고 덜 명확하게 표현합니다.',
  'Recruiter_AIReport_cantonese_oral_communication_low': ' 생각과 아이디어를 덜 유창하고 덜 명확하게 표현합니다.',
  'Recruiter_AIReport_mandarin_oral_communication_low': ' 생각과 아이디어를 덜 유창하고 덜 명확하게 표현합니다.',
  'Recruiter_AIReport_team_collaboration_and_inclusion_low': ' 자기 중심적이고 타인에 대한 관심이 적으며 혼자서 독립적으로 일하는 것을 즐깁니다. 호의적이지 않고 타인과 모순될 수 있으며 문화적으로 민감하지 않습니다.',
  'Recruiter_AIReport_building_relationships_and_network_low': ' 내성적이고 적극적으로 관계를 구축하려고 하지 않으며 다른 사람들과 성공적으로 상호 작용할 수 있는 대인관계 기술이 부족합니다. 다른 사람의 개인 발전을 지원하는 강점 기반 사고 방식을 수용하지 않습니다.',
  'Recruiter_AIReport_flexibility_and_adaptability_low': ' 다소 유연하지 않고 변화에 적응하지 못하며 루틴을 조정하거나 다른 사람들과의 상호작용에서 자신의 접근 방식을 조정하려는 시도를 거의 하지 않습니다.',
  'Recruiter_AIReport_creativity_and_innovation_low': ' 전통적인 기존 방식을 따르고 새로운 아이디어를 창출하는 데 호기심이 낮습니다. 문제 해결에 대해 기존 방식을 고수하며 독창적인 디자인이나 해결책을 만들기 위해 현재의 관행에서 벗어날 수 없습니다.',
  'Recruiter_AIReport_emotional_intelligence_low': ' 어려움에 직면할 때 긴장감이 보이고 자신감이 부족합니다. 다른 배경(장애인, 노인 또는 어린이)을 가진 고객을 대할 때 인내심이 떨어지거나 용인할 수 없습니다.',
  'Recruiter_AIReport_enthusiasm_low': ' 긍정적인 감정과 에너지를 전달하지 못하고 다소 소외되고 분리되는 경향을 보입니다.',
  'Recruiter_AIReport_composure_low': ' 압박을 받았을 때 긴장감이나 좌절감을 보이며 스트레스를 받기 쉽습니다.',
  'Recruiter_AIReport_self_confidence_low': ' 자신을 소개할 때 자신감이 떨어지고 사람들을 대할 때 불편함을 느낍니다.',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_low': ' 문제를 찾고 비전을 창출하는 데 낮은 능력을 보여주며 위험을 고려한 혁신과 발명을 가져올 기회를 포착하고 행동하는 기업가적 마인드가 거의 없습니다.',
  'Recruiter_AIReport_technology_expertise_and_business_sense_low': ' 기술에 대한 능력이나 지식이 거의 없으며 시장의 요구를 해결할 수 있는 비즈니스 감각이 없습니다.',
  'Recruiter_AIReport_effective_communication_and_teambuilding_low': ' 아이디어를 명확하고 간결하게 전달하는 능력이 부족하며 성공적인 팀 구축을 위해 다른 사람에게 영향력을 행사하거나 참여시킬 수 없습니다.',
  'Recruiter_AIReport_grit_and_passion_low': ' 도전과 역경에 직면했을 때 장기적인 목표를 달성하기 위한 끈기나 열정뿐만 아니라 성공하려는 용기와 결단력이 거의 없습니다.',

  'Recruiter_AIReport_0': '이 역량을 판단할 수 없습니다. 보통 지원자가 해당 면접 질문에 답하지 않았거나 면접 영상을 제공하지 않았기 때문입니다.',

  "Recruiter_AIRating_Comment": "의견",
  "Recruiter_AIRating_BackToDashboard": "지원자 목록으로 돌아가기",
  "Recruiter_AIRating_Title": "AI 등급",
  "Recruiter_AIRating_OverallScore": "전체 점수",
  "Recruiter_AIRating_Percentile": "백분위수",
  "Recruiter_AIRating_Passed": "합격",
  "Recruiter_AIRating_Failed": "탈락",
  "Recruiter_AIRating_ImpressionScore": "노출 점수:",
  "Recruiter_AIRating_Impression": "노출 점수:",
  "Recruiter_AIRating_PotentialWorkPerformanceScore": "잠재적 업무 성과 점수:",
  "Recruiter_AIRating_FullMark": "10점 만점",
  "Recruiter_AIRating_HighScore": "높은 점수: 7.0 이상",
  "Recruiter_AIRating_LowScore": "낮은 점수: 5.0 이하",
  "Recruiter_AIRating_RadarLabel": ['목표 및 달성 노력', '리더십', '창의성', '학습 민첩성', '커뮤니케이션', '대인 관계', '감정 지능'],
  "Recruiter_AIRating_Big5Score": "빅5 성격 점수:",
  "Recruiter_AIRating_TotalScore": "총 점수:",
  'Recruiter_AIRating_TaskPerformance': '업무 성과 점수:',
  'Recruiter_AIRating_ContextualPerformance': '상황별 성과 점수:',
  'Recruiter_AIRating_AdaptivePerformance': '적응형 성과 점수:',
  "Recruiter_Comment_BackToDashboard": "지원자 목록으로 돌아가기",
  "Recruiter_Comment_Title": "채용 담당자 의견",
  "Recruiter_Comment_Impression": "노출",
  "Recruiter_Comment_PotentialWorkPerformance": "잠재적 업무 성과",
  "Recruiter_Comment_Rating": "등급",
  "Recruiter_Comment_Comments": "의견",
  "Recruiter_Comment_OverallScore": "전체 점수:",
  "Recruiter_Comment_OverallComments": "전체 의견",
  "Recruiter_Comment_Submit": "제출",
  "Recruiter_Comment_Submit_SuccessMsg": "저장 성공",
  "Recruiter_Comment_Submit_FailedMsg": "저장 실패",

  "Recruiter_Candidate_Result_No_Criteria": '채점 기준 및 가중치가 설정되지 않았습니다. 위치 및 면접 설정 페이지로 이동하여 관련 설정을 완료하십시오.',
  "Recruiter_Candidate_Result_Go_Setting": '설정 페이지로 이동',
  "Recruiter_Candidate_Result_Criteria_Setting": '역량 수정  ',
  "Recruiter_Guest_Review_No_Criteria": '채점 기준 및 가중치가 설정되지 않았습니다. 검토 중인 지원자의 관리자에게 문의하십시오.',
  "Recruiter_CandidateProfile_Title": "지원자 프로필",
  "Candidate_CandidateProfile_Upload_Title" : "Before the interview, please upload your resume",
  "Recruiter_CandidateProfile_CV": "이력서",
  "Recruiter_CandidateProfile_CV_Instruction": "이력서를 여기에 놓거나 선택하십시오.",
  "Recruiter_CandidateProfile_CV_Extension": "권장 파일 형식: PDF, DOC 또는 JPG",
  "Recruiter_CandidateProfile_BasicInformation_Title": "기본 정보",
  "Recruiter_CandidateProfile_BasicInformation_FullName": "성명",
  "Recruiter_CandidateProfile_BasicInformation_PhoneNumber": "전화번호",
  "Recruiter_CandidateProfile_BasicInformation_Email": "이메일 주소",
  "Recruiter_CandidateProfile_BasicInformation_Address": "주소",
  "Recruiter_CandidateProfile_WorkExp_Title": "근무 경력",
  "Recruiter_CandidateProfile_WorkExp_Institute": "회사/기관",
  "Recruiter_CandidateProfile_WorkExp_JobFunction": "직무",
  "Recruiter_CandidateProfile_WorkExp_JobTitle": "직책",
  "Recruiter_CandidateProfile_WorkExp_Location": "위치",
  "Recruiter_CandidateProfile_WorkExp_Active": "재직중",
  "Recruiter_CandidateProfile_WorkExp_StartDate_Year": "시작일 - 년",
  "Recruiter_CandidateProfile_WorkExp_StartDate_Month": "시작일 - 월",
  "Recruiter_CandidateProfile_WorkExp_EndDate_Year": "종료일 - 년",
  "Recruiter_CandidateProfile_WorkExp_EndDate_Month": "종료일 - 월",
  "Recruiter_CandidateProfile_Education_Title": "학력",
  "Recruiter_CandidateProfile_Education_Institute": "기관",
  "Recruiter_CandidateProfile_Education_Major": "전공",
  "Recruiter_CandidateProfile_Education_Award": "수상",
  "Recruiter_CandidateProfile_Education_Location": "위치",
  "Recruiter_CandidateProfile_Education_Active": "재학중",
  "Recruiter_CandidateProfile_Education_StartDate_Year": "시작일 - 년",
  "Recruiter_CandidateProfile_Education_StartDate_Month": "시작일 - 월",
  "Recruiter_CandidateProfile_Education_EndDate_Year": "종료일 - 년",
  "Recruiter_CandidateProfile_Education_EndDate_Month": "종료일 - 월",
  "Recruiter_CandidateProfile_Cert_Title": "자격증 및 수상",
  "Recruiter_CandidateProfile_Cert_Cert": "자격증 / 수상",
  "Recruiter_CandidateProfile_Cert_Year": "년",
  "Recruiter_CandidateProfile_Skills_Title": "기술",
  "Recruiter_CandidateProfile_Skills_Skill": "특기",
  "Recruiter_CandidateProfile_Action_Add": "추가",
  "Recruiter_CandidateProfile_Action_Remove": "삭제",
  "Recruiter_CandidateProfile_Action_Upload": "업로드",
  "Candidate_CandidateProfile_Confirm_Title" : "Resume Upload Confirmation", 
  "Candidate_CandidateProfile_Confirm_Content" : "Please make sure all filled information is correct, you will not be allowed to modify once you click the CONFIRM button below.", 
  "Recruiter_CandidateProfile_Upload_MsgSuccess": "프로필 업데이트 성공",
  "Recruiter_CandidateProfile_Upload_MsgFailed": "프로필 업데이트 실패",
  "Recruiter_Candidate_Invite_Result_Title": "초대 오류",
  "Recruiter_Candidate_Invite_Result_Content": "다음 후보자의 초대에 오류가 발생했습니다:",
  "Recruiter_Candidate_Invite_Result_Code0": "-",
  "Recruiter_Candidate_Invite_Result_Code1": "이메일을 보낼 수 없습니다",
  "Recruiter_Candidate_Invite_Result_Code2": "초대 이메일이 성공적으로 전송되었습니다. 그러나 SMS 메시지는 전화번호가 제공되지 않았기 때문에 보낼 수 없습니다.",
  "Recruiter_Candidate_Invite_Result_Code3": "할당량이 충분하지 않습니다.",
  "Recruiter_Candidate_Invite_Result_Code4": "면접 완료",
  "Recruiter_Candidate_Invite_Result_Table_Name": "이름",
  "Recruiter_Candidate_Invite_Result_Table_Email": "이메일",
  "Recruiter_Candidate_Invite_Result_Table_Result": "초대 상태",
  "Recruiter_Candidate_Invite_Result_Table_Message": "사유",
  "Recruiter_Candidate_Invite_Result_Success": "초대가 전송되었습니다.",
  "Recruiter_Candidate_Invite_Result_Fail": "초대 전송에 실패했습니다.",
  "Recruiter_Skills_Attractiveness": "매력",
  "Recruiter_Skills_Wear_Glasses": "안경 착용",
  "Recruiter_Skills_Wear_Glasses_yes": "예",
  "Recruiter_Skills_Wear_Glasses_no": "아니오",
  "Recruiter_Skills_Enthusiasm": "열정",
  "Recruiter_Skills_SelfConfidence": "자신감",
  "Recruiter_Skills_Composure": "평정",
  "Recruiter_Skills_Pace": "능변",
  "Recruiter_Skills_Leadership": "리더십",
  "Recruiter_Skills_LearningAgility": "학습 민첩성",
  "Recruiter_Skills_CreativityAndInnovation": "창의성 및 혁신성",
  "Recruiter_Skills_EmotionalIntelligence": "감정 지능",
  "Recruiter_Skills_Communication": "임팩트 있는 커뮤니케이션",
  "Recruiter_Skills_InterpersonalRelationship": "대인 관계",

  "Recruiter_Skills_GoalAndAchievementStriving": "목표 및 달성 노력",
  "Recruiter_Skills_Pleasantness": "상냥함",
  "Recruiter_Skills_Patience": "인내심",
  "Recruiter_Skills_ComposureS4m": "평정",
  "Recruiter_Skills_Independence": "독립성",
  "Recruiter_Skills_AdaptabilityAndSupporting": "적응성 및 지원",
  "Recruiter_Skills_CaringAndSensitivity": "배려 및 감수성",
  "Recruiter_Skills_ResponsibleWithOwnership": "소유권 및 목표 달성에 대한 책임",
  'Recruiter_Skills_DevelopingPeople': '인재 개발',
  'Recruiter_Skills_Responsibility': '책임',
  'Recruiter_Skills_ManagingExecution': '실행 관리',
  'Recruiter_Skills_AnalyticalAndLogicalThinking': '분석적 및 논리적 사고',
  'Recruiter_Skills_ComplexProblemSolving': '복잡한 문제 해결',
  'Recruiter_Skills_CaringAndEmpathy': '배려와 공감',
  'Recruiter_Skills_EnglishOralCommunication': '영어로 의사 소통',
  'Recruiter_Skills_CantoneseOralCommunication': '광둥어로 의사 소통',
  'Recruiter_Skills_MandarinOralCommunication': '북경어로 의사 소통',
  'Recruiter_Skills_TeamCollaborationAndInclusion': '팀 협업 및 포용성',
  'Recruiter_Skills_BuildingRelationshipsAndNetwork': '관계 및 네트워크 구축',
  'Recruiter_Skills_FlexibilityAndAdaptability': '유연성 및 적응성',
  'Recruiter_Skills_VisionAndEntrepreneurialMindset': '비전과 기업가 정신',
  'Recruiter_Skills_TechnologyExpertiseAndBusinessSense': '기술 전문성 및 비즈니스 감각',
  'Recruiter_Skills_EffectiveCommunicationAndTeambuilding': '효율적인 커뮤니케이션 및 팀 빌딩',
  'Recruiter_Skills_GritAndPassion': '투지 및 열정',

  "Recruiter_Skills_EnglishOralCommunicationOngrad": "영어로 의사 소통",
  "Recruiter_Skills_MotivationOngrad": "건강/환경/미학/기술에 대한 관심 (직무 1)",
  "Recruiter_Skills_MotivationOngradB": "건강/환경/미학/기술에 대한 관심 (직무 2)",
  "Recruiter_Skills_CommunicationWithImpactOngrad": "임팩트 있는 커뮤니케이션",
  "Recruiter_Skills_TeamworkAndCollaborationOngrad": "팀워크 및 협업",
  "Recruiter_Skills_CaringAndEmpathyOngrad": "배려와 공감",
  "Recruiter_Skills_BuildingRelationshipAndPeopleOngrad": "관계 구축",
  "Recruiter_Skills_ResponsibilityAndGoalAchievementOngrad": "책임 및 목표 달성",
  "Recruiter_Skills_EmotionalIntelligenceOngrad": "감정 지능",
  "Recruiter_Skills_ManagingExecutionOngrad": "실행 관리",
  "Recruiter_Skills_FlexibilityAndActiveLearningOngrad": "유연성 및 적응성",
  "Recruiter_Skills_ComplexProblemSolvingOngrad": "복잡한 문제 해결",
  "Recruiter_Skills_AnalyticalAndLogicalThinkingOngrad": "분석적 및 논리적 사고",
  "Recruiter_Skills_CreativityAndInnovationOngrad": "창의성 및 혁신성",
  "Recruiter_Skills_ConfidenceOngrad": "자신감",
  "Recruiter_Skills_ComposureOngrad": "평정",
  "Recruiter_Skills_EnthusiasmOngrad": "열정",

  "Recruiter_Skills_TaskPerformance": "업무 성과",
  "Recruiter_Skills_InterpersonalRelationshipCommunication": "대인 관계 및 커뮤니케이션",
  "Recruiter_Skills_Adaptability": "적응성",


  "LayoutSettings_QuestionSubType_Leadership": "리더십",
  "LayoutSettings_QuestionSubType_DevelopingPeople": "인재 개발",
  "LayoutSettings_QuestionSubType_GoalAndAchievementStriving": "목표 및 달성 노력",


  "LayoutSettings_QuestionSubType_TechnologyExpertiseAndBusiness Sense": "기술 전문성 및 비즈니스 감각",
  "LayoutSettings_QuestionSubType_Responsibility": "책임",
  "LayoutSettings_QuestionSubType_ManagingExecution": "실행 관리",
  "LayoutSettings_QuestionSubType_AnalyticalAndLogicalThinking": "분석적 및 논리적 사고",
  "LayoutSettings_QuestionSubType_ComplexProblemSolving": "복잡한 문제 해결",
  "LayoutSettings_QuestionSubType_VisionAndEntrepreneurialMindset": "비전과 기업가 정신",

  "LayoutSettings_QuestionSubType_CommunicationWithImpact": "임팩트 있는 커뮤니케이션",
  "LayoutSettings_QuestionSubType_CaringAndEmpathy": "배려와 공감",
  "LayoutSettings_QuestionSubType_InterpersonalRelationship": "대인 관계",
  "LayoutSettings_QuestionSubType_Team CollaborationAndInclusion": "팀 협업 및 포용성",
  "LayoutSettings_QuestionSubType_Building RelationshipsAndNetwork": "관계 및 네트워크 구축",
  "LayoutSettings_QuestionSubType_Effective CommunicationAndTeambuilding": "효율적인 커뮤니케이션 및 팀 빌딩",
  "LayoutSettings_QuestionSubType_FlexibilityAndAdaptability": "유연성 및 적응성",
  "LayoutSettings_QuestionSubType_LearningAgility": "학습 민첩성",
  "LayoutSettings_QuestionSubType_CreativityAndInnovation": "창의성 및 혁신성",
  "LayoutSettings_QuestionSubType_EmotionalIntelligence": "감정 지능",
  "LayoutSettings_QuestionSubType_GritAndPassion": "투지 및 열정",


  "Recruiter_Email_Invitation_Default": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p></p><p>저희 회사에 지원해 주셔서 감사합니다!</p><p>귀하는 Neufast 평가를 수행하도록 초대되었습니다. 30분 정도의 간단한 가상 평가입니다. 시작일과 종료일 사이에 언제든지 수행할 수 있습니다.</p><p></p><p>로그인 세부 정보는 아래에 나와 있습니다. </p><ul><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>면접 웹사이트: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>로그인 정보: {{Candidate’s login, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>비밀번호: {{Candidate’s password, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>시작일: {{Start date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>종료일: {{End date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>시간대: {{Timezone, don’t change}}</li></ul><span style=\"font-size: 14px;\"><p></p><p></p><ins>시스템 요구 사항:</ins></span><p>데스크톱/노트북: 웹캠 및 마이크가 있는 Wi-Fi/유선 연결 된 노트북/데스크톱에서 업데이트된 Chrome/Firefox/Safari(MacOS)</p>\n<p>모바일: Android에서 업데이트된 Chrome / iPhone/iPad에서 업데이트된 Safari (SE2/XS 이상) </p>\n<p style=\"margin-left:0px;\"></p><p>평가에 참여해 주셔서 감사합니다. 성공적으로 완료하기를 바라며 다음 라운드에서 뵙겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Email_Invitation_Default_old": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p></p><p>저희 회사에 지원해 주셔서 감사합니다!</p><p>귀하는 Neufast 화상 면접에 초대되었습니다. 30분 정도의 간단한 가상 화상 면접입니다. 시작일과 종료일 사이에 언제든지 수행할 수 있습니다.</p><p></p><p>로그인 세부 정보는 아래에 나와 있습니다. </p><ul><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>면접 웹사이트: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>로그인 정보: {{Candidate’s login, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>비밀번호: {{Candidate’s password, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>시작일: {{Start date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>종료일: {{End date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>시간대: {{Timezone, don’t change}}</li></ul><span style=\"font-size: 14px;\"><p></p><p></p><ins>시스템 요구 사항:</ins></span><p>데스크톱/노트북: 웹캠 및 마이크가 있는 Wi-Fi/유선 연결 된 노트북/데스크톱에서 업데이트된 Chrome/Firefox/Safari(MacOS)</p>\n<p>모바일: Android에서 업데이트된 Chrome / iPhone/iPad에서 업데이트된 Safari (SE2/XS 이상) </p>\n<p style=\"margin-left:0px;\"></p><p>화상 면접에 참여해 주셔서 감사합니다. 성공적으로 완료하기를 바라며 다음 라운드에서 뵙겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자 </p>",
  "Recruiter_Email_Reminder_Default": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>{{Company’s name, don’t change}}의 {{Job Title, don’t change}}에 대한 지원과 관련하여, {{End date and time, don’t change}}전에 평가를 수행해야 합니다. 평가의 로그인 세부 정보는 다음과 같이 다시 제공됩니다:</p><ul> <li>면접 웹사이트: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>로그인 정보: <strong>{{Candidate’s login, don’t change}}</strong></li><li>비밀번호: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>시작일: <strong>{{Start date and time, don’t change}}</strong></li><li>종료일: <strong>{{End date and time, don’t change}}</strong></li> <li>시간대: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>평가에 참여해 주셔서 감사합니다. 성공적으로 완료하기를 바라며 다음 라운드에서 뵙겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Email_Reminder_Default_old": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>{{Company’s name, don’t change}}의 {{Job Title, don’t change}}에 대한 지원과 관련하여, {{End date and time, don’t change}}전에 화상 면접을 수행해야 합니다. 화상 면접의 로그인 세부 정보는 다음과 같이 다시 제공됩니다:</p><ul> <li>면접 웹사이트: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>로그인 정보: <strong>{{Candidate’s login, don’t change}}</strong></li><li>비밀번호: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>시작일: <strong>{{Start date and time, don’t change}}</strong></li><li>종료일: <strong>{{End date and time, don’t change}}</strong></li> <li>시간대: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>화상 면접에 참여해 주셔서 감사합니다. 성공적으로 완료하기를 바라며 다음 라운드에서 뵙겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Email_Confirmation_Default": "<p> 친애하는 {{Candidate’s name, don’t change}},</p><p>평가를 완료해 주셔서 감사합니다. 답변을 검토 중이며 다음 라운드에 최종 후보로 선정되면 연락드리겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Email_Confirmation_Default_old": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>화상 면접을 완료해 주셔서 감사합니다. 답변을 검토 중이며 다음 라운드에 최종 후보로 선정되면 연락드리겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자​</p>",
  "Recruiter_Email_Extension_Default": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>{{Company’s name, don’t change}}의 {{Job Title, don’t change}}에 대한 지원과 관련하여, 평가 기한이 {{End date and time, don’t change}}(으)로 변경되었습니다. 평가의 로그인 세부 정보는 다음과 같이 다시 제공됩니다:</p><ul> <li>면접 웹사이트: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>로그인 정보: <strong>{{Candidate’s login, don’t change}}</strong></li><li>비밀번호: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>시작일: <strong>{{Start date and time, don’t change}}</strong></li><li>종료일: <strong>{{End date and time, don’t change}}</strong></li> <li>시간대: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>평가에 참여해 주셔서 감사합니다. 성공적으로 완료하기를 바라며 다음 라운드에서 뵙겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Email_Extension_Default_old": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>{{Company’s name, don’t change}}의 {{Job Title, don’t change}}에 대한 지원과 관련하여, 화상 면접 기한이 {{End date and time, don’t change}}(으)로 변경되었습니다. 화상 면접의 로그인 세부 정보는 다음과 같이 다시 제공됩니다:</p><ul> <li>면접 웹사이트: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>로그인 정보: <strong>{{Candidate’s login, don’t change}}</strong></li><li>비밀번호: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>시작일: <strong>{{Start date and time, don’t change}}</strong></li><li>종료일: <strong>{{End date and time, don’t change}}</strong></li> <li>시간대: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>화상 면접에 참여해 주셔서 감사합니다. 성공적으로 완료하기를 바라며 다음 라운드에서 뵙겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_SMS_Invitation_Default": "{{company name}}의 {{job title}}에 대한 평가를 수행하도록 초대되었습니다. 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!!",
  "Recruiter_SMS_HighScoreContent_Default": "{{company name}}의 {{job title}}에 대한 평가를 수행하도록 초대되었습니다. 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!!",
  "Recruiter_SMS_MediumScoreContent_Default": "{{company name}}의 {{job title}}에 대한 평가를 수행하도록 초대되었습니다. 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!!",
  "Recruiter_SMS_LowScoreContent_Default": "{{company name}}의 {{job title}}에 대한 평가를 수행하도록 초대되었습니다. 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!!",
  "Recruiter_SMS_Reminder_Default": "가능한 한 빨리 {{company name}}의 {{job title}}에 대한 평가를 수행해 주십시오. 평가 마감은 24시간 후입니다. 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!",
  "Recruiter_SMS_Extension_Default": "{{company name}}의 {{job title}}에 대한 평가 마감일이 {{End date and time, don’t change}}(으)로  변경되었습니다. 가능한 한 빨리 완료하고 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!",
  "Recruiter_SMS_Invitation_Default_old": "{{company name}}의 {{job title}}에 대한 화상 면접을 수행하도록 초대되었습니다. 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!!",
  "Recruiter_SMS_Reminder_Default_old": "가능한 한 빨리 {{company name}}의 {{job title}}에 대한 화상 면접을 수행해 주십시오. 화상 면접 마감은 24시간 후입니다. 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!",
  "Recruiter_SMS_Extension_Default_old": "{{company name}}의 {{job title}}에 대한 화상 면접 마감일이 {{End date and time, don’t change}}(으)로  변경되었습니다. 가능한 한 빨리 완료하고 자세한 내용은 이메일 {{Candidate's login, don't change}}을 확인하세요. 감사합니다!",
  "Recruiter_Email_Redo_Default": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>{{company name}}의 {{job title}}에 대한 평가에 참여해 주셔서 감사합니다. 안타깝게도 {{Number of retaking questions, don’t change}}질문에 대한 영상이 누락된 것을 발견했습니다. 종료일 전에 아래 링크를 통해 특정 질문을 다시 수행하십시오.</p><p> </p><p>로그인 세부 정보는 아래에 나와 있습니다. 웹캠 및 마이크가 있는 모바일 또는 노트북에서 업데이트된 Chrome 브라우저를 사용하여 면접을 진행하시기 바랍니다.</p><ul> <li>면접 웹사이트: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>로그인 정보: <strong>{{Candidate’s login, don’t change}}</strong></li><li>비밀번호: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>시작일: <strong>{{Start date and time, don’t change}}</strong></li><li>종료일: <strong>{{End date and time, don’t change}}</strong></li> <li>시간대: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>성공적으로 완료하기를 바라며 다음 라운드에서 뵙겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Email_Redo_Default_old": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>{{company name}}의 {{job title}}에 대한 화상 면접에 참여해 주셔서 감사합니다. 안타깝게도 {{Number of retaking questions, don’t change}}질문에 대한 영상이 누락된 것을 발견했습니다. 종료일 전에 아래 링크를 통해 특정 질문을 다시 수행하십시오.</p><p> </p><p>로그인 세부 정보는 아래에 나와 있습니다. 웹캠 및 마이크가 있는 모바일 또는 노트북에서 업데이트된 Chrome 브라우저를 사용하여 면접을 진행하시기 바랍니다.</p><ul> <li>면접 웹사이트: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>로그인 정보: <strong>{{Candidate’s login, don’t change}}</strong></li><li>비밀번호: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>시작일: <strong>{{Start date and time, don’t change}}</strong></li><li>종료일: <strong>{{End date and time, don’t change}}</strong></li> <li>시간대: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>성공적으로 완료하기를 바라며 다음 라운드에서 뵙겠습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Email_Report_Default": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>평가를 완료해 주셔서 감사합니다. 귀하의 면접이 분석되었습니다. 다음은 귀하의 전체 점수와 의견입니다:</p><p></p><p>점수: {{Score, don’t change}}/10</p><p>의견: {{Comment, don’t change}}</p><p></p><p>개발 영역을 파악하는 데 도움이 되는 개발 보고서도 동봉되어 있습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Email_WithoutScore_Report_Default": "<p>친애하는 {{Candidate’s name, don’t change}},</p><p>평가를 완료해 주셔서 감사합니다. 귀하의 면접이 분석되었습니다. 개발 영역을 파악하는 데 도움이 되는 개발 보고서도 동봉되어 있습니다.</p><p></p><p>감사합니다,</p><p>인재 관리자</p>",
  "Recruiter_Upload_Large_File_Warning_Title": '대용량 파일이 감지되었습니다.',
  "Recruiter_Upload_Large_File_Warning_Message": '업로드된 동영상 파일이 200MB보다 큽니다. 이로 인해 면접 로딩 시간이 길어질 수 있습니다.',
  "Recruiter_AccountSetting_Title": "계정 설정",
  "Recruiter_AccountSetting_RecruiterProfile_Title": "채용 담당자 프로필",
  "Recruiter_AccountSetting_CompanyProfile_Title": "회사 프로필",
  "Recruiter_AccountSetting_Functionality_Title": "기능",
  "Recruiter_AccountSetting_UsageHistory_Title": "사용 내역",
  "Recruiter_AccountSetting_Password_Title": "비밀번호",
  "Recruiter_AccountSetting_Add_Recruiter_Button": "하위 채용 담당자 추가",
  "Recruiter_AccountSetting_Register_Dialog_Title": "하위 채용 담당자 등록",
  "Recruiter_AccountSetting_Register_Dialog_SubTitle_Login": "로그인 정보",
  "Recruiter_AccountSetting_Register_Dialog_SubTitle_Account": "계정 정보",
  "Recruiter_AccountSetting_Register_Dialog_Email": "이메일",
  "Recruiter_AccountSetting_Register_Dialog_Password": "비밀번호",
  "Recruiter_AccountSetting_Register_Dialog_FirstName": "이름",
  "Recruiter_AccountSetting_Register_Dialog_LastName": "성",
  "Recruiter_AccountSetting_RecruiterProfile_Picture": "프로필 사진:",
  "Recruiter_AccountSetting_RecruiterProfile_FirstName": "이름:",
  "Recruiter_AccountSetting_RecruiterProfile_LastName": "성:",
  "Recruiter_AccountSetting_RecruiterProfile_Email": "이메일:",
  "Recruiter_AccountSetting_RecruiterProfile_JobTitle": "직책:",
  "Recruiter_AccountSetting_RecruiterProfile_Tel": "전화번호:",
  "Recruiter_AccountSetting_Functionality_RecruiterEvaluation": "채용 담당자 평가",
  "Recruiter_AccountSetting_Functionality_FacialAnnotation": "영상에서의 얼굴 표정 어노테이션",
  "Recruiter_AccountSetting_UsageHistory_NumberInvitations": "초대 수",
  "Recruiter_AccountSetting_UsageHistory_NumberCompletedInterviews": "완료된 면접 수",
  "Recruiter_AccountSetting_UsageHistory_TimePeriod": "기간",
  "Recruiter_AccountSetting_UsageHistory_Number": "번호",
  "Recruiter_AccountSetting_Password_CurrentPassword": "현재 비밀번호",
  "Recruiter_AccountSetting_Password_NewPassword": "새로운 비밀번호",
  "Recruiter_AccountSetting_Password_PasswordConfirmation": "비밀번호 확인",
  "Recruiter_AccountSetting_PurchaseBalance_Title": "구매 및 잔액",
  "Recruiter_AccountSetting_DateOfPurchase": "구매일",
  "Recruiter_AccountSetting_ValidUntil": "유효 기간",
  "Recruiter_AccountSetting_Reference": "참조",
  "Recruiter_AccountSetting_NumberOfInterviews": "면접 수",
  "Recruiter_AccountSetting_NumberOfExpiredInterviews": "만료된 면접",
  "Recruiter_AccountSetting_RecruiterAccount": "채용 담당자 계정",
  "Recruiter_AccountSetting_InterviewUsage": "면접 사용량",
  "Recruiter_AccountSetting_PurchasedInterviews": "구매한 면접",
  "Recruiter_AccountSetting_Usage": "사용",
  "Recruiter_AccountSetting_Balance": "잔액",
  "Recruiter_AccountSetting_AccountStatus": "계정 상태",
  "Recruiter_AccountSetting_TotalNumberOfInterviews": "총 면접 수 (1)",
  "Recruiter_AccountSetting_TotalInterviewUsage": "총 면접 사용량 (2)",
  "Recruiter_AccountSetting_TotalNumberOfExpiredInterviews": "총 만료된 면접 수 (3)",
  "Recruiter_AccountSetting_TotalBalance": "잔액 = (1) - (2) - (3)",

  "Recruiter_CV_Upload_Message": "+이력서 업로드",
  "Recruiter_CV_Extension": "파일 형식: JPG, PDF, DOC, DOCX",

  "Candidate_Common_Next": "다음",
  "Candidate_Common_Start": "시작",
  "Candidate_Common_Step_Setting": "오디오 및 영상 확인",
  "Candidate_Common_Step_Practice": "연습",
  "Candidate_Common_Step_Real": "면접",
  "Candidate_Common_Step_Finished": "완료됨",
  "Candidate_Common_HideCamera": "카메라 숨기기",
  "Candidate_Common_TimeRemaining": "남은 시간",
  "Candidate_Common_Video_Recording": "녹화 중...",
  "Candidate_Common_Video_Stop": "중지",
  "Candidate_Common_Video_Uploading": "업로드 중...",
  "Candidate_Interview_LoadingMessage": "잠시만 기다려 주십시오, 평가를 로딩 중입니다...",
  "Candidate_Interview_LoadingMessage_old": "잠시만 기다려 주십시오, 화상 면접을 로딩 중입니다...",
  "Candidate_Browser_Msg": "<p> 죄송합니다. 귀하의 브라우저는 영상 녹화를 지원하지 않습니다. </p> <p>Google Chrome 브라우저를 사용하십시오. 다음 사이트에서 다운로드할 수 있습니다:</p><p><a href=\"https://www.google.com/chrome/\">https://www.google.com/chrome/</a></p><p> 또는 안드로이드 휴대폰에서 Chrome 브라우저를 사용할 수도 있습니다. 감사합니다! </p>",
  "Candidate_Browser_Warning_IOS": "iPhone/iPad의 브라우저는 화상 면접을 지원하지 않습니다. App Store에서 Neufast 면접 앱을 사용하거나 Google Chrome 브라우저가 있는 Mac/Android/Window 기기를 사용하십시오.",
  "Candidate_Browser_Warning_Edge": "귀하의 Edge 브라우저 버전은 화상 면접을 지원하지 않습니다. Edge 브라우저를 최신 버전으로 업데이트하십시오",
  "Candidate_Browser_Warning_Generic": "귀하의 브라우저는 화상 면접을 지원하지 않습니다. Google Chrome 브라우저를 사용하십시오",
  "Candidate_Browser_Warning_CriOS": "iOS의 Chrome은 앱과 호환되지 않습니다.사파리로 전환하십시오",
  "Candidate_Interview_WelcomeTitle": "환영합니다, {name}님! 귀하와 이 평가를 하게 되어 기쁩니다.",
  "Candidate_Interview_WelcomeTitle_old": "환영합니다, {name}님! 귀하와 이 화상 면접을 하게 되어 기쁩니다.",
  'Candidate_Interview_WelcomeTitle_ongrad': "환영합니다, {name}님! 저희와 면접을 해주시기 바랍니다.",
  "Candidate_Interview_Welcome_Company": "<b>회사:</b> {companyName}",
  "Candidate_Interview_Welcome_JobTitle": "<b>직무:</b> {jobTitle}",
  "Candidate_Interview_Welcome_CompanyWebsite": "<b>웹사이트:</b> {companyWebsite}",
  "Candidate_Interview_Welcome_Deadline": "<b>마감일:</b> {deadline}",
  "Candidate_Interview_Language": "<b>평가 언어:</b> {interviewLanguage}",
  "Candidate_Interview_Language_old": "<b>화상 면접 언어:</b> {interviewLanguage}",
  "Candidate_Introduction_Title": "회사 소개 영상",
  "Candidate_Instruction_Title": "지시사항",
  "Candidate_Instruction_Tips": "(<b>조언:</b> 이 영상을 시청하면 회사와 직무에 대한 더 나은 통찰력을 얻을 수 있습니다)",
  "Candidate_Instruction_Details": ["주변 소음이 없는 조용한 장소에서 인터넷에 원활하게 접속합니다.", "스탠드에 기기를 받치거나 안정감 있게 손으로 단단히 잡습니다.", "다른 웹 페이지와 애플리케이션을 닫습니다.", "이 평가는 감독되고 영상은 녹화됩니다. 공정한 평가를 위해 테스트 중에 안면 마스크를 착용하지 않는 것이 좋습니다."],
  "Candidate_Instruction_Details_old": ["주변 소음이 없는 조용한 장소에서 인터넷에 원활하게 접속합니다.", "스탠드에 기기를 받치거나 안정감 있게 손으로 단단히 잡습니다.", "다른 웹 페이지와 애플리케이션을 닫습니다.", "이 화상 면접은 감독되고 영상은 녹화됩니다. 공정한 평가를 위해 화상 면접 중에 안면 마스크를 착용하지 않는 것이 좋습니다."],
  "Candidate_Instruction_Details2": ["평가를 수행하려면 웹캠 및 마이크가 있는 노트북/데스크톱에서 업데이트된 Chrome/Firefox 브라우저를 사용하십시오.", "화상 면접을 위해 스마트폰/ 모바일 기기를 사용하는 것은 권장하지 않습니다.</b>", "<b>화상 면접 시 마스크 착용 금지.</b>", "한 번에 화상 면접을 완료하도록 합니다.", "면접을 완료하면 영상이 업로드될 때까지 기다렸다가 브라우저를 닫고 로그아웃하십시오.", "방해받지 않도록 백그라운드 설정을 유지합니다."],

  "Candidate_Instruction_Details_last": "준비가 되면, \"다음\"을 누르십시오. 웹캠과 오디오 설정을 확인할 것입니다.",

  "Candidate_Instruction_RecordedInterview_Message": "자동 평가이므로 실제 사람이 면접하지 않습니다!",
  "Candidate_Instruction_RecordedInterview_Message_old": "이 면접은 자동화된 화상 면접이므로 실제 사람이 면접하지 않습니다!",
  "Candidate_Settings_Title": "오디오 및 영상 확인",
  "Candidate_Settings_Caption": '평가를 수행하기 전에 기기의 웹캠, 마이크 및 스피커가 켜져 있고 잘 작동하는지 확인하십시오.',
  "Candidate_Settings_Caption_old": '화상 면접을 수행하기 전에 기기의 웹캠, 마이크 및 스피커가 켜져 있고 잘 작동하는지 확인하십시오.',
  "Candidate_Settings_Browser_Compatibility": "브라우저 호환성",
  "Candidate_Settings_Browser_Compatibility_Caption": "당신의 브라우저는",
  "Candidate_Settings_Browser_Compatibility_Text_True": "호환 가능",
  "Candidate_Settings_Browser_Compatibility_Text_False": "호환되지 않음",
  "Candidate_Settings_Browser_Compatibility_Warning": "경고: 브라우저가 오래되었거나 지원되지 않습니다.",
  "Candidate_Settings_Browser_Compatibility_Warning_Message": "브라우저를 최신 버전으로 업데이트하거나 다른 브라우저를 사용하세요. 계속하기로 선택하면 인터뷰 프로세스가 실패할 수 있습니다.",
  "Candidate_Settings_Browser_Compatibility_Warning_Message_Button": "확인하다",
  "Candidate_Settings_Browser_Compatibility_Browser": "지원되는 브라우저:",
  "Candidate_Settings_Browser_Compatibility_Handling": "문제가 지속되면 다른 장치로 시도하십시오",
  "Candidate_Settings_Browser_Compatibility_Handling_iOS": "iOS/MacOS 버전이 감지되었습니다. {version}. ver.14.3 이상으로 업데이트 해주세요",
  "Candidate_Settings_Browser_Compatibility_Handling_CriOS": "iOS/iPad에서 Chrome을 사용하고 있습니다. 대신 Safari 브라우저를 사용하십시오.",
  "Candidate_Settings_Browser_Compatibility_Handling_Unknown": "iOS/iPadOS/MacOS 버전에서 알 수 없는 오류가 감지되었습니다. {version}.",
  "Candidate_Settings_Webcam": "웹캠",
  "Candidate_Settings_Webcam_Caption": "웹캠에 대한 접근을 승인하고 아래 화면에 얼굴이 표시되는지 확인하십시오",
  "Candidate_Settings_Microphone": "마이크",
  "Candidate_Settings_Microphone_Caption": "마이크에 대한 접근을 승인하고 아래 표시기에 목소리가 감지되는지 확인하십시오",
  "Candidate_Settings_MicrophoneVolume_TooLow": "너무 낮음",
  "Candidate_Settings_MicrophoneVolume_Low": "낮음",
  "Candidate_Settings_MicrophoneVolume_Recommended": "권장함",
  "Candidate_Settings_MicrophoneVolume_Loud": "높음",
  "Candidate_Settings_MicrophoneVolume_TooLoud": "너무 높음",
  "Candidate_Settings_Lighting": "조명 및 위치",
  "Candidate_Settings_Speaker": "스피커 볼륨",
  "Candidate_Settings_Speaker_Caption": "음악을 재생하여 들을 수 있는지 확인하십시오",
  "Candidate_Settings_TestAudio": "오디오 테스트",
  'Candidate_Settings_PauseAudio': "오디오 일시 중지",
  "Candidate_Settings_LightCheckPrefix": "누름",
  "Candidate_Settings_LightCheckSuffix": "조명과 위치가 적절한지 확인합니다.",
  "Candidate_Settings_LightCheckPrefixButton": "여기",
  "Candidate_Settings_NetworkCondition": "네트워크 상태",
  "Candidate_Settings_NetworkCondition_UploadSpeed": "업로드 속도: {speed}",
  "Candidate_Settings_NetworkCondition_DownloadSpeed": "다운로드 속도: {speed}",
  "Candidate_Settings_NetworkCondition_Estimating": "계산 중 ...",
  "Candidate_Settings_NetworkCondition_Recommendation": "(안정적인 Wi-Fi 네트워크를 사용하는 것이 좋습니다.)",
  "Candidate_Settings_NetworkCondition_NASpeed": "--- KB/Sec",
  "Candidate_Settings_NetworkCondition_B": "{speed} B/Sec",
  "Candidate_Settings_NetworkCondition_KB": "{speed} KB/Sec",
  "Candidate_Settings_NetworkCondition_MB": "{speed} MB/Sec",
  "Candidate_Settings_NetworkCondition_GB": "{speed} GB/Sec",
  "Candidate_Settings_Error_Msg": "카메라/오디오 장치에 접근할 수 없습니다. 활성화되어 있거나 다른 애플리케이션에서 사용하지 않는지 확인하십시오.",
  "Candidate_Settings_Microphone_No_Voice_Error_Msg": "마이크로 녹음된 음성이 없습니다. 이 대화 상자를 닫고 마이크에 대고 말한 다음 '다음'을 다시 누르십시오. 문제가 지속되면 마이크 설정을 확인하십시오.",
  "Candidate_Detail_Greeting": "안녕하세요, {name}님!",
  "Candidate_Detail_Greeting_In_Mobile_View": "안녕하세요! {name} 님",
  "Candidate_Detail_QuestionAndTimeLimit": "이 면접은 <span style=\"font-size: 150%\">{totalQuestion}</span> 개의 질문으로 구성되며 <span style=\"font-size: 150%\">{timeLimit}</span> 분 소요됩니다.",
  "Candidate_Detail_Deadline": "마감일",
  "Candidate_Detail_InterviewPractice": "면접 연습",
  "Candidate_Detail_Multiple_Choices_Practice": "객관식 질문 연습",
  "Candidate_Detail_Short_Question_Practice": "짧은 질문 연습",
  "Candidate_Detail_Question": "질문:",
  "Candidate_Detail_Interview": "면접",
  "Candidate_Detail_Duration": "시간:",
  "Candidate_Detail_Format": "형식:",
  "Candidate_Detail_Interview_Reminder": "알림",
  "Candidate_Detail_Language_Text_Suffix": '{language}',
  "Candidate_Detail_Paragraph_1": '이 테스트를 진행하기 전에 테스트 형식을 숙지할 수 있도록 연습 테스트를 하는 것이 좋습니다. ',
  "Candidate_Detail_Paragraph_2": '귀하의 면접은 <span style=\"font-weight: bold;font-size: 200%\">{noOfQuestion}</span> {measureWord}(으)로 구성됩니다: ',
  "Candidate_Detail_Paragraph_2_Retake": '귀하의 면접 부분 재응시는 <span style=\"font-weight: bold;font-size: 200%\">{noOfQuestion}</span> {measureWord}(으)로 구성됩니다: ',
  "Candidate_Detail_Language_Text_Suffix_2": '{language}로 <span style=\"font-weight: bold;font-size: 200%;color: red\">{noOfQuestion}</span> {measureWord}',
  "Candidate_Detail_Paragraph_3": "각 질문에 대해 <span style=\"background-color: #e3f2fd\">{preparationTime} 동안 답변을 생각할 수 있으며</span>, 최대 <span style=\"background-color: #e3f2fd\">{timeForEachQuestion} 까지 답변할 수 있습니다.</span>",
  "Candidate_Detail_Paragraph_3_No_Preparation_Time": "각 질문에 대해 최대 <span style=\"background-color: #e3f2fd\">{timeForEachQuestion} 까지 답변할 수 있습니다.</span>",
  "Candidate_Detail_Paragraph_4": "<b>총 예상 시간:</b> {totalTime}",
  "Candidate_Detail_Video_Interview": "화상 면접",
  "Candidate_Detail_Short_Question": "짧은 질문",
  "Candidate_Detail_Multiple_Choices": "객관식 질문",
  "Candidate_Detail_Video_Interview_Paragraph_1_normal": "귀하의 화상 면접 테스트는 {noOfQuestion} {measureWord}(으)로 구성됩니다.",
  "Candidate_Detail_Video_Interview_Paragraph_1_normal_Retake": "귀하의 면접 부분 재응시는 {noOfQuestion} {measureWord}(으)로 구성됩니다.: ",
  "Candidate_Detail_Video_Interview_Paragraph_2_normal": "각 질문에 대해 {preparationTime} 동안 답변을 생각할 수 있으며, 최대 {timeForEachQuestion} 까지 답변할 수 있습니다.",
  "Candidate_Detail_Video_Interview_Paragraph_2_normal_No_Preparation_Time": "각 질문에 대해 최대 {timeForEachQuestion} 까지 답변할 수 있습니다.",
  "Candidate_Detail_Multiple_Choices_Paragraph_1_normal": "객관식 질문 테스트는 {noOfQuestion} {measureWord}(으)로 구성됩니다.",
  "Candidate_Detail_Short_Question_Paragraph_1_normal": "짧은 질문 테스트는 {noOfQuestion} {measureWord}(으)로 구성됩니다.",
  "Candidate_Detail_Multiple_Choices_Paragraph_1": "각 질문에 대해 {timeForEachQuestion} 정도의 답변 시간이 있습니다.",
  "Candidate_Detail_Multiple_Choices_Text_Suffix": "<span style=\"font-weight: bold;font-size: 200%;color: black\">{noOfQuestion}</span>",
  "Candidate_Detail_Short_Question_Paragraph_1": "각 질문에 대해 {timeForEachQuestion} 정도의 답변 시간이 있습니다.",
  "Candidate_Detail_Short_Question_Text_Suffix": "<span style=\"font-weight: bold;font-size: 200%;color: black\">{noOfQuestion}</span>",
  "Candidate_Detail_Start_Practice": "연습 시작",
  "Candidate_Detail_Sec_to_Prepare": "초 동안 준비",
  "Candidate_Detail_Min_To_Answer": "분 동안 답변",
  "Candidate_Detail_Start_Interview": "면접 시작",
  "Candidate_Detail_Start_Test": "테스트 시작",
  "Candidate_Detail_Interview_Info_Heading": "귀하의 평가 정보는 다음과 같습니다:",
  "Candidate_Detail_Compay": "회사",
  "Candidate_Detail_Position_Requested": "직책",
  "Candidate_Detail_Website": "웹사이트",
  "Candidate_Detail_Interview_Date_And_Time": "평가 날짜 및 시간",
  "Candidate_Detail_Help_Center": "지원 센터",
  "Candidate_Detail_Video_Interview_Information": "화상 면접 정보",
  "Candidate_Detail_Multiple_Choices_Information": "객관식 질문 테스트 정보",
  "Candidate_Detail_Short_Question_Information": "짧은 질문 테스트 정보",

  "Candidate_Interview_Time_Remaining": "남은 시간 :",
  "Candidate_Interview_Question_Of": "질문 {totalQuestion} 중 {question}",

  "Candidate_Practice_Title": "면접 연습",
  "Candidate_Practice_PracticeAgain": "다시 연습",
  "Candidate_Practice_Question": "질문",
  "Candidate_Practice_Placeholder": "여기에 답을 입력해주세요",
  "Candidate_Practice_Answer_In": "{language}로 답변",

  "Candidate_Practice_Answer_In_pu_en": "보통화/영어로 답변",
  "Candidate_Practice_Answer_In_cn_en": "광둥어/영어로 답변",

  "Candidate_Practice_Answer_Time": "답변 시간",
  "Candidate_Practice_You_have": "답변을 생각할 수 있는 시간이",
  "Candidate_Practice_To_Think": "남았습니다.",
  "Candidate_Practice_Skip_Message": '이 단계를 건너뛰고 "녹화" 버튼을 클릭하여 바로 시작할 수 있습니다.',
  "Candidate_Practice_Web_Skip_Message": '이 단계를 건너뛰고 "녹화" 버튼을 클릭하여 바로 시작할 수 있습니다.',
  "Candidate_Practice_Record": "녹화",
  "Candidate_Practice_Start_Recording": "녹화 시작",
  "Candidate_Practice_Hide_Self_View": "내 화면 숨기기",
  "Candidate_Practice_Tip": "조언",
  "Candidate_Practice_Tip_Message": " 좋은 답변을 위해 준비 시간을 활용하십시오",
  "Candidate_Practice_Enable_Self_View": "내 화면 숨기기",
  "Candidate_Practice_Done": "완료",


  "Candidate_Practice_Check_Title": '녹화된 연습 영상입니다.	',
  "Candidate_Practice_Check_Content": '녹음된 음성이 잘 들리고 영상이 선명합니까?',
  "Candidate_Practice_Check_YES": '예',
  "Candidate_Practice_Check_NO": '아니오',
  "Candidate_Practice_Check_FAIL": '기기 검사로 다시 안내합니다. 웹캠 또는 마이크를 변경하고 제대로 작동하는지 확인해야 할 수도 있습니다.',
  "Candidate_Practice_Check_Redirect": '오디오 및 영상 확인',



  "Candidate_Practice_NextStagePopup_Title": "안녕하세요! 제 이름은 {recruiterFirstname}, 이며 오늘 귀하의 면접관입니다.",
  "Candidate_Practice_NextStagePopup_Start_Interview": "면접을 시작해봅시다!",

  "Candidate_Practice_Welcome_Title": '연습 면접에 오신 것을 환영합니다',
  "Candidate_Practice_Welcome_Content": '각 질문은 준비 시간 <span class=\"{spanClass}\"{preparationTimeString}</span>(으)로 시작하므로 녹화하기 전에 답변을 생각할 수 있습니다.',
  "Candidate_Practice_Welcome_Content_No_Preparation": '준비 시간이 없으며 3초의 카운트다운 후에 영상 녹화가 시작됩니다.',
  "Candidate_Practice_Welcome_Checkbox_Label": '내 화면 숨기기 (답변은 계속 녹화됩니다.)',
  "Candidate_Practice_Welcome_Confirm": '확인',
  "Candidate_Practice_Welcome_Start": "시작",

  "Candidate_Multiple_Choices_Practice_Welcome_Title": "{testName} 연습에 오신 것을 환영합니다.",
  "Candidate_Multiple_Choices_Practice_Content": "이 연습은 테스트 형식에 익숙해지는 데 도움이 됩니다. 질문은 실제 테스트와 다릅니다.",

  "Candidate_Short_Question_Practice_Welcome_Title": "{testName} 연습에 오신 것을 환영합니다.",
  "Candidate_Short_Question_Practice_Content": "이 연습은 테스트 형식에 익숙해지는 데 도움이 됩니다. 질문은 실제 테스트와 다릅니다.",

  "Candidate_Interview_Submit_Confirm": "제출",
  "Candidate_Interview_Submit_Not_Confirm": "뒤로",
  "Candidate_Interview_Submit_Content": "답변을 제출하시겠습니까?",
  "Candidate_Interview_Face_Detection_Warning": "얼굴이 감지되지 않습니다. 얼굴이 감지되지 않습니다.",

  "Candidate_Interview_Upload_Header_Progressing": "오류가 감지되었습니다! 잠시만 기다려 주십시오. 잠시만 기다려 주십시오....",
  "Candidate_Interview_Upload_Header_Completed": "이전 질문의 영상 녹화에 실패했습니다.",
  "Candidate_Interview_Upload_Body_Progressing": "이전 질문의 영상 녹화에 실패했습니다. 브라우저 또는 기기의 문제일 수 있습니다. 이전 질문의 동영상 업로드가 완료될 때까지 기다려 주십시오.",
  "Candidate_Interview_Upload_Body_Completed": "브라우저 또는 기기의 문제일 수 있습니다. 브라우저를 다시 시작하거나 다른 기기를 사용하여 테스트를 계속하십시오. 문제가 지속되면 'customer-service@neufast.com‘으로 문의하십시오. 불편을 끼쳐드려 죄송합니다.",
  
  "Candidate_Practice_Finish_Title": '녹화된 연습 영상입니다.',
  "Candidate_Multiple_Choices_Practice_Finish_Title": "객관식 질문 연습을 마쳤습니다.",
  "Candidate_Short_Question_Practice_Finish_Title": "짧은 질문 연습을 마쳤습니다.",
  "Candidate_Practice_Finish_Content": '테스트는 연습과 동일한 형식을 따릅니다.',
  "Candidate_Practice_Finish_Content_old": '면접은 연습과 동일한 형식을 따릅니다.',
  "Candidate_Practice_Finish_Button_Practice": '다시 연습',
  "Candidate_Practice_Finish_Button_Back": '메뉴로 돌아가기',
  "Candidate_Practice_Finish_Button_Start": '테스트 시작',
  "Candidate_Practice_Finish_Button_Start_old": '면접 시작',

  "Candidate_Logout_Confirm": "평가가 아직 완료되지 않았지만 마감일 전에 다시 로그인할 수 있습니다.\n\n지금 로그아웃하시겠습니까?",


  "Candidate_RealInterview_Welcome_Title": '화상 면접에 오신 것을 환영합니다!',
  "Candidate_RealInterview_Welcome_Content": '<div>면접을 철저하게 완료하지 않는 한 면접을 <span style=\"font-weight: bold;font-size: 110%\">중단</span> 해서는 안 됩니다. 면접을 할 수 있는 기회는 단 <span style=\"font-weight: bold;font-size: 110%\">한 번</span>뿐이기 때문에 중단하는 것은 피해야 합니다.</div><br/><div>또한 동영상 업로드에 영향을 미칠 수 있으므로 브라우저에서 "뒤로" 또는 "새로 고침" 버튼을 누르지 마십시오.</div>',
  "Candidate_RealInterview_Placeholder": '여기에 답을 입력해주세요',
  "Candidate_RealInterview_Welcome_Checkbox_Label": '내 화면 숨기기 (답변은 계속 녹화됩니다.)',
  "Candidate_RealInterview_Welcome_Confirm": '확인',

  "Candidate_Multiple_Choices_Welcome_Title": "{testName}에 오신 것을 환영합니다!",
  "Candidate_Multiple_Choices_Welcome_Content": '<div>면접을 철저하게 완료하지 않는 한 면접을 <span style=\"font-weight: bold;font-size: 110%\">중단</span> 해서는 안 됩니다. 객관식 질문 테스트를 할 수 있는 기회는 단 <span style=\"font-weight: bold;font-size: 110%\">한 번</span>뿐이기 때문에 중단하는 것은 피해야 합니다.</div><br/><div>테스트를 시작하면 타이머가 시작되고 시간이 다 되거나 "제출" 버튼을 클릭할 때까지 계속됩니다.</div>',

  "Candidate_Short_Question_Welcome_Title": "{testName}에 오신 것을 환영합니다!",
  "Candidate_Short_Question_Welcome_Content": '<div> 면접을 철저하게 완료하지 않는 한 면접을 <span style=\"font-weight: bold;font-size: 110%\">중단</span> 해서는 안 됩니다. 짧은 질문 테스트를 할 수 있는 기회는 단 <span style=\"font-weight: bold;font-size: 110%\">한 번</span>뿐이기 때문에 중단하는 것은 피해야 합니다.</div><br/><div>테스트를 시작하면 타이머가 시작되고 시간이 다 되거나 "제출" 버튼을 클릭할 때까지 계속됩니다.</div>',

  "Candidate_RealInterview_Title": "화상 면접",
  "Candidate_RealInterview_Question": "질문",
  "Candidate_RealInterview_Video": "위의 영상을 시청하시고 이후 질문에 답변해 주십시오.",
  "Candidate_RealInterview_TotalQuestion": "총 면접 질문:",
  "Candidate_RealInterview_NextQuestion": "다음 질문",
  "Candidate_RealInterview_Finish": "종료",
  "Candidate_RealInterview_BackButton": "뒤로' 버튼을 눌러 화상 면접을 종료했습니다.",
  "Candidate_RealInterview_Reject": "죄송합니다. 다른 모든 지원자의 투명성과 공정성을 위해 화상 면접이 중단되었으므로 다시 시작할 수 없습니다. 기술적 문제가 있는 경우 customer-service@neufast.com으로 이메일을 보내주십시오.",
  'Candidate_RealInterview_CheckWebcam_Message': '죄송합니다! 카메라에 런타임 오류가 발생했습니다. 해결해보도록 하겠습니다.',
  "Candidate_RealInterview_Warning": "경고",
  "Candidate_RealInterview_noVoiceWarning":"10초 이상 음성이 감지되지 않았습니다. 목소리를 높이거나 마이크를 확인하세요.",

  "Candidate_Interview_Part": "파트 {number}",
  "Candidate_Interview_Proctoring": "감독",
  "Candidate_Interview_Question_List": "질문 목록",
  "Candidate_Interview_Question": "질문 {questionNo}: {question}",
  "Candidate_Interview_Question_Previous": "이전",
  "Candidate_Interview_Question_Next": "다음",
  "Candidate_Interview_Question_Submit": "제출",
  "Candidate_Interview_Multiple_Choices_Reminder": "*둘 이상의 답변을 선택할 수 있습니다.",

  "Candidate_Multiple_Choices_Title": "객관식 질문",
  "Candidate_Short_Question_Title": "짧은 질문",


  "Candidate_RealInterview_english_Section": "영어 부문",
  "Candidate_RealInterview_cantonese_Section": "광둥어 부문",
  "Candidate_RealInterview_mandarin_Section": "북경어 부문",
  "Candidate_RealInterview_thai_Section": "태국어 부문",
  "Candidate_RealInterview_japanese_Section": "일본어 부문",
  "Candidate_RealInterview_indonesian_Section": "인도네시아어 부문",
  "Candidate_RealInterview_vietnamese_Section": "베트남어 부문",
  "Candidate_RealInterview_khmer_Section": "크메르어 부문",
  "Candidate_RealInterview_malay_Section": "말레이시아어 부문",
  "Candidate_RealInterview_german_Section": "독일어 섹션",
  "Candidate_RealInterview_french_Section": "프랑스어 섹션",
  "Candidate_RealInterview_korean_Section": "프랑스어 섹션",

  "Candidate_RealInterview_cn_en_Section": "광둥어/영어 부문",
  "Candidate_RealInterview_pu_en_Section": "보통화/영어 부문",
  "Candidate_RealInterview_th_en_Section": "태국어/영어 부문",

  "Candidate_RealInterview_english": "영어",
  "Candidate_RealInterview_cantonese": "광둥어",
  "Candidate_RealInterview_mandarin": "북경어",
  "Candidate_RealInterview_thai": "태국어",
  "Candidate_RealInterview_putonghua": "보통화",
  "Candidate_RealInterview_japanese": "일본어",
  "Candidate_RealInterview_indonesian": "인도네시아어",
  "Candidate_RealInterview_vietnamese": "베트남어",
  "Candidate_RealInterview_khmer": "크메르어",
  "Candidate_RealInterview_malay": "말레이시아어",
  "Candidate_RealInterview_german": "독일 사람",
  "Candidate_RealInterview_french": "프랑스 국민",
  "Candidate_RealInterview_korean": "한국인",

  "Candidate_RealInterview_pu_en": "보통화/영어",
  "Candidate_RealInterview_cn_en": "광둥어/영어",


  "Candidate_Language_Change_Dialog": '다음 {noOfQuestion} {measureWord}은(는) {language}로 답변해야 합니다.',
  "Candidate_Language_Gotit": "알겠습니다!",

  "Candidate_Upload_Completed": "% 완료",
  "Candidate_Upload_Thankyou": "모든 질문에 답변해 주셔서 감사합니다!",
  "Candidate_Upload_Wait": "완료된 영상이 업로드되는 동안 기다려주십시오.",
  "Candidate_upload_Complete_Wait": "100% 완료될 때까지 브라우저를 닫지 마십시오.",
  "Candidate_Finish_Continue": "계속",
  "Candidate_Finish_Logout": "로그아웃",
  "Candidate_Finish_Uploading": "완료된 영상이 업로드되고 있습니다. 잠시만 기다려 주십시오....",
  'Candidate_Finish_Redo': '죄송합니다! {numberOfErrors} 개의 질문에 대한 답변이 제대로 녹화되지 않았습니다. \'다음\' 버튼을 눌러 {numberOfErrors} 개의 질문에 대한 답변을 다시 녹화하십시오. 감사합니다.',

  "Candidate_Support_Button": "지원자 지원",
  "Candidate_Support_Title": "화상 면접 및 평가를 위한 지원자 지원",
  "Candidate_Support_Walkthrough": "화상 면접 및 평가 리허설",
  "Candidate_Support_TroubleShooting": "문제 해결",
  "Candidate_Support_Contact": "추가 질문이 있으십니까? <u>customer-service@neufast.com</u>으로 문의하십시오.",
  "Candidate_Support_Back": "뒤로",
  "Candidate_Support_Login_Subtitle": "평가 로그인",
  "Candidate_Support_Login_Msg": "<p>1단계: apisit.neufast.com/candidate에서 지원자의 로그인 페이지에 접속합니다. 면접 및 평가는 최신 Chrome/Firefox 웹 브라우저를 통해 접속할 수 있습니다. Chrome 또는 Firefox 브라우저를 최신 버전으로 업데이트하십시오. 최상의 녹화 성능을 보장하기 위해 WI-FI 연결이 가능한 노트북이나 데스크톱을 사용하는 것이 좋습니다.</p> <p>2단계: 면접 초대 이메일의 이메일 주소와 접근 코드를 입력합니다. 지정된 면접 기간에만 로그인할 수 있습니다.</p>",
  "Candidate_Support_Check_Subtitle": "웹 카메라 및 오디오 확인",
  "Candidate_Support_Check_Msg": "시스템에서 영상 및 오디오 설정 페이지를 열고 웹 카메라, 인터넷 연결, 조명, 마이크 및 스피커 설정을 확인합니다. 웹 카메라와 마이크가 켜져 있고 원활하고 빠른 인터넷 연결이 되어 있는지 확인하십시오.",
  "Candidate_Support_Practice_Subtitle": "화상 면접 및 평가 연습",
  "Candidate_Support_Practice_Msg": "각 평가 유형(화상 면접/객관식 질문/질의응답)에 대해 실제 평가 전에 무작위 연습 질문이 제공됩니다. 연습에서 질문에 답변하기 위해 제공된 레이아웃과 시간은 실제 평가와 동일합니다. 이 기회를 활용하여 시스템을 연습하고 숙지하는 것이 좋습니다. 이 연습 평가는 필요한 만큼 여러 번 수행할 수 있습니다.",
  "Candidate_Support_Record_Subtitle": "면접 및 평가 실시",
  "Candidate_Support_Record_Msg": "연습을 거친 후 평가가 시작될 예정입니다. 구체적인 답변 시간은 채용 담당자가 정합니다. 모든 지원자에게 공정성을 보장하기 위해 모든 평가는 한 번만 수행 할 수 있습니다. 따라서 지원자는 평가 전에 더 많은 연습 테스트를 하는 것이 좋습니다.",
  "Candidate_Support_Tips_Subtitle": "더 나은 영상 녹화 결과를 위한 조언 (화상 면접)",
  "Candidate_Support_Tips_Msg": "채용 담당자를 위한 고품질 영상을 녹화하는 데 도움이 되는 몇 가지 조언이 있습니다.<ul><li>조용한 장소를 찾습니다.</li><li>일반 사진 촬영과 유사하게 충분한 조명과 역광이 없는 상태로 영상을 녹화합니다.</li><li>카메라를 시야에 들어오면서 얼굴에서 약간 더 멀리 떨어지도록 위치를 잡습니다. 자신감을 보여주는 데 도움이 되며 채용 담당자와 정상적인 대화를 하는 것처럼 보일 것입니다.</li></ul>",
  "Candidate_Support_Help_Subtitle": "면접 기술에 대한 더 많은 도움이 필요합니다.",
  "Candidate_Support_Help_Msg": "구직 및 면접에 대한 연습과 조언이 더 필요하십니까? 당사는 구직자들이 면접을 준비하고 진로를 선택할 수 있도록 전 세계의 인증된 커리어 코치와 협력하고 있습니다. 도움이 필요하면 언제든지 customer-service@neufast.com으로 무료 상담을 요청하거나 경력 개발 웹사이트(www.neucareers.com)<a href='http://www.neucareers.com'>를 방문하십시오. </a>.",

  "Candidate_Support_SystemRequirement_Subtitle": "화상 면접 및 평가를 위한 시스템 요구 사항",
  "Candidate_Support_SystemRequirement_Msg": "<p>채용 지원자의 경우 최신 Google Chrome(90 이상), Firefox(88 이상), Safari(14 이상) 및 Chromium Edge(76 이상)가 노트북/데스크톱에서 지원됩니다. 안드로이드에서는 Google Chrome(92 이상), iOS 14 또는 그 이상에서는 Safari 및 Chrome도 지원됩니다. 다른 브라우저는 Google Chrome 브라우저를 설치하는 것이 좋습니다. </p><p>최상의 화상 면접 성능을 얻으려면 최신 Google Chrome 또는 Firefox 브라우저를 사용하여 Windows 또는 MacOS가 설치된 노트북/데스크톱에서 화상 면접을 진행하는 것이 좋습니다. 인터넷 연결이 양호하고 방해(수신 전화 등)가 없는 경우 휴대폰 사용도 가능합니다.</p>",
  "Candidate_Support_AllowAccess_Subtitle": "카메라 및 마이크에 대한 접근 허용",
  "Candidate_Support_AllowAccess_Msg": "<p>면접 및 평가를 수행하려면 웹 카메라와 마이크에 대한 접근 권한이 필요합니다. 영상 및 오디오 설정 페이지에서 지원되는 브라우저를 올바르게 설정한 경우 마이크와 카메라에 대한 접근 권한을 허용하라는 메시지가 표시됩니다. '둘 다 허용'을 클릭합니다. (이 작업은 한 번만 하면 됩니다).</p><p>실수로 카메라 또는 마이크에 대한 접근을 거부한 경우 브라우저를 다시 시작할 수 있으며 브라우저에서 영상 및 오디오 설정 페이지를 다시 열면 접근 권한을 허용하라는 메시지가 다시 표시됩니다. </p>",
  "Candidate_Support_Speaker_Subtitle": "스피커 켜기",
  "Candidate_Support_Speaker_Msg": "의무 사항은 아니지만 스피커를 활성화하면 시스템에서 면접 질문을 읽어주어 보다 매력적인 면접 경험을 만들 수 있습니다. 영상 및 오디오 설정 중에 테스트할 수 있습니다.",
  "Candidate_Support_NetworkQuality_Subtitle": "네트워크 품질 문제 해결",
  "Candidate_Support_NetworkQuality_Msg": "<p>영상 녹화의 품질을 높이려면 면접 전에 기기가 인터넷에 연결되어 있어야 합니다.</p><p>원활한 영상 및 오디오 업로드를 위해 1Mbps 이상의 일관된 업로드 속도가 있어야 하며 일반적으로 유선전화 또는 WI-FI 네트워크를 사용하는 경우 이 속도에 도달할 수 있습니다.</p><p>사용자 연결 속도를 확인하려면 speedtest.net을 사용하십시오.</p><p>휴대폰에서 셀룰러 네트워크를 사용하는 경우 데이터 전송을 개선하기 위해 녹화 해상도를 줄입니다. 하지만 녹화하는 도중에도 문제가 있을 수 있습니다. 다음 조언을 통해 더 나은 품질의 연결에 접근하는 것이 좋습니다:</p><ul><li>Wi-Fi 사용자의 경우 기기의 신호가 강하고 라우터가 인터넷에 연결되어 있는지 확인하십시오. Wi-Fi 라우터 근처에 기기를 놓거나 라우터를 재시작해 볼 수도 있습니다.</li><li>휴대폰 사용자의 경우 신호가 더 강한 위치를 찾으십시오.</li><li>신호 관련 문제는 인터넷 서비스 제공업체에 문의하십시오.</li></ul>",
  "Candidate_Support_CameraIssues_Subtitle": "카메라 문제 해결",
  "Candidate_Support_CameraIssues_Msg": "<p>카메라 문제를 해결하려면 다음 방법을 시도해 보십시오:</p><ul><li>카메라에 대한 접근을 허용해야 합니다.</li><li>Chrome 브라우저를 사용하고 브라우저가 최신 버전인지 확인합니다.</li><li>업데이트된 브라우저로 기기를 다시 시작합니다.</li><li>시스템 설정을 확인하여 카메라가 올바르게 설치되었으며 접근할 수 있는지 확인합니다.</li><li>문제가 지속되면 웹 카메라 제조업체에 문의하십시오.</li></ul>",
  "Candidate_Support_MicrophoneIssues_Subtitle": "마이크 문제 해결",
  "Candidate_Support_MicrophoneIssues_Msg": "<p>마이크가 작동하지 않으면 다음 방법을 시도해 보십시오:</p><ul><li>마이크에 대한 접근을 허용했는지 확인하십시오.</li><li>마이크가 음소거되지 않았는지 확인하고 켜져 있는지 확인합니다.</li><li>시스템 설정에서 마이크가 기본 녹음 장치인지 확인하고 올바른 녹음 수준이 설정되어 있는지 확인합니다.</li><li>기기를 다시 시작합니다.</li><li>위의 모든 수정 사항에도 불구하고 계속 유사한 문제가 발생하는 경우 마이크 제조업체에 문의하십시오.</li></ul>",
  "Candidate_Support_AboutNeufast_Subtitle": "Neufast 소개",
  "Candidate_Support_AboutNeufast_Msg": "Neufast는 온라인 화상 채용 면접의 리더이자 전문가로 채용 담당자가 더 빨리 적합한 인재를 찾을 수 있도록 돕고 인재들이 더 빠르고 공정하게 채용 제안을 받을 수 있도록 도와줍니다. 또한 영상 기반 면접을 통해 지원자는 대화 또는 텍스트 기반 평가를 넘어 자신의 능력을 보여줄 수 있습니다. 채용 담당자는 또한 효과적인 방식으로 지원자를 종합적으로 평가할 수 있습니다.",
  "Candidate_Support_FAQ_Subtitle": "FAQ",
  "Candidate_Support_FAQ_Msg": "<ul><li><p>일방향 화상 면접 평가란 무엇입니까?</p><p>화상 면접은 일방향 온라인 면접입니다. 채용 담당자가 귀하를 면접에 초대하면 온라인으로 시스템에 접속하여 자동으로 면접을 수행할 수 있습니다. 면접은 미리 녹화되어 있습니다. 이를 통해 더 많은 지원자가 이력서를 바탕으로 평가받는 대신 잠재적 고용주에게 자신의 능력과 야망을 보여줄 수 있는 기회를 가질 수 있습니다.</p></li><br/><li><p>면접 시스템에서 어떤 기기를 사용할 수 있습니까?</p><p>채용 지원자의 경우 최신 Google Chrome(90 이상), Firefox(88 이상), Safari(14 이상) 및 Chromium Edge(76 이상)가 노트북/데스크톱에서 지원됩니다. 안드로이드에서는 Google Chrome(92 이상)도 지원됩니다. IE 또는 Safari 및 기타 브라우저 사용자는 Google Chrome 브라우저를 설치하는 것이 좋습니다. iPhone/iPad 사용자는 App Store에서 Neufast 면접 앱을 다운로드하여 면접을 수행해야 합니다.</p><p>최상의 화상 면접 성능을 얻으려면 최신 Google Chrome 또는 Firefox 브라우저를 사용하여 Windows 또는 MacOS가 설치된 노트북/데스크톱에서 화상 면접을 진행하는 것이 좋습니다. 인터넷 연결이 양호하고 방해(수신 전화 등)가 없는 경우 휴대폰 사용도 가능합니다.</p></li><br/><li><p>전 노트북이 없습니다. 휴대폰을 사용해도 되나요?</p><p>네. 하지만 휴대폰 인터넷 연결은 안정성이 훨씬 떨어집니다. WI-FI 연결이 강한 좋은 위치를 찾는 것이 좋습니다. 또한 안드로이드 폰만 지원됩니다. iOS 사용자는 일반적으로 노트북을 사용하는 것이 좋습니다.</p></li><br/><li><p>제 모바일에는 3G 연결만 되어 있습니다. 문제가 될까요?</p><p>서비스가 좋은 Wi-Fi/4G를 사용하는 것이 좋습니다. 3G를 사용하면 업로드 시간이 길어지고 동영상 품질이 떨어질 수밖에 없습니다. 이것이 유일한 옵션인 경우 경우 업로드 속도가 가장 빠른 지점을 찾은 다음 영상 및 오디오 설정 페이지에서 네트워크 상태를 테스트하는 것이 좋습니다.</p></li><br/><li><p>몇 번이나 면접을 볼 수 있나요?</p><p>면접은 한 번만 응시할 수 있습니다. 그렇긴 하지만 시스템에 익숙해지고 싶은 만큼 연습 면접을 얼마든지 할 수 있습니다.</p></li><br/><li><p>이 화상 면접은 얼마나 걸립니까?</p><p>채용 담당자가 설정한 질문 수에 따라 달라집니다.보통 30분 미만입니다.</p></li></ul>",

  "Candidate_AppSupport_PP_Title": "개인 정보 보호 정책 성명서 (PPS)",
  "Candidate_AppSupport_TC_Title": "이용 약관 (T&C)",

  "Button_Yes": '확인',
  "Button_No": '취소',
  "Deparment": "부서",
  "Job": "직무",
  "Candidate": "지원자",
  "Understand": "이해",
  "Name": "이름",
  "Email": "이메일",
  "Current_Deadline": "현재 마감일",
  "Interview_Status": "면접 상태",
  "Close": "닫기",
  "Minutes": "분",
  "Minute": "분",
  "Second": '초',
  "Seconds": '초',
  "Question": "질문",
  "Questions": "질문",
  "Or": "또는",
  'Back': '뒤로',
  'Start': '시작',

  'Record_Control_Error_Msg': "카메라/오디오 장치에 접근할 수 없습니다. 활성화되어 있거나 다른 애플리케이션에서 사용하지 않는지 확인하십시오..",


  "Shortlisted": "최종 후보자로 선정됨",
  "Rejected": "탈락",
  "Waiting_Listed": "대기자 명단",
  "Pending": "초대 대기 중...",
  "Waiting_Invitation": "초대 전송됨, 면접 대기 중",
  "Processing": "영상 처리 중...",
  "Completed": "완료됨",
  "Partially_Completed": "부분적으로 완료됨",
  "No_Quota": "할당량 초과",

  "Login_HiAdmin": "Neufast CMS에 오신 것을 환영합니다.",

  "Recruiter_Review_Title": "검토 중인 지원자",
  "Recruiter_Dashboard_TableColumn_ProgrammeName": "프로그램 이름",
  "Recruiter_Dashboard_TableColumn_JobName": "직무명",
  "Recruiter_Dashboard_TableColumn_InterviewLanguage": "면접 언어",
  "Recruiter_Dashboard_TableColumn_Last_Video": "마지막 동영상",
  "Recruiter_Dashboard_TableColumn_First_Video": "첫 번째 동영상",
  "Recruiter_Dashboard_TableColumn_Num_Of_Video": '업로드한 동영상 수',
  "Recruiter_Dashboard_TableColumn_Export": "내보내기",
  "Review_Evaluation_Title": "검토자 평가",
  "Recruiter_Skills_Openness": "개방성",
  "Recruiter_Skills_Conscientiousness": "성실성",
  "Recruiter_Skills_Extraversion": "외향성",
  "Recruiter_Skills_Agreeableness": "합의가능성",
  "Recruiter_Skills_Neuroticism": "신경증적 경향",
  "Recruiter_Review_Instruction": "이 페이지는 검토 중인 지원자를 나열합니다.",
  'Recruiter_Review_List_Files_Failure_Msg': '파일 검색 실패',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Title': 'S3에서 파일 전송',
  'Recruiter_Review_Transfer_S3_Files_Dialog_LocalFiles': '당사 저장소에 있는 파일',
  'Recruiter_Review_Transfer_S3_Files_Dialog_S3Files': 'S3에 있는 파일',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Success_Msg': '선택한 파일이 성공적으로 복사되었습니다.',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Failure_Msg': '선택한 파일을 복사하는 데 실패했습니다',
  'Question_Number': '질문 번호',
  'Filename': '파일 이름',
  'Filesize': '파일 크기',
  'Candidate_Interview_Finish_Message': '{interview_name} ({interview_type})을(를) 완료해 주셔서 감사합니다.',
  'Candidate_Continue_Message': '{interview_name} ({interview_type}를 진행해 주십시오.',
  'interview': '면접',
  "TextField_Required": "* 필수",
  'Happy': '행복',
  'Sad': '슬픔',
  'Fear': '두려움',
  'Surprise': '놀람',
  'Neutral': '중립',
  'Grimace': '찡그림',
  'Pouty': '뾰로통함',


  "Recruiter_Interview_Monitor_Title": "진행 중인 면접에 따른 채용 정보",
  "Recruiter_Interview_Monitor_Hintbox_Message": "이 페이지는 면접 마감일 전에 '대기 중인 초대' 및 '대기 중인 면접'에 있는 지원자의 채용 정보를 보여줍니다.",
  "Recruiter_Interview_Monitor_TableColumn_RecruiterName": "채용 담당자 이름",
  "Recruiter_Interview_Monitor_TableColumn_RecruiterEmail": "채용 담당자 이메일",
  "Recruiter_Interview_Monitor_TableColumn_JobTitle": "직업 Id",
  "Recruiter_Interview_Monitor_TableColumn_InterviewDeadline": "면접 마감일",
  "Recruiter_Interview_Monitor_TableColumn_Total_Num_Of_Candidates": "지원자 총 수",
  "Recruiter_Interview_Monitor_TableColumn_Completion_Rate": "완료율",
  "Recruiter_Interview_Monitor_TableColumn_Num_Of_Invited_Candidates": "초대된 지원자 수",
  "Recruiter_Interview_Monitor_TableColumn_Num_Of_Pending_Invitations": "보류 중인 초대 수",
  "Recruiter_Interview_Monitor_Job": "채용 {count}건",



  "TC_Header": "이용 약관",
  "TC_Top_Section": "웹사이트 neufast.com ('웹사이트') 의 콘텐츠에 대한 접근 및 사용은 Neufast Limited ('회사')에서 제공하며 다음 약관의 적용을 받습니다. 귀하는 본 웹사이트의 이용에 있어 귀하가 본 이용 약관에 동의하는 것으로 간주되며 이는 귀하가 본 웹사이트를 처음 사용한 날로부터 효력이 발생합니다. 회사는 언제든지 온라인으로 변경 사항을 게시하여 본 이용 약관을 변경할 권리를 보유하며 이용 약관이 귀하에게 적용되므로 주기적으로 이 페이지를 방문하여 이용 약관을 검토하시기 바랍니다. 변경 사항이 게시된 후에도 웹사이트를 계속 사용하는 것은 변경된 변경 사항에 따라 본 이용 약관에 동의하는 것으로 간주됩니다. 여기에서 '귀하' 및 '사용자'라는 용어는 어떠한 이유 또는 목적을 위해 언제든지 웹사이트에 접근 및/또는 사용하는 모든 개인 및/또는 단체를 의미합니다.",
  "TC_Content_1": "웹사이트 사용",
  "TC_Content_1.1": "귀하는 합법적인 목적으로만 웹사이트를 사용하고 제3자의 권리를 침해하지 않거나 웹사이트의 사용 및 향유를 제한하거나 금지하지 않는 방식으로 사용하는 데 동의합니다. 이는 불법 행위 또는 다른 사람을 괴롭히거나 고통 또는 불편을 초래할 수 있는 행위, 외설적이거나 공격적인 콘텐츠의 전송 또는 웹사이트 내에서 정상적인 대화 흐름을 방해하는 행위를 포함하되 이에 국한되지 않습니다.",
  "TC_Content_1.2": "다른 사람의 지적 재산권을 침해하기 위해 웹사이트를 사용해서는 안 됩니다.",
  "TC_Content_1.3": "웹사이트를 사용하여 위협, 괴롭힘, 명예 훼손, 불법, 유해, 외설, 비방 또는 기타 모욕적이거나 불쾌한 자료를 전송, 알림, 업로드, 게시, 배포 또는 저장해서는 안 됩니다.",
  "TC_Content_1.4": "귀하는 웹사이트의 서버의 정상적인 작동을 방해하기 위해 소프트웨어, 도구 또는 프로그램을 사용하거나 달리 행동해서는 안됩니다.",
  "TC_Content_1.5": "웹사이트의 시스템을 의도적으로 또는 고의적으로 과부하해서는 안 됩니다.",
  "TC_Content_1.6": "귀하는 컴퓨터 바이러스 또는 손상 프로그램을 웹사이트 및 그 회원에게 전송해서는 안됩니다.",
  "TC_Content_1.7_Title": "특정 사용자 - 구직자",
  "TC_Content_1.7_a": "웹사이트에서 일자리를 구하는 사용자('구직자')는 로그인 아이디와 비밀번호를 신중하게 유지하고 다른 사람에게 공개하지 않을 것에 동의합니다. 구직자는 로그인 아이디와 비밀번호의 기밀 유지 및 (승인 또는 허가되지 않은)사용에 대한 전적인 책임이 있습니다. 구직자는 이를 무단으로 사용하는 경우 회사에 즉시 통보하는 데 동의합니다.",
  "TC_Content_1.7_b": "구직자는 불완전하거나 거짓이거나 부정확한 이력서 정보를 웹사이트 또는 회사에 게시해서는 안됩니다.",
  "TC_Content_1.7_c": "구직자가 웹사이트에 제출하는 모든 정보는 합법적이고 적절하며 차별이 없고 진실해야 합니다. 구직자는 웹사이트 또는 회사에 제출한 콘텐츠 및 자료에 대한 전적인 책임이 있습니다.",
  "TC_Content_1.7_d": "구직자는 광고된 직무에 지원하는 것 이외의 어떠한 이유로도 고용 기회에 응답할 수 없습니다.",
  "TC_Content_1.7_e": "구직자들이 제출한 이력서는 직원을 구하는 데 있어 사용자 또는 광고주('고용주')에게 관련 정보를 제공하기 위한 목적입니다.",
  "TC_Content_1.7_f": "구직자가 제출한 개인 정보는 구직자가 고용주 및 웹사이트 또는 회사의 채용 담당자와 적절한 고용을 모색할 수 있도록 지원할 목적으로 사용됩니다. 구직자는 채용 공고에 지원하거나 회사의 이력서 데이터베이스에 개인 이력서를 저장하려고 할 때 고용주 및/또는 웹사이트 및 회사의 채용 담당자에게 개인 정보를 공개하며 이 모든 것은 구직자의 승인을 받습니다.",
  "TC_Content_1.7_g": "구직자가 웹사이트 또는 회사에 제출한 모든 정보는 회사의 개인 정보 보호 정책 설명서의 적용을 받습니다.",
  "TC_Content_1.7_h": "구직자는 고용주에게 제공된 개인 데이터 또는 정보가 전적으로 본인의 책임 하에 제공됨을 수락합니다. 고용주가 구직자의 개인 정보를 직원을 찾는 것 이외의 용도로 사용하는 경우 회사는 어떠한 경우에도 책임을 지지 않습니다.",
  "TC_Content_1.7_i": "구직자는 이력서를 웹사이트를 통해 광고하는 고용주에게 직접 보낼 수 있습니다. 또는 구직자는 구인 광고에 대한 회신으로 웹사이트를 통해 회사에 이력서를 보낼 수 있습니다. 이러한 경우 법적 요구 사항에 따라 구직자의 이력서는 구직자가 삭제를 요청하지 않는 한 본 서비스의 비활성화에도 불구하고 사전 결정된 기간 동안 웹사이트에 보관됩니다. 그 후 구직자의 책임 하에 회사의 데이터베이스에 저장됩니다.",
  "TC_Content_1.7_j": "구직자는 자신의 이력서를 회사의 데이터베이스에 저장할 수 있지만 고용주가 이력서를 검색하는 것은 허용하지 않습니다. 이러한 경우 구직자는 자신의 이력서를 사용하여 온라인으로 구직을 신청할 수 있지만 고용주 및 채용 담당자는 회사의 데이터베이스를 통해 접근할 수 없습니다.",
  "TC_Content_1.7_k": "구직자가 '지원자 매칭' 기능에 참여하여 잠재 고용주에게 자신의 이력서를 공개하는 데 동의하면 회사에 광고를 게재하거나 회사 서비스에 가입한 모든 고용주 및 채용 담당자는 자신의 이력서에 접근할 수 있습니다. 회사는 구직자 정보를 식별할 수 없는 고용주 및 채용 담당자에게 공개하지 않습니다. 구직자가 제공한 개인 정보는 회사의 개인 정보 수집 성명서 및 개인 정보 보호 정책 성명서에 따라 엄격하게 사용됩니다.",
  "TC_Content_1.7_l": "구직자가 제출한 이력서 또는 개인 정보는 직원을 구하는 데 있어 고용주에게 관련 정보를 제공하기 위한 목적입니다.",
  "TC_Content_1.7_m": "구직자가 제출한 개인 정보는 구직자가 고용주 및 웹사이트 또는 회사의 채용 담당자와 적절한 고용을 모색할 수 있도록 지원할 목적으로 사용됩니다. 구직자는 채용 공고에 지원하거나 회사의 이력서 데이터베이스에 개인 이력서를 저장하려고 할 때 회사의 채용 담당자에게 개인 정보를 공개하며 이 모든 것은 구직자의 승인을 받습니다.",
  "TC_Content_1.7_n": "회사는 고용주, 고용 관리자, 헤드헌터, 인사 전문가 및 회사의 내부 권한이 있는 직원에게만 데이터베이스에 대한 접근 권한을 부여하기 위해 최선을 다해야 하지만 회사는 다른 당사자가 회사의 동의 없이 데이터베이스에 대한 접근 권한이 없음을 보장하지 않습니다. 모든 구직자는 언제든지 자신의 이력서 열람을 중단할 수 있습니다. 그러나 구직자는 고용주 및 기타 다른 방식으로 데이터베이스에 접근할 수 있는 당사자가 구직자의 이력서 사본을 자신의 파일이나 데이터베이스에 보관했을 수 있음을 인정합니다. 회사는 이러한 사례에서 이력서의 유지, 사용 또는 개인 정보 보호, 또는 이력서가 데이터베이스에 있는 동안 당사자가 이력서를 사용하거나 개인 정보 보호에 대해 책임을 지지 않습니다.",
  "TC_Content_1.7_o": "구직자가 '지원자 매칭' 기능에 참여하지만 고용주가 이력서를 검색하는 것을 허용하지 않는 경우, 회사는 구직자의 요구 사항을 충족하는 채용 공고가 있으면 구직자에게 채용 정보를 보냅니다. 이러한 경우 구직자의 이력서는 구인 공고를 제공하는 고용주에게 공개되지 않을 것입니다.",
  "TC_Content_1.7_p": "구직자는 구직 활동을 위해 구직 정보가 필요한 지인에게 웹사이트의 구인 정보를 보낼 수 있지만 다른 용도로 사용하거나 이 기능을 남용해서는 안 됩니다.",
  "TC_Content_1.7_q": "개인 정보(개인 정보 보호) 조례에 따라 구직자는 회사와 함께 보관된 자신의 개인 정보에 접근할 수 있으며 언제든지 이러한 개인 정보를 변경하거나 수정할 수 있습니다. 모든 열람 또는 정정 요구는 회사에 서면으로 요청을 보내 요청할 수 있습니다. 자세한 사항은 개인정보수집내역서 및 개인정보취급방침을 참고하시기 바랍니다. 또한 또는 대안으로 구직자(사전 본인 확인 필수)는 언제든지 웹사이트에서 자신의 개인 정보를 직접 변경하거나 수정할 수 있습니다.",
  "TC_Content_1.8": "특정 용도 - 고용주",
  "TC_Content_1.8_a": "회사 및/또는 회사가 정한 기타 이용 약관(있을 경우)에 따라 서비스 수수료를 지불하면 고용주는 특정 기간 동안 웹사이트를 통해 채용 공고를 광고할 수 있습니다. 고용주는 광고에 포함된 내용과 자료에 대한 전적인 책임을 집니다. 회사는 적합하다고 판단되는 모든 광고를 편집할 권리를 보유합니다.",
  "TC_Content_1.8_b": "구직자 정보 접근과 관련하여 회사가 수시로 규정한 조건 또는 요구 사항에 따라 고용주는 회사가 관리하는 구직자 데이터베이스에 접근할 수 있지만 모든 정보가 잠재적 직원을 구하는 목적으로만 사용되며 해당 구직자의 사전 동의 없이 해당 정보를 다른 당사자에게 공개하지 않는다는 데 동의합니다.",
  "TC_Content_1.9": "특정 용도 - 신입 졸업생",
  "TC_Content_1.9_a": "사용자는 웹사이트의 '오픈 포럼'에 게시한 연설문, 메시지 및 첨부 파일(해당되는 경우)의 내용과 그로 인해 발생하는 모든 결과에 대해 전적으로 책임을 집니다.",
  "TC_Content_1.9_b": "사용자가 웹사이트의 '오픈 포럼'에 게시하는 기사, 의견 및/또는 콘텐츠의 테마는 토론, 연구 또는 의견 표현의 성격이어야 합니다. 명예훼손, 저속하고 음란한 언어 사용은 엄격히 금지됩니다. 모든 기사의 내용은 본질적으로 타인에게 상품 및 서비스 권유, 광고 또는 타인의 명예를 훼손해서는 안 됩니다. 회사는 본 약관을 위반하는 '오픈 포럼'의 자료 및 콘텐츠를 변경하거나 삭제할 권리를 보유하며 이로 인한 손실 또는 손해에 대해 회사는 책임을 지지 않습니다.",
  "TC_Content_2_Title": "미성년자",
  "TC_Content_2": "18세 미만 또는 미성년자로 간주되거나 법적 책임을 지지 않는 경우 웹사이트를 사용할 수 없습니다. 웹사이트를 보고 접근하려면 이 약관의 의미와 결과에 대해 부모 또는 보호자에게 조언을 구해야 합니다. 회사는 웹사이트의 모든 사용자가 법정 연령인 것으로 추정합니다. 회사는 귀하의 연령을 확인할 의무가 없지만 웹사이트의 사용자가 법적 연령이 아닌 것으로 밝혀진 경우 회사는 웹사이트에 대한 접근을 중단할 권리를 포함하여 해당 사용자 또는 해당 사용자의 부모 또는 보호자에 대해 사용할 수 있는 권리를 보유합니다.",
  "TC_Content_3": "보증 및 책임",
  "TC_Content_3.1": "웹사이트와 여기에 제공된 정보는 법률이 허용하는 최대한의 범위 내에서 명시적 또는 묵시적으로 어떠한 종류의 보증도 없이 '있는 그대로' 제공됩니다.",
  "TC_Content_3.2": "회사는 상품성, 주요 제품 또는 서비스의 가용성, 특정 목적에의 적합성 및 비침해성에 대한 보증을 포함하여 명시적이든 묵시적이든 모든 보증을 부인합니다.",
  "TC_Content_3.3": "회사는 웹사이트의 자료, 콘텐츠 또는 정보의 정확성, 신뢰성, 완전성 또는 적시성에 대해 보증하지 않습니다.",
  "TC_Content_3.4": "회사는 웹사이트 내용의 오류 또는 누락, 삭제, 잘못된 전달 또는 사용자 커뮤니케이션 또는 개인화 설정을 저장하지 못한 것에 대해 책임지지 않습니다.",
  "TC_Content_3.5": "회사는 웹 사이트에 오류가 없을 것이라는 점, 웹사이트 및 해당 서버에 컴퓨터 바이러스 또는 기타 유해한 메커니즘이 없을 것이라는 점, 모든 결함이 수정될 것이라는 점, 또는 웹사이트의 운영이 중단되지 않고 시기적절하며 안전할 것이라는 점을 보증하지 않습니다. 귀하의 웹사이트, 상품 또는 자료 사용으로 인해 기기 또는 데이터의 서비스 또는 교체가 필요한 경우 회사는 그러한 비용에 대해 책임을 지지 않습니다.",
  "TC_Content_3.6": "모든 사용자는 전적으로 자신의 책임 하에 회사의 웹사이트 및 이를 통해 접근할 수 있는 기타 웹사이트를 사용합니다. 귀하는 자신의 커뮤니케이션에 대한 책임이 있으며 게시물의 결과에 대한 책임은 귀하에게 있습니다. 회사는 다른 사용자가 게시한 커뮤니케이션의 진실성, 정확성 또는 신뢰성을 대표하거나 보장하지 않으며 사용자가 표현한 의견을 보증하지 않습니다. 다른 사용자가 게시한 자료에 대해 의존하는 것은 사용자 본인의 책임입니다. 회사는 본 계약을 위반하거나 법률을 위반한 경우 언제든지 사용자를 추방하고 웹사이트에 대한 추가 접근을 방지할 권리를 보유하며 회사가 단독 재량으로 허용할 수 없거나 악용하거나 불법적이거나 방해가 된다고 판단하는 메시지 또는 자료를 웹사이트에서 제거할 권리를 보유합니다.",
  "TC_Content_3.7": "웹사이트에는 타사 웹사이트 링크가 포함될 수 있습니다. 이러한 정보는 사용자에게 편의를 제공하기 위한 목적으로만 제공되며 타사 웹사이트의 콘텐츠에 대한 회사의 보증으로 제공되지 않습니다. 사용자가 링크된 타사 웹사이트에 접근하는 경우 전적으로 본인의 책임입니다. 회사는 자사 웹사이트에 링크된 타사 웹사이트의 콘텐츠에 대해 책임을 지지 않으며 해당 타사 웹사이트의 콘텐츠 또는 자료의 정확성에 대해 어떠한 진술이나 보증도 하지 않습니다. 또한 사용자가 웹사이트에 게시한 모든 자료 또는 세부 정보는 웹사이트에 링크된 다른 웹사이트의 사용자가 볼 수 있으며 회사는 웹사이트에 게시된 정보 또는 자료의 링크된 제3자 웹사이트에서 사용자 또는 제3자가 부적절하게 사용한 것에 대해 책임을 지지 않습니다.",
  "TC_Content_3.8": "어떠한 경우에도 회사 또는 웹사이트에 언급된 제3자는 웹사이트, 상품 및 자료를 사용하거나 사용할 수 없거나 성능 장애, 오류, 누락, 중단, 삭제, 결함, 운영 또는 전송 지연, 컴퓨터 바이러스, 통신 회선 장애, 온라인 차단 통신, 소프트웨어 또는 하드웨어 문제(데이터 손실 또는 호환성 문제를 포함하되 이에 국한되지 않음), 웹사이트의 도난, 파괴 또는 변경, 계약 위반, 불법 행위, 태만 또는 직간접적으로 발생하는 기타 모든 원인 웹사이트의 사용 또는 데이터, 텍스트, 이미지 또는 기타 자료나 정보를 웹사이트로 또는 웹 이트에서 업로드, 다운로드 또는 게시하고 회사가 그러한 손해의 가능성에 대해 조언을 받았는지 여부 등으로 인한 모든 손해 또는 손상(우발적 및 결과적 손해, 이익 손실 또는 데이터 손실 또는 비즈니스 중단으로 인한 손해를 포함하되 이에 국한되지 않음)에 대해 (법률이 허용하는 한도 내에서)책임을 지지 않습니다.",
  "TC_Content_3.9_i": "회사는 또한 본 웹사이트에 대한 귀하의 접근 및 사용과 관련하여 어떠한 책임도 지지 않습니다: ",
  "TC_Content_3.9_ii": "• 바이러스, 악성코드 또는 기타 유해한 구성 요소의 부재",
  "TC_Content_3.9_iii": "• 기술적 결함의 부재",
  "TC_Content_3.9_iv": "• 홍콩 및 기타 지역 및 관할권에서의 이용 가능 여부 및 접근",
  "TC_Content_3.9_v": "귀하는 본 웹사이트, 콘텐츠 및 도구의 사용과 관련하여 귀하의 관할권에서 적용되는 모든 법률을 준수할 책임이 있습니다.",
  "TC_Content_4_Title": "배상",
  "TC_Content_4": "모든 사용자는 웹사이트 사용 또는 본 계약 약관 위반으로 인해 발생하는 모든 청구, 조치, 요구, 손실 또는 손해로부터 회사, 임원, 이사, 직원 및 대리인을 면책하는데 동의합니다. 회사는 관련 사용자에게 이러한 청구, 소송 또는 소송에 대한 신속한 통지를 제공해야 합니다.",
  "TC_Content_5_Title": "광고주와의 거래",
  "TC_Content_5": "관련 상품이나 서비스의 결제 및 배송, 기타 거래와 관련된 조건, 보증 또는 진술 등을 포함하여 웹사이트에서 또는 웹사이트를 통해 발견된 광고주와의 서신 또는 비즈니스 거래 또는 프로모션 참여는 전적으로 귀하와 광고주 사이에 있습니다. 귀하는 그러한 거래의 결과 또는 웹사이트에 광고주의 존재로 인해 발생하는 모든 종류의 손실 또는 손해에 대해 회사가 책임을 지지 않는다는 것에 동의합니다.",
  "TC_Content_6": "다른 사용자와의 거래",
  "TC_Content_6.1": "회사는 공정한 구인 및 채용 서비스를 제공하기 위해 최선의 노력을 기울이고 고용주와 직원 간에 교환되는 정보를 지원하는 매체를 대표하지만 회사는 구인자와 고용주 사이의 거래에 관여하지 않을 것이며 회사는 채용 서비스의 품질, 보안 및 정당성에 대해 책임을 지지 않습니다.",
  "TC_Content_6.2": "회사는 구직자가 제공한 정보 및/또는 이력서 및 고용주가 제공한 채용 광고의 정확성을 보증하지 않습니다.",
  "TC_Content_6.3": "회사는 고용주가 관련 급여를 지급할 수 있는지 또는 구직자가 업무를 수행할 능력이 있는지에 대해 책임을 지지 않습니다.",
  "TC_Content_6.4": "고용주와 구직자 사이에 분쟁이 발생하는 경우 고용주는 이를 자체적으로 해결해야 하며 회사는 분쟁에 대해 책임을 지지 않습니다.",
  "TC_Content_7": "해지",
  "TC_Content_7.1": "사용자가 제공한 정보가 부정확하거나 법률을 위반하거나 음란한 요소를 포함하는 경우 회사는 예고 없이 즉시 사용자의 계정을 폐지하며 회사는 해당 사용자에 대한 법적 조치를 취하는 것을 포함하되 이에 국한되지 않는 적절하고 올바르거나 필요한 조치를 취할 권리를 보유합니다.",
  "TC_Content_7.2": "회사는 사용자가 본 계약에 포함된 조건을 위반했다는 의견이 있거나 회사가 적절하거나 올바르거나 필요하다고 판단하는 추가 조치를 취하는 경우 회사가 제공하는 웹사이트 또는 서비스에 대한 사용자의 접근을 사전 통지 없이 즉시 종료하거나 중지할 권리를 보유합니다.",
  "TC_Content_7.3": "회사는 사용자 및/또는 구직자 및/또는 고용주가 본 계약의 조건을 위반했는지 여부를 결정할 최종적이고 절대적인 재량권을 보유합니다.",
  "TC_Content_8": "지적 재산권",
  "TC_Content_8.1": "웹사이트에 포함된 모든 정보, 그래픽, 텍스트, 이미지 콘텐츠 및 디자인은 회사의 재산이며 저작권 및/또는 기타 지적 재산권에 의해 보호됩니다. 웹사이트에 접근 시 사용자는 콘텐츠를 자신의 개인 비상업적 용도로만 다운로드할 수 있음에 동의합니다.",
  "TC_Content_8.2": "사용자는 회사의 사전 서면 동의 없이 어떠한 목적으로도 웹사이트의 콘텐츠를 복사, 복제, 전송, 유포, 판매, 배포, 방송, 유통, (모든 매체에서) 저장, 개작 또는 변경할 수 없습니다.",
  "TC_Content_9": "일반",
  "TC_Content_9.1": "본 이용 약관 중 하나 이상 또는 해당 약관의 적용이 어떤 이유로든 무효, 불법 또는 시행 불가능한 것으로 간주되는 경우 다른 측면에서 해당 약관 또는 조건의 타당성, 적법성 및 집행 가능성 및 나머지 약관은 어떠한 방식으로도 손상되지 않습니다.",
  "TC_Content_9.2": "본 이용 약관에 따른 권리 또는 구제책을 행사하지 못하거나 지체하는 것은 포기로 해석되거나 운영되지 않으며 당사가 제공하는 권리 또는 구제책의 단일 또는 부분적 행사가 당사가 제공하는 권리 또는 구제책의 추가 행사를 배제하지 않습니다.",
  "TC_Content_9.3": "당사는 본 약관에 포함된 권리 및 의무의 일부 또는 전부를 언제든지 당사자에게 양도할 수 있습니다.",
  "TC_Content_9.4": "본 일반 이용 약관 및/또는 특정 자료와 관련하여 본 사이트에 표시되는 규칙 및/또는 특정 이용 약관이 상충하는 경우 후자가 우선합니다.",
  "TC_Content_9.5": "본 약관 및 귀하의 회사 웹사이트 사용으로 인해 또는 부수적으로 발생하는 모든 분쟁 또는 문제는 홍콩특별행정구의 법률의 적용을 받으며 귀하와 회사는 홍콩특별행정구의 법원에 제출하는 데 동의합니다.",

  "PPS_Header": "개인 정보 보호 정책 ('PPS')",
  "PPS_Top_Section": "Neufast Limited('회사') 는 개인 정보를 존중하며 개인 정보(개인 정보 보호) 조례('조례')의 정보 보호 원칙 및 모든 관련 조항을 준수하기 위해 최선을 다하고 있습니다. 정보는 회사의 웹사이트 서비스 Neufast.com(이하 '사이트')에 의해 수집됩니다. 회사의 PPS는 취급하는 개인 정보와 관련된 데이터 사용자의 개인 정보 보호 정책 및 관행에 대한 일반적인 진술입니다.",
  "PPS_Content_1_i": "정책 준칙",
  "PPS_Content_1_ii": "개인 정보를 회사에 제공하는 개인의 정보 보호 이익을 보호하기 위한 회사의 전반적인 약속.",
  "PPS_Content_1_iii": "Neufast는 개인 정보 보호를 존중하고 개인 정보(개인 정보 보호) 조례(PDPO) 및 개인 정보 보호 위원회(PCPD))가 때때로 발행하는 관련 실행 규범을 준수합니다.",
  "PPS_Content_2_i": "관행 준칙",
  "PPS_Content_2_ii": "사용자는 사이트를 사용하는 과정에서 개인 정보 및/또는 데이터를 공개하거나 제공하도록 요청할 수 있습니다. 사이트에서 제공하는 다양한 서비스를 이용하고 즐기기 위해 이용자는 회사에 자신의 개인 정보 및/또는 데이터를 제공해야 할 수 있습니다. 사용자는 사이트에서 요청한 대로 정보 및/또는 데이터를 제공할 의무가 없지만 회사는 사용자가 그렇게 하지 않는 경우 사이트에서 특정 서비스를 렌더링할 수 없습니다.",
  "PPS_Content_2_iii": "사용자는 사용자가 회사에 제공하는 모든 정보가 자발적으로 제공되며 정확하고 진실하며 최신이고 완전하다는 데 동의합니다. 이러한 상황이 아니거나 회사가 의심할 만한 합리적인 이유가 있는 경우 회사는 사용자에게 서비스를 취소 및/또는 거부할 권리가 있습니다.",
  "PPS_Content_2_iv": "사이트의 정보 및 데이터를 수집하고 사용하기 위한 회사의 목적에는 다음이 포함되나 이에 국한되지 않습니다:",
  "PPS_Content_2_v": "• 사용자에게 제공되는 서비스의 일일 운영을 위한 목적;",
  "PPS_Content_2_vi": "• 구직자가 고용주와 적절한 고용을 찾을 수 있도록 지원하고 고용주가 다양한 직업 및 산업에 대한 구직 지원자의 적합성을 평가하도록 지원하기 위한 목적;",
  "PPS_Content_2_vii": "• 사이트 및/또는 제휴사 및 뉴스레터, 채용 공고 및 홍보 및 마케팅 자료가 제공하는 다양한 서비스를 사용자에게 제공하기 위한 목적(자세한 내용은 아래 '뉴스레터/홍보물/마케팅 자료 구독' 부문을 참조하십시오.);",
  "PPS_Content_2_vii": "• 사용자에게 프로모션 및 마케팅 자료를 제공할 수 있도록 제휴사와 공유하기 위한 목적;",
  "PPS_Content_2_ix": "• 사용자의 문의, 요청 및 불만 사항에 대한 처리 및 후속 조치를 하기 위한 목적;",
  "PPS_Content_2_x": "• 사이트 사용과 관련된 관리 통지 및 통신과 관련하여 사용자에게 연락하고 사용자의 문의 또는 요청에 응답하기 위한 목적;",
  "PPS_Content_2_xi": "• 향후 마케팅 및 홍보 목적 또는 기타 내부 목적을 위한 개발을 위해 회사를 지원하려는 목적;",
  "PPS_Content_2_xii": "• 사이트에 광고, 자료, 표현, 메시지, 조회수 또는 의견 또는 기타 정보(총칭하여 '정보')를 게시한 사용자의 신원을 확인하기 위한 목적;",
  "PPS_Content_2_xiii": "• 사이트에 게시된 정보를 본 사용자를 식별하기 위한 목적;",
  "PPS_Content_2_xiv": "• 사용자가 회사 및/또는 그 계열사 및/또는 파트너 회사가 주최하는 특별 이벤트 및 프로모션에 등록하여 사이트의 회원으로서 혜택을 누릴 수 있도록 허용하기 위한 목적;",
  "PPS_Content_2_xv": "• 마케팅 홍보 자료를 수신하고 사용하여 사이트 회원으로서 혜택을 누린 사용자를 식별하기 위한 목적;;",
  "PPS_Content_2_xvi": "• 회사 및/또는 제휴사의 서비스 제공 및 마케팅 서비스 및/또는 특별 이벤트와 관련된 목적으로 회사 및/또는 제휴사가 사용자의 개인 정보를 사용하는 것을 용이하게 하기 위한 목적;",
  "PPS_Content_2_xvii": "• 내부 사용을 위한 추가 개발을 돕기 위해 사이트의 사용을 분석하기 위해 사용자에 대한 통계를 얻기 위한 목적;",
  "PPS_Content_2_xviii": "• 회사가 적합하다고 판단할 수 있는 제휴사의 제품 및/또는 서비스의 제공 및/또는 마케팅과 관련된 위에서 언급한 목적 이외의 목적",
  "PPS_Content_2_xix": "• 명시된 관련 목적을 위해 사이트에서 제공하는 서비스를 개선하는 데 도움을 주는 목적",
  "PPS_Content_2_xx": "이용자가 13세 미만인 경우 회사는 이용자를 사이트 회원으로 등록하기 위해 '문의' 부문에 명시된 연락처 정보가 있는 책임있는 고객 지원 담당자에게 연락할 수 있는 부모 또는 보호자와 함께 사전에 동의를 구할 것을 강력히 권장합니다.",
  "PPS_Content_2_xxi": "회사는 위에 명시된 목적과 관련하여 필요하고 적절하지만 과도하지 않은 개인 정보만 수집하기 위해 노력합니다.",
  "PPS_Content_2_xxii": "회사가 상기 명시된 목적 이외의 목적으로 귀하의 개인 정보를 사용해야 하는 경우 당사는 귀하의 규정된 동의를 요청할 것입니다. 미성년자인 경우 부모 또는 보호자가 정해진 동의를 해야 합니다.",
  "PPS_Content_3_i": "보안",
  "PPS_Content_3_ii": "사용자의 개인 정보 및 데이터의 보안은 Neufast Group에 중요합니다. Neufast는 사용자의 개인 정보와 데이터가 무단 접근으로부터 보호되도록 항상 노력합니다. 당사는 사용자의 개인 정보와 데이터를 보호하기 위해 적절한 전자적 및 관리적 조치를 시행했습니다.",
  "PPS_Content_3_iii": "사용자가 제공하는 모든 개인 정보 및 데이터는 회사 또는 그 권한을 위임받은 제3자에 의해서만 접근 가능하며 해당 직원은 해당 개인 정보 및 데이터에 접근할 때 본 개인 정보 보호 정책의 조건을 준수하도록 지시받아야 합니다. 사용자는 개인 정보 및 데이터가 수집 목적을 달성하기 위해 필요한 기간 동안만 보관되므로 안심할 수 있습니다. 등록된 사용자는 비밀을 유지하고 기밀을 유지하여 자신의 고유한 사용자 이름과 암호를 보호해야 하며 이러한 세부 정보를 누구와도 공유하지 않아야 합니다.",
  "PPS_Content_3_iv": "회사는 사이트에서 전자 결제 거래를 용이하게 하기 위해 제3자 서비스 제공자를 이용합니다.",
  "PPS_Content_3_v": "회사는 전송 중 및 수신 후 사용자가 사이트에 제출한 개인 정보 및 데이터를 보호하기 위해 일반적으로 인정되는 업계 표준을 따릅니다. 그러나 인터넷을 통한 전송 방법이나 전자 저장 방법은 100% 안전하지 않습니다. 따라서 당사는 무단 접근으로부터 사용자의 개인 정보와 데이터를 보호하기 위해 노력하지만 회사는 절대적인 보안을 보장할 수 없습니다.",
  "PPS_Content_4_i": "사용자 프로필 및 이력서 저장",
  "PPS_Content_4_ii": "고용주와 광고주에게 사용자에 대한 가장 관련성 높은 정보를 제공하기 위해(사이트의 사용자 프로필 개인 정보 보호 설정에 따라) 사이트의 사용자 프로필에 첨부된 기본 이력서도 사이트에서 스캔하며 광고주 데이터베이스에서 관련 콘텐츠를 광고주에게 표시할 수 있습니다. 이력서의 내용을 광고주에게 표시하지 않으려면 이력서를 첨부하지 마십시오.",
  "PPS_Content_5_i": "개인 정보 보유",
  "PPS_Content_5_ii": "Neufast Group이 사용자의 개인 정보 및/또는 데이터를 확보하면 '관행 준칙' 부문에 명시된 대로 정보가 수집된 목적을 달성하는 데 필요한 기간 동안 회사 시스템에서 안전하게 유지됩니다. 일단 등록되면 사용자는 '문의' 부문에 명시된 연락처 정보가 있는 회사의 개인 정보 보호 담당자에게 연락하여 사이트 회원 자격을 해지할 수 있습니다. 회사는 법적 의무를 준수하고 규제 요건을 충족하고 사용자 간의 분쟁을 해결하고 사기 및 남용을 방지하거나 본 개인 정보 보호 정책 및 이용 약관을 시행하기 위해 보존이 합리적으로 필요한 경우 사용자가 계정을 폐쇄한 후에도 사용자의 개인 정보를 보유할 수 있습니다.",
  "PPS_Content_6_i": "개인 정보 보호 정책의 변경",
  "PPS_Content_6_ii": "회사는 회사가 필요하다고 판단하는 경우 언제든지 본 개인 정보 보호 정책을 업데이트, 변경 또는 수정할 권리를 보유하므로 사용자는 본 개인 정보 보호 정책을 자주 검토하는 것이 좋습니다. 회사가 본 개인 정보 보호 정책을 업데이트, 변경 또는 수정하기로 결정하는 경우 회사는 이러한 변경 사항을 사이트 및/또는 회사가 적절하다고 판단하는 다른 장소에 게시하여 사용자가 회사가 수집하는 정보, 정보 사용 방법 및 회사가 정보를 공개하는 상황(있는 경우)을 알 수 있도록 합니다.",
  "PPS_Content_6_iii": "회사가 본 개인 정보 보호 정책을 중대하게 변경하는 경우 당사는 본 웹페이지, 이메일 또는 사이트 홈페이지의 공지사항을 통해 사용자에게 통지합니다. 본 개인 정보 보호 정책의 변경은 회사가 사이트에 동일한 내용을 게시하는 시점부터 적용됩니다. 사용자가 사이트에서 사이트 및 서비스를 계속 사용하는 것은 본 개인 정보 보호 정책의 변경 사항을 수락하는 것으로 간주됩니다.",
  "PPS_Content_7_i": "Cookies 사용",
  "PPS_Content_7_ii": "Cookies는 웹사이트가 사이트에 있는 동안 기록 보관을 위해 개인의 하드 드라이브로 전송하는 정보 항목입니다. Cookies를 사용하면 비밀번호, 구매 및 환경설정을 저장하여 검색을 쉽게 할 수 있습니다. Cookies 사용은 업계 표준이며 대부분의 주요 웹사이트에서 Cookies를 찾을 수 있습니다.",
  "PPS_Content_7_iii": "Cookies 자체는 사용자가 이전에 제출한 개인 식별 정보와 사용자의 서비스 사용을 연결할 수 있지만 개인 식별 정보가 포함되어 있지 않습니다.",
  "PPS_Content_7_iv": "때때로 광고주로부터 Cookies를 받을 수 있습니다. 이러한 Cookies는 제3자의 컴퓨터에서 전송되며 제3자의 정책에 따릅니다. Google Analytics가 이 사이트에 설치되어 방문자의 행동을 파악할 수 있습니다. 광고 분석 기능을 거부하려면 관련 Google 서비스 페이지를 방문하십시오.",
  "PPS_Content_7_v": "대부분의 브라우저는 처음에는 Cookies를 허용하도록 설정되어 있습니다. 위의 정보를 공개하지 않으려면 Cookies를 거부하도록 설정해야 합니다. 그러나 그렇게 하면 사이트의 대부분의 영역이 제대로 작동하지 않을 수 있습니다.",
  "PPS_Content_8_i": "아웃소싱 배열",
  "PPS_Content_8_ii": "회사는 IT 시스템을 개발하고 유지하기 위해 사내 자원을 사용해 왔습니다. 회사가 IT 시스템과 관련된 특정 서비스를 제공하기 위해 제3자 공급업체를 고용하는 경우 공급업체는 통상적인 상황에서 IT 시스템에 저장된 개인 정보에 접근할 수 없습니다.",
  "PPS_Content_8_iii": "공급업체가 접근 권한을 가진 예외적인 경우 회사는 다음을 보장하기 위해 합리적인 조치를 사용합니다: (i) 공급업체는 개인 정보를 기밀로 유지하고 무단 접근, 사용, 손실, 유지, 수정, 전송 또는 기타를 방지하기 위해 적절한 수단을 채택할 계약상의 의무가 있습니다.",
  "PPS_Content_9_i": "문의, 데이터 접근 요청 및 데이터 수정",
  "PPS_Content_9_ii": "PDPO에 따라 개인은 문의를 하고 당사가 보유한 개인 정보에 대한 접근 및 수정을 요청할 권리가 있습니다. POPO의 조건에 따라 당사는 데이터 접근 요청 처리를 위해 합리적인 수수료를 청구할 권리가 있습니다.",
  "PPS_Content_9_iii": "당사가 보유하고 있는 귀하의 개인 정보 조회, 열람, 정정을 원하시면 다음으로 요청해 주십시오:",
  "PPS_Content_9_iv": "개인 정보 담당자",
  "PPS_Content_9_v": "Neufast Limited",
  "PPS_Content_9_vi": "주소: 1032, 10/F, Building 19W, No.19 Science Park Avenue West, Shatin, N.T., Hong Kong",
  "PPS_Content_9_vii": "전화번호: (+852)59876904",
  "PPS_Content_9_viii": "이메일: customer-service@neufast.com",
  "PPS_Content_10_i": "권리 제한 없음",
  "PPS_Content_10_ii": "이 준칙의 어떠한 내용도 개인 정보(개인 정보 보호) 조례(PDPO)에 따른 정보 주체의 권리를 제한하지 않습니다.",

  "Africa/Cote_d'Ivoire": "아프리카/코트디부아르",
  "Africa/Ghana": "아프리카/가나",
  "Africa/Addis_Ethiopia": "아프리카/아디스 에티오피아",
  "Africa/Algeria": "아프리카/알제리",
  "Africa/Eritrea": "아프리카/에리트레아",
  "Africa/Mali": "아프리카/말리",
  "Africa/Central_African_Republic": "아프리카/중앙아프리카공화국",
  "Africa/Gambia": "아프리카/감비아",
  "Africa/Guinea-Bissau": "아프리카/기니비사우",
  "Africa/Malawi": "아프리카/말라위",
  "Africa/Republic_of_Congo": "아프리카/콩고 공화국",
  "Africa/Democratic Republic of Congo/West Time": "아프리카/콩고 민주 공화국/서부 시간",
  "Africa/Democratic Republic of Congo/Eastern Time": "아프리카/콩고 민주 공화국/동부 시간",
  "Africa/Burundi": "아프리카/부룬디",
  "Africa/Egypt": "아프리카/이집트",
  "Africa/Morocco": "아프리카/모로코",
  "Atlantic/Canary_Islands": "대서양/카나리아 제도",
  "Africa/Guinea": "아프리카/기니",
  "Africa/Senegal": "아프리카/세네갈",
  "Africa/United_Republic_of_Tanzania": "아프리카/유나이티드 공화국 탄자니아",
  "Africa/Djibouti": "아프리카/지부티",
  "Africa/Cameroon": "아프리카/카메룬",
  "Africa/Western_Sahara": "아프리카/서사하라",
  "Africa/Sierra_Leone": "아프리카/시에라리온",
  "Africa/Botswana": "아프리카/보츠와나",
  "Africa/Zimbabwe": "아프리카/짐바브웨",
  "Africa/South_Africa": "아프리카/남아프리카",
  "Africa/South_Sudan": "아프리카/남 수단",
  "Africa/Uganda": "아프리카/우간다",
  "Africa/Sudan": "아프리카/수단",
  "Africa/Rwanda": "아프리카/르완다",
  "Africa/Nigeria": "아프리카/나이지리아",
  "Africa/Gabon": "아프리카/가봉",
  "Africa/Togo": "아프리카/토고",
  "Africa/Angola": "아프리카/앙골라",
  "Africa/Zambia": "아프리카/잠비아",
  "Africa/Equatorial_Guinea": "아프리카/적도 기니",
  "Africa/Mozambique": "아프리카/모잠비크",
  "Africa/Lesotho": "아프리카/레소토",
  "Africa/Swaziland": "아프리카/스와질란드",
  "Africa/Somalia": "아프리카/소말리아",
  "Africa/Liberia": "아프리카/라이베리아",
  "Africa/Kenya": "아프리카/케냐",
  "Africa/Chad": "아프리카/차드",
  "Africa/Niger": "아프리카/니제르",
  "Africa/Mauritania": "아프리카/모리타니",
  "Africa/Burkina_Faso": "아프리카/부르키나파소",
  "Africa/Benin": "아프리카/베냉",
  "Africa/Sao_Tome_and_Principe": "아프리카/상투메 프린시페",
  "Africa/Libya": "아프리카/리비아",
  "Africa/Tunisia": "아프리카/튀니지",
  "Africa/Namibia": "아프리카/나미비아",
  "America/Hawaii-Aleutian Standard Time": "아메리카/하와이 알류샨 표준시",
  "America/Hawaii-Aleutian Daylight Time": "아메리카/하와이 알류샨 일광 절약 시간",
  "America/Alaska Standard Time": "아메리카/알래스카 표준시",
  "America/Alaska Daylight Time": "아메리카/알래스카 일광 절약 시간",
  "America/Mountain Standard Time": "아메리카/산악 표준시",
  "America/Mountain Daylight Time": "아메리카/산악 일광 절약 시간",
  "America/Central Standard Time": "아메리카/중부 표준시",
  "America/Central Daylight Time": "아메리카/중부 일광 절약 시간",
  "America/Pacific Standard Time": "아메리카/태평양 표준시",
  "America/Pacific Daylight Time": "아메리카/태평양 일광 절약 시간",
  "America/Eastern Standard Time": "아메리카/동부 표준시",
  "America/Eastern Daylight Time": "아메리카/동부 일광 절약 시간",
  "America/Newfoundland Standard Time": "아메리카/뉴펀들랜드 표준시",
  "America/Newfoundland Daylight Time": "아메리카/뉴펀들랜드 일광 절약 시간",
  "America/Atlantic Standard Time": "아메리카/대서양 표준시",
  "America/Atlantic Daylight Time": "아메리카/대서양 일광 절약 시간",
  "America/Brazil/Acre Standard Time": "아메리카/브라질/에이커 표준시",
  "America/Brazil/Amazon Standard Time": "아메리카/브라질/아마존 표준시",
  "America/Brazil/Brasilia Standard Time": "아메리카/브라질/브라질리아 표준시",
  "America/Brazil/Fernando de Noronha Standard Time": "아메리카/브라질/페르난도 데 노로냐 표준시",
  "America/West Greenland Time": "아메리카/서부 그린란드 시간",
  "America/East Greenland Time": "아메리카/동부 그린란드 시간",
  "America/Anguilla": "아메리카/앵귈라",
  "America/Antigua_and_Barbuda": "아메리카/앤티가 바부다",
  "America/Argentina": "아메리카/아르헨티나",
  "America/Aruba": "아메리카/아루바",
  "America/Paraguay": "아메리카/파라과이",
  "America/Barbados": "아메리카/바베이도스",
  "America/Belize": "아메리카/벨리즈",
  "America/Colombia": "아메리카/콜롬비아",
  "America/Bolivarian_Republic_of_Venezuela": "아메리카/베네수엘라 볼리바리안 공화국",
  "America/French_Guiana": "아메리카/프랑스령 기아나",
  "America/Cayman_Islands": "아메리카/케이맨 제도",
  "America/Costa_Rica": "아메리카/코스타리카",
  "America/Curacao": "아메리카/쿠라카오",
  "America/Dominica": "아메리카/도미니카",
  "America/El_Salvador": "아메리카/엘살바도르",
  "America/Turks_and_Caicos_Islands": "아메리카/터크스케이커스 제도",
  "America/Grenada": "아메리카/그레나다",
  "America/Guadeloupe": "아메리카/과들루프",
  "America/Guatemala": "아메리카/과테말라",
  "America/Ecuador/Galapagos Time": "아메리카/에콰도르/갈라파고스 시간",
  "America/Ecuador Time": "아메리카/에콰도르 시간",
  "America/Guyana": "아메리카/가이아나",
  "America/Cuba": "아메리카/쿠바",
  "America/Jamaica": "아메리카/자메이카",
  "America/Sint_Eustatius_and_Saba_Bonaire": "아메리카/신트 유스타티우스 및 사바 보네르",
  "America/Bolivia": "아메리카/볼리비아",
  "America/Peru": "아메리카/페루",
  "America/Sint_Maarten": "아메리카/신트마르턴",
  "America/Nicaragua": "아메리카/니카라과",
  "America/Saint_Martin": "아메리카/세인트 마틴",
  "America/Martinique": "아메리카/마르티니크",
  "America/Saint_Pierre_and_Miquelon": "아메리카/생 피에르 미클롱",
  "America/Uruguay": "아메리카/우루과이",
  "America/Montserrat": "아메리카/몬트세랫",
  "America/Bahamas": "아메리카/바하마",
  "America/Panama": "아메리카/파나마",
  "America/Suriname": "아메리카/수리남",
  "America/Haiti": "아메리카/아이티",
  "America/Trinidad_and_Tobago": "아메리카/트리니다드토바고",
  "America/Puerto_Rico": "아메리카/푸에르토리코",
  "America/Easter Island Standard Time": "아메리카/이스터 섬 표준시",
  "America/Chile Standard Time": "아메리카/칠레 표준시",
  "America/Chile Summer Time": "아메리카/칠레 서머 타임",
  "America/Dominican_Republic": "아메리카/도미니카 공화국",
  "America/St_Barthelemy": "아메리카/세인트 바텔레미",
  "America/St_Kitts_and_Nevis": "아메리카/세인트키츠 네비스",
  "America/St_Lucia": "아메리카/세인트 루시아",
  "America/US_Virgin_Islands": "아메리카/미국 버진아일랜드",
  "America/St_Vincent_and_Grenadines": "아메리카/세인트빈센트 그레나딘",
  "America/Honduras": "아메리카/온두라스",
  "America/British_Virgin_Islands": "미국/영국령 버진아일랜드",
  "Asia/Yemen": "아시아/예멘",
  "Asia/Kazakhstan/East Time": "아시아/카자흐스탄/동부 표준시",
  "Asia/Kazakhstan/West Time": "아시아/카자흐스탄/서부 표준시",
  "Asia/Jordan": "아시아/요르단",
  "Asia/Turkmenistan": "아시아/투르크메니스탄",
  "Asia/Iraq": "아시아/이라크",
  "Asia/Bahrain": "아시아/바레인",
  "Asia/Azerbaijan": "아시아/아제르바이잔",
  "Asia/Thailand": "아시아/태국",
  "Asia/Lebanon": "아시아/레바논",
  "Asia/Kyrgyzstan": "아시아/키르기스스탄",
  "Asia/Brunei_Darussalam": "아시아/브루나이 다루살람",
  "Asia/Mongolia/Choibalsan Time": "아시아/몽골/초이발산 시간",
  "Asia/Mongolia/Ulaanbaatar Time": "아시아/몽골/울란바토르 시간",
  "Asia/Mongolia/Hovd Time": "아시아/몽골/호브드 시간",
  "Asia/China Standard Time": "아시아/중국 표준시",
  "Asia/Sri_Lanka": "아시아/스리랑카",
  "Asia/Syrian_Arab_Republic": "아시아/시리아 아랍 공화국",
  "Asia/Bangladesh": "아시아/방글라데시",
  "Asia/Timor-Leste": "아시아/티모르",
  "Asia/UAE": "아시아/아랍 에미리트 연합국",
  "Asia/Tajikistan": "아시아/타지키스탄",
  "Asia/Cyprus": "아시아/키프로스",
  "Asia/Palestine": "아시아/팔레스타인",
  "Asia/Vietnam": "아시아/베트남",
  "Asia/Hong_Kong": "아시아/홍콩",
  "Asia/Russia/Irkutsk_Time": "아시아/러시아/이르쿠츠크 시간",
  "Asia/Russia/Kamchatka_Time": "아시아/러시아/캄차카 시간",
  "Asia/Russia/Krasnoyarsk_Time": "아시아/러시아/크라스노야르스크 시간",
  "Asia/Russia/Magadan_Time": "아시아/러시아/마가단 시간",
  "Asia/Russia/Omsk_Time": "아시아/러시아/옴스크 시간",
  "Asia/Russia/Vladivostok_Time": "아시아/러시아/블라디보스토크 시간",
  "Asia/Russia/Yakutsk_Time": "아시아/러시아/야쿠츠크 시간",
  "Asia/Russia/Yekaterinburg_Time": "아시아/러시아/예카테린부르크 시간",
  "Asia/Turkey": "아시아/터키",
  "Asia/Indonesian/Western Time": "아시아/인도네시아/서부 표준시",
  "Asia/Indonesian/Central Time": "아시아/인도네시아/중부 표준시",
  "Asia/Indonesian/Eastern Time": "아시아/인도네시아/동부 표준시",
  "Asia/Israel": "아시아/이스라엘",
  "Asia/Afghanistan": "아시아/아프가니스탄",
  "Asia/Pakistan": "아시아/파키스탄",
  "Asia/Nepal": "아시아/네팔",
  "Asia/India": "아시아/인도",
  "Asia/Malaysia": "아시아/말레이시아",
  "Asia/Kuwait": "아시아/쿠웨이트",
  "Asia/Macau": "아시아/마카오",
  "Asia/Philippines": "아시아/필리핀",
  "Asia/Oman": "아시아/오만",
  "Asia/Cambodia": "아시아/캄보디아",
  "Asia/North_Korea": "아시아/북한",
  "Asia/Qatar": "아시아/카타르",
  "Asia/Saudi_Arabia": "아시아/사우디아라비아",
  "Asia/Uzbekistan": "아시아/우즈베키스탄",
  "Asia/South_Korea": "아시아/대한민국",
  "Asia/Singapore": "아시아/싱가포르",
  "Asia/Taiwan": "아시아/대만",
  "Asia/Georgia": "아시아/조지아",
  "Asia/Iran": "아시아/이란",
  "Asia/Bhutan": "아시아/부탄",
  "Asia/Japan": "아시아/일본",
  "Asia/Laos": "아시아/라오스",
  "Asia/Myanmar": "아시아/미얀마",
  "Asia/Armenia": "아시아/아르메니아",
  "Europe/Netherlands": "유럽/네덜란드",
  "Europe/Andorra": "유럽/안도라",
  "Europe/Greece": "유럽/그리스",
  "Europe/Serbia": "유럽/세르비아",
  "Europe/Germany": "유럽/독일",
  "Europe/Slovakia": "유럽/슬로바키아",
  "Europe/Belgium": "유럽/벨기에",
  "Europe/Romania": "유럽/루마니아",
  "Europe/Hungary": "유럽/헝가리",
  "Europe/Moldova": "유럽/몰도바",
  "Europe/Denmark": "유럽/덴마크",
  "Europe/Ireland": "유럽/아일랜드",
  "Europe/Gibraltar": "유럽/지브롤터",
  "Europe/Guernsey": "유럽/건지",
  "Europe/Finland": "유럽/핀란드",
  "Europe/Isle_of_Man": "유럽/맨 섬",
  "Europe/Turkey": "유럽/터키",
  "Europe/Jersey": "유럽/저지",
  "Europe/Russia/Kaliningrad_Time": "유럽/러시아/칼리닌그라드 시간",
  "Europe/Russia/Moscow_Time": "유럽/러시아/모스크바 시간",
  "Europe/Russia/Samara_Time": "유럽/러시아/사마라 시간",
  "Europe/Ukraine": "유럽/우크라이나",
  "Europe/Portugal": "유럽/포르투갈",
  "Atlantic/Portugal/Azores": "대서양/포르투갈/아조레스",
  "Europe/Slovenia": "유럽/슬로베니아",
  "Europe/United_Kingdom": "유럽/영국",
  "Europe/Luxembourg": "유럽/룩셈부르크",
  "Europe/Spain": "유럽/스페인",
  "Europe/Malta": "유럽/몰타",
  "Europe/Åland_Islands": "유럽/올란드 제도",
  "Europe/Belarus": "유럽/벨라루스",
  "Europe/France": "유럽/프랑스",
  "Europe/Cyprus": "유럽/키프로스",
  "Europe/Norway": "유럽/노르웨이",
  "Europe/Montenegro": "유럽/몬테네그로",
  "Europe/Czech_Republic": "유럽/체코",
  "Europe/Latvia": "유럽/라트비아",
  "Europe/Italy": "유럽/이탈리아",
  "Europe/San_Marino": "유럽/산마리노",
  "Europe/Bosnia_and_Herzegovina": "유럽/보스니아 헤르체고비나",
  "Europe/Macedonia": "유럽/마케도니아",
  "Europe/Bulgaria": "유럽/불가리아",
  "Europe/Sweden": "유럽/스웨덴",
  "Europe/Estonia": "유럽/에스토니아",
  "Europe/Albania": "유럽/알바니아",
  "Europe/Moldova": "유럽/몰도바",
  "Europe/Liechtenstein": "유럽/리히텐슈타인",
  "Europe/Holy_See_Vatican": "유럽/바티칸",
  "Europe/Austria": "유럽/오스트리아",
  "Europe/Lithuania": "유럽/리투아니아",
  "Europe/Poland": "유럽/폴란드",
  "Europe/Croatia": "유럽/크로아티아",
  "Europe/Switzerland": "유럽/스위스",
  "Europe/Iceland": "유럽/아이슬란드",
  "Oceania/Australia/Western Standard Time": "오세아니아/호주/서부 표준시",
  "Oceania/Australia/Central Western Standard Time": "오세아니아/호주/중서부 표준시",
  "Oceania/Australia/Central Standard Time": "오세아니아/호주/중부 표준시",
  "Oceania/Australia/Eastern Standard Time": "오세아니아/호주/동부 표준시",
  "Oceania/Australia/Lord Howe Standard Time": "오세아니아/호주/로드 하우 표준시",
  "Oceania/New_Zealand": "오세아니아/뉴질랜드",
  "Oceania/New_Zealand/Chatham Island": "오세아니아/뉴질랜드/채텀 섬",
  "Admin_Auto_Email_opening_title": "Neufast 채용 담당자 계정 개설",
  "Admin_Auto_Email_add_quota_title": "Neufast 면접 할당량 추가",
  "Admin_Auto_Email_suspension_title": "Neufast 채용 담당자 계정 정지",
  "Admin_Auto_Email_reactivation_title": "Neufast 채용 담당자 계정 재활성화",
  "Admin_Auto_Email_out_of_quota_title": "Neufast 채용 담당자 계정 – 할당량 초과 경고",
  "Admin_Auto_Email_low_quota_title": "Neufast 채용자 계정 - 낮은 할당량 수준 경고",
  "Admin_Auto_Email_return_quota_title": "Neufast 면접 할당량 반환",
  "Admin_Auto_Email_opening_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">친애하는 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">귀하의 Neufast 채용 담당자 계정에 대한 로그인 정보는 다음과 같습니다.:</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">웹사이트:</span> <a href="https://apisit.neufast.com/" target="_blank"><span style="color: blue;font-size: medium;font-family: Times New Roman", serif;">apisit.neufast.com</span></a></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">로그인: {{Login email, don’t change}}</span>&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">비밀번호: {{Login password, don’t change}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">면접 할당량 수: {{Number of interview quota}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">최신 Chrome 브라우저 (89 또는 90버전) 또는 Firefox를 사용하여 접속하십시오. 사용자 가이드는 참고를 위해 여기에 첨부되어 있습니다.</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">궁금한 점이 있으시면 언제든지 문의해 주십시오. 감사합니다!</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">감사합니다,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">Neufast 고객 서비스 팀</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">이메일: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">전화번호: (+852) 59876904</span></p>',
  "Admin_Auto_Email_add_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">친애하는 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">채용 담당자 계정에 다음과 같은 면접 할당량이 추가되었습니다.</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">추가된 면접 할당량 수: {{Number of interview quota added}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">면접 할당량 잔액: {{Number of interview quota balance}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">궁금한 점이 있으시면 언제든지 문의해 주십시오. 감사합니다!</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">감사합니다,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">Neufast 고객 서비스 팀</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">이메일: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">전화번호: (+852) 59876904</span></p>',
  "Admin_Auto_Email_suspension_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">친애하는 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;"> 채용 담당자 계정이 정지되었습니다.</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">궁금한 점이 있으시면 언제든지 문의해 주십시오. 감사합니다!</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">감사합니다,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">Neufast 고객 서비스 팀</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">이메일: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">전화번호: (+852) 59876904</span></p>',
  "Admin_Auto_Email_reactivation_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">친애하는 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">채용 담당자 계정이 재활성화되었습니다.</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">궁금한 점이 있으시면 언제든지 문의해 주십시오. 감사합니다!</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">감사합니다,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">Neufast 고객 서비스 팀</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">이메일: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">전화번호: (+852) 59876904</span></p>',
  "Admin_Auto_Email_out_of_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">친애하는 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">채용 담당자 계정의 잔액이 0으로 떨어졌습니다. 중단 없이 지속적인 면접 서비스를 보장하기 위해 더 많은 면접 할당량을 구매하려면 당사에 문의하십시오.</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">궁금한 점이 있으시면 언제든지 문의해 주십시오. 감사합니다!</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">감사합니다,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">Neufast 고객 서비스 팀</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">이메일: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">전화번호: (+852) 59876904</span></p>',
  "Admin_Auto_Email_low_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">친애하는 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">채용 담당자 계정의 잔액이 5로 떨어졌습니다. 중단 없이 지속적인 면접 서비스를 보장하기 위해 더 많은 면접 할당량을 구매하려면 당사에 문의하십시오.</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">궁금한 점이 있으시면 언제든지 문의해 주십시오. 감사합니다!</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">감사합니다,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">Neufast 고객 서비스 팀</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">이메일: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">전화번호: (+852) 59876904</span></p>',
  "Admin_Auto_Email_return_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">친애하는 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">채용 담당자 계정에 다음과 같은 면접 할당량이 추가되었습니다.</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">감소된 면접 할당량 수: {{Number of interview quota added}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">면접 할당량 잔액: {{Number of interview quota balance}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;"> 궁금한 점이 있으시면 언제든지 문의해 주십시오. 감사합니다!</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">감사합니다,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">Neufast 고객 서비스 팀</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">이메일: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">전화번호: (+852) 59876904</span></p>',
  "Sap_status_update_fail": "상태 업데이트 실패",
  "Recruiter_Candidate_Result_Invalid_Identity": "채용 담당자 계정은 이 지원자의 정보를 볼 권한이 없습니다. 올바른 계정을 사용하십시오.",
  "Sap_videolink_welcome_message": "지원자의 면접 분석을 열려면 로그인 정보를 입력하십시오",
  "PDF_Bulk_download_title":"PDF 대량 다운로드 상태",
  "PDF_Bulk_download_content":"다음 후보자의 보고서는 다운로드할 수 없습니다.",
  "PDF_Bulk_download_status":"상태",
  "PDF_Bulk_download_fail":"실패하다",
  "PDF_Bulk_download_reason":"준비되지 않은 보고서",
  "Candidate_CandidateProfile_With_CV_OPTION" : "I have a resume",
  "Candidate_CandidateProfile_Without_CV_OPTION" : "I don't have a resume",
  "Candidate_CandidateProfile_WorkExperience_SubTitle" : "Work Experience",
  "Candidate_CandidateProfile_Education_SubTitle" : "Education",
  "Candidate_CandidateProfile_Confirm_Title" : "Resume Upload Confirmation", 
  "Candidate_CandidateProfile_Confirm_Content" : "Please make sure all filled information is correct, you will not be allowed to modify once you click the CONFIRM button below.", 
  "Candidate_CandidateProfile_Validation_Error_Msg" : "there are some errors in the filled fields, please check again.",
  "Recruiter_CandidateProfile_Languages_Title": "Languages",
  "Recruiter_CandidateProfile_Upload_Title" : "Before the interview, please upload your resume",
  "Candidate_CandidateProfile_Action_Upload" : "Submit",
  "Recruiter_Layout_ShowConsent" : "맞춤형 사용자 계약 추가",
  "Recruiter_Layout_ShowConsent_Tooltip" : "이를 통해 후보자에 대한 맞춤형 사용자 동의가 가능합니다.",
  "Recruiter_Layout_ShowConsent_Default_Message" : "<p>이것은 사용자 계약입니다</p>",
  "Recruiter_Layout_ShowConsent_Title" : "계약 내용",
  "Candidate_Consent_Form_Title" : "사용자 계약",
  "Candidate_Consent_Form_Checkbox_Content" : "이용약관을 읽었으며 이에 동의합니다",
  "Candidate_Consent_Form_Confirmation_Title" : "확인하다",
  "Candidate_Consent_Form_Confirmation_Content" : "확인 을 클릭하면 철회를 위해 당사에 연락해야 하므로 동의 여부를 확인하십시오.",
  "Candidate_Consent_Form_Non_Latest_Message" : "이전 버전의 사용자 계약을 확인하고 있습니다. 새로 고침하고 다시 시도하십시오.",
  "Candidate_Consent_Form_No_Consent_ID" : "이 사용자 계약은 데이터베이스에 없습니다. 새로고침하고 다시 시도하십시오.",

  "Do_you_confirm_your_interview_language": "Do you confirm your interview language?",
  "You_selected": "You selected:",
  "You_can_not_change_it_once_you_click_confirm": "*You can not change it once you click confirm",
  "Cancel": "Cancel",
  "Confirm": "Confirm",
  "Candidate_Consent_Form_Non_Latest_Message" : "이전 버전의 동의를 확인하고 있습니다. 새로고침하고 다시 시도하세요.",
  "Candidate_Consent_Form_No_Consent_ID" : "이 동의는 데이터베이스에 없습니다. 새로고침하고 다시 시도하세요.",
  "SESSION_TIMEOUT_TITLE" : "Session Timeout",
  "SESSION_TIMEOUT_CONTENT": "You're being timed out due to inactivity. Please choose to stay signed in or to logoff. Otherwise, you will be logged out automatically in {remaining} seconds.",
  "SESSION_STAY_LOGGED_IN": "Stay Logged In",
  "SESSION_LOGOUT": "Logout",
  "Session_Management_Title" : "Session Management",
}
